import React, {Component, KeyboardEvent} from "react"
import styles from "./SignUp.module.css"
import {LoginWrapper} from "components/LoginWrapper"
import {Button} from "pages/sign-in/parts/Button"
import {Label} from "components/inputs/Label"
import {Input} from "components/inputs/input"
import {KlassDropdown} from "components/inputs/KlassDropdown"
import {Captcha} from "components/Captcha"
import {observer} from "mobx-react"
import {observable, toJS} from "mobx"
import {Authorisation} from "models/Authorisation"
import {Link} from "react-router-dom"
import {
    CHECK_PASSWORD_OPTIONS,
    findErrors,
    findPasswordErrors
} from "../../lib/functions/findErrors"
import {Model} from "Model"
import {LabelPassword} from "components/inputs/LabelPassword"
import {DELIMITER, getPartsByDelimiter} from "lib/functions/helper"
import Swal from "sweetalert2"

interface Props {
    auth: Authorisation
    model: Model
}

export interface SignUpUser {
    otp?
    first_name?
    middle_name?
    last_name?
    email?
    password?
    confirm_password?
    json_data: {
        address?: string
        country?: string
        city?: string
        state?: string
        zip?: string
        preferred_contact_time?: "morning" | "noon" | "evening"
        phone_number?: string
        how_attend?: string
        previously_applied?: "Yes" | "No"
        crm_id?
        rep_code?
        lead_source?
        about_us: string
        about_us_text?: string
    }
    captcha_value?: string
}

const options1 = [
    {label: "Morning", value: "morning"},
    {label: "Noon", value: "noon"},
    {label: "Evening", value: "evening"}
]

const countries = [
    {
        countryId: 89,
        code: "US",
        label: "United States",
        value: "United States",
        states: [
            {
                stateId: 34,
                label: "Alabama",
                value: "Alabama",
                countryId: 89
            },
            {
                stateId: 38,
                label: "Alaska",
                value: "Alaska",
                countryId: 89
            },
            {
                stateId: 72,
                label: "Arizona",
                value: "Arizona",
                countryId: 89
            },
            {
                stateId: 73,
                label: "Arkansas",
                value: "Arkansas",
                countryId: 89
            },
            {
                stateId: 192,
                label: "California",
                value: "California",
                countryId: 89
            },
            {
                stateId: 277,
                label: "Colorado",
                value: "Colorado",
                countryId: 89
            },
            {
                stateId: 281,
                label: "Connecticut",
                value: "Connecticut",
                countryId: 89
            },
            {
                stateId: 306,
                label: "Delaware",
                value: "Delaware",
                countryId: 89
            },
            {
                stateId: 336,
                label: "District of Columbia",
                value: "District of Columbia",
                countryId: 89
            },
            {
                stateId: 392,
                label: "Florida",
                value: "Florida",
                countryId: 89
            },
            {
                stateId: 409,
                label: "Georgia",
                value: "Georgia",
                countryId: 89
            },
            {
                stateId: 467,
                label: "Hawaii",
                value: "Hawaii",
                countryId: 89
            },
            {
                stateId: 491,
                label: "Idaho",
                value: "Idaho",
                countryId: 89
            },
            {
                stateId: 513,
                label: "Illinois",
                value: "Illinois",
                countryId: 89
            },
            {
                stateId: 520,
                label: "Indiana",
                value: "Indiana",
                countryId: 89
            },
            {
                stateId: 521,
                label: "Iowa",
                value: "Iowa",
                countryId: 89
            },
            {
                stateId: 574,
                label: "Kansas",
                value: "Kansas",
                countryId: 89
            },
            {
                stateId: 609,
                label: "Kentucky",
                value: "Kentucky",
                countryId: 89
            },
            {
                stateId: 702,
                label: "Louisiana",
                value: "Louisiana",
                countryId: 89
            },
            {
                stateId: 724,
                label: "Maine",
                value: "Maine",
                countryId: 89
            },
            {
                stateId: 746,
                label: "Maryland",
                value: "Maryland",
                countryId: 89
            },
            {
                stateId: 749,
                label: "Massachusetts",
                value: "Massachusetts",
                countryId: 89
            },
            {
                stateId: 772,
                label: "Michigan",
                value: "Michigan",
                countryId: 89
            },
            {
                stateId: 778,
                label: "Minnesota",
                value: "Minnesota",
                countryId: 89
            },
            {
                stateId: 782,
                label: "Mississippi",
                value: "Mississippi",
                countryId: 89
            },
            {
                stateId: 783,
                label: "Missouri",
                value: "Missouri",
                countryId: 89
            },
            {
                stateId: 792,
                label: "Montana",
                value: "Montana",
                countryId: 89
            },
            {
                stateId: 829,
                label: "Nebraska",
                value: "Nebraska",
                countryId: 89
            },
            {
                stateId: 836,
                label: "Nevada",
                value: "Nevada",
                countryId: 89
            },
            {
                stateId: 839,
                label: "New Hampshire",
                value: "New Hampshire",
                countryId: 89
            },
            {
                stateId: 840,
                label: "New Jersey",
                value: "New Jersey",
                countryId: 89
            },
            {
                stateId: 841,
                label: "New Mexico",
                value: "New Mexico",
                countryId: 89
            },
            {
                stateId: 843,
                label: "New York",
                value: "New York",
                countryId: 89
            },
            {
                stateId: 864,
                label: "North Carolina",
                value: "North Carolina",
                countryId: 89
            },
            {
                stateId: 866,
                label: "North Dakota",
                value: "North Dakota",
                countryId: 89
            },
            {
                stateId: 890,
                label: "Ohio",
                value: "Ohio",
                countryId: 89
            },
            {
                stateId: 894,
                label: "Oklahoma",
                value: "Oklahoma",
                countryId: 89
            },
            {
                stateId: 905,
                label: "Oregon",
                value: "Oregon",
                countryId: 89
            },
            {
                stateId: 941,
                label: "Pennsylvania",
                value: "Pennsylvania",
                countryId: 89
            },
            {
                stateId: 1047,
                label: "Rhode Island",
                value: "Rhode Island",
                countryId: 89
            },
            {
                stateId: 1195,
                label: "South Carolina",
                value: "South Carolina",
                countryId: 89
            },
            {
                stateId: 1196,
                label: "South Dakota",
                value: "South Dakota",
                countryId: 89
            },
            {
                stateId: 1257,
                label: "Tennessee",
                value: "Tennessee",
                countryId: 89
            },
            {
                stateId: 1261,
                label: "Texas",
                value: "Texas",
                countryId: 89
            },
            {
                stateId: 1317,
                label: "Utah",
                value: "Utah",
                countryId: 89
            },
            {
                stateId: 1352,
                label: "Vermont",
                value: "Vermont",
                countryId: 89
            },
            {
                stateId: 1371,
                label: "Virginia",
                value: "Virginia",
                countryId: 89
            },
            {
                stateId: 1388,
                label: "Washington",
                value: "Washington",
                countryId: 89
            },
            {
                stateId: 1393,
                label: "West Virginia",
                value: "West Virginia",
                countryId: 89
            },
            {
                stateId: 1398,
                label: "Wisconsin",
                value: "Wisconsin",
                countryId: 89
            },
            {
                stateId: 1399,
                label: "Wyoming",
                value: "Wyoming",
                countryId: 89
            }
        ]
    },
    {
        countryId: 93,
        code: "AF",
        label: "Afghanistan",
        value: "Afghanistan",
        states: [
            {
                stateId: 1570,
                label: "Kabul",
                value: "Kabul",
                countryId: 93
            }
        ]
    },
    {
        countryId: 2,
        code: "AX",
        label: "Aland Islands",
        value: "Aland Islands",
        states: [
            {
                stateId: 36,
                label: "Ålands landsbygd",
                value: "Ålands landsbygd",
                countryId: 2
            },
            {
                stateId: 37,
                label: "Ålands skärgård",
                value: "Ålands skärgård",
                countryId: 2
            },
            {
                stateId: 739,
                label: "Mariehamns stad",
                value: "Mariehamns stad",
                countryId: 2
            }
        ]
    },
    {
        countryId: 95,
        code: "AL",
        label: "Albania",
        value: "Albania",
        states: [
            {
                stateId: 1571,
                label: "Tirana",
                value: "Tirana",
                countryId: 95
            }
        ]
    },
    {
        countryId: 3,
        code: "DZ",
        label: "Algeria",
        value: "Algeria",
        states: [
            {
                stateId: 11,
                label: "Adrar",
                value: "Adrar",
                countryId: 3
            },
            {
                stateId: 26,
                label: "Ain-Defla",
                value: "Ain-Defla",
                countryId: 3
            },
            {
                stateId: 27,
                label: "Ain-Temouchent",
                value: "Ain-Temouchent",
                countryId: 3
            },
            {
                stateId: 41,
                label: "Alger",
                value: "Alger",
                countryId: 3
            },
            {
                stateId: 60,
                label: "Annaba",
                value: "Annaba",
                countryId: 3
            },
            {
                stateId: 121,
                label: "Batna",
                value: "Batna",
                countryId: 3
            },
            {
                stateId: 127,
                label: "Bechar",
                value: "Bechar",
                countryId: 3
            },
            {
                stateId: 129,
                label: "Bejaia",
                value: "Bejaia",
                countryId: 3
            },
            {
                stateId: 142,
                label: "Biskra",
                value: "Biskra",
                countryId: 3
            },
            {
                stateId: 147,
                label: "Blida",
                value: "Blida",
                countryId: 3
            },
            {
                stateId: 151,
                label: "Bordj-Bou-Arreridj",
                value: "Bordj-Bou-Arreridj",
                countryId: 3
            },
            {
                stateId: 156,
                label: "Bouira",
                value: "Bouira",
                countryId: 3
            },
            {
                stateId: 157,
                label: "Boumerdes",
                value: "Boumerdes",
                countryId: 3
            },
            {
                stateId: 257,
                label: "Chlef",
                value: "Chlef",
                countryId: 3
            },
            {
                stateId: 283,
                label: "Constantine",
                value: "Constantine",
                countryId: 3
            },
            {
                stateId: 340,
                label: "Djelfa",
                value: "Djelfa",
                countryId: 3
            },
            {
                stateId: 363,
                label: "El-Bayadh",
                value: "El-Bayadh",
                countryId: 3
            },
            {
                stateId: 364,
                label: "El-Oued",
                value: "El-Oued",
                countryId: 3
            },
            {
                stateId: 365,
                label: "El-Taref",
                value: "El-Taref",
                countryId: 3
            },
            {
                stateId: 410,
                label: "Ghardaia",
                value: "Ghardaia",
                countryId: 3
            },
            {
                stateId: 443,
                label: "Guelma",
                value: "Guelma",
                countryId: 3
            },
            {
                stateId: 514,
                label: "Illizi",
                value: "Illizi",
                countryId: 3
            },
            {
                stateId: 555,
                label: "Jijel",
                value: "Jijel",
                countryId: 3
            },
            {
                stateId: 612,
                label: "Khenchela",
                value: "Khenchela",
                countryId: 3
            },
            {
                stateId: 662,
                label: "L.Aghouat",
                value: "L.Aghouat",
                countryId: 3
            },
            {
                stateId: 714,
                label: "M'Sila",
                value: "M'Sila",
                countryId: 3
            },
            {
                stateId: 748,
                label: "Mascara",
                value: "Mascara",
                countryId: 3
            },
            {
                stateId: 759,
                label: "Medea",
                value: "Medea",
                countryId: 3
            },
            {
                stateId: 775,
                label: "Mila",
                value: "Mila",
                countryId: 3
            },
            {
                stateId: 797,
                label: "Mostaganem",
                value: "Mostaganem",
                countryId: 3
            },
            {
                stateId: 808,
                label: "Naama",
                value: "Naama",
                countryId: 3
            },
            {
                stateId: 901,
                label: "Oran",
                value: "Oran",
                countryId: 3
            },
            {
                stateId: 916,
                label: "Ouargla",
                value: "Ouargla",
                countryId: 3
            },
            {
                stateId: 917,
                label: "Oum-El-Bouaghi",
                value: "Oum-El-Bouaghi",
                countryId: 3
            },
            {
                stateId: 1040,
                label: "Relizane",
                value: "Relizane",
                countryId: 3
            },
            {
                stateId: 1089,
                label: "Saida",
                value: "Saida",
                countryId: 3
            },
            {
                stateId: 1153,
                label: "Setif",
                value: "Setif",
                countryId: 3
            },
            {
                stateId: 1163,
                label: "Sidi-Bel-Abbes",
                value: "Sidi-Bel-Abbes",
                countryId: 3
            },
            {
                stateId: 1178,
                label: "Skikda",
                value: "Skikda",
                countryId: 3
            },
            {
                stateId: 1193,
                label: "Souk-Ahras",
                value: "Souk-Ahras",
                countryId: 3
            },
            {
                stateId: 1237,
                label: "Tamanrasset",
                value: "Tamanrasset",
                countryId: 3
            },
            {
                stateId: 1250,
                label: "Tebessa",
                value: "Tebessa",
                countryId: 3
            },
            {
                stateId: 1263,
                label: "Tiaret",
                value: "Tiaret",
                countryId: 3
            },
            {
                stateId: 1267,
                label: "Tindouf",
                value: "Tindouf",
                countryId: 3
            },
            {
                stateId: 1269,
                label: "Tipaza",
                value: "Tipaza",
                countryId: 3
            },
            {
                stateId: 1272,
                label: "Tissemsilt",
                value: "Tissemsilt",
                countryId: 3
            },
            {
                stateId: 1273,
                label: "Tizi-Ouzou",
                value: "Tizi-Ouzou",
                countryId: 3
            },
            {
                stateId: 1275,
                label: "Tlemcen",
                value: "Tlemcen",
                countryId: 3
            }
        ]
    },
    {
        countryId: 4,
        code: "AS",
        label: "American Samoa",
        value: "American Samoa",
        states: [
            {
                stateId: 78,
                label: "As",
                value: "As",
                countryId: 4
            }
        ]
    },
    {
        countryId: 5,
        code: "AD",
        label: "Andorra",
        value: "Andorra",
        states: [
            {
                stateId: 56,
                label: "Andorra la Vella",
                value: "Andorra la Vella",
                countryId: 5
            },
            {
                stateId: 200,
                label: "Canillo",
                value: "Canillo",
                countryId: 5
            },
            {
                stateId: 368,
                label: "Encamp",
                value: "Encamp",
                countryId: 5
            },
            {
                stateId: 375,
                label: "Escaldes-Engordany",
                value: "Escaldes-Engordany",
                countryId: 5
            },
            {
                stateId: 664,
                label: "La Massana",
                value: "La Massana",
                countryId: 5
            },
            {
                stateId: 902,
                label: "Ordino",
                value: "Ordino",
                countryId: 5
            },
            {
                stateId: 1129,
                label: "Sant Julià de Lòria",
                value: "Sant Julià de Lòria",
                countryId: 5
            }
        ]
    },
    {
        countryId: 99,
        code: "AO",
        label: "Angola",
        value: "Angola",
        states: [
            {
                stateId: 1572,
                label: "Luanda",
                value: "Luanda",
                countryId: 99
            }
        ]
    },
    {
        countryId: 100,
        code: "AI",
        label: "Anguilla",
        value: "Anguilla",
        states: [
            {
                stateId: 1573,
                label: "The Valley",
                value: "The Valley",
                countryId: 100
            }
        ]
    },
    // {
    //     countryId: 101,
    //     code: "AQ",
    //     label: "Antarctica",
    //     value: "Antarctica",
    //     states: []
    // },
    {
        countryId: 102,
        code: "AG",
        label: "Antigua and Barbuda",
        value: "Antigua and Barbuda",
        states: [
            {
                stateId: 1574,
                label: "Saint John’s",
                value: "Saint John’s",
                countryId: 102
            }
        ]
    },
    {
        countryId: 6,
        code: "AR",
        label: "Argentina",
        value: "Argentina",
        states: [
            {
                stateId: 176,
                label: "Buenos Aires",
                value: "Buenos Aires",
                countryId: 6
            },
            {
                stateId: 222,
                label: "Catamarca",
                value: "Catamarca",
                countryId: 6
            },
            {
                stateId: 240,
                label: "Chaco",
                value: "Chaco",
                countryId: 6
            },
            {
                stateId: 260,
                label: "Chubut",
                value: "Chubut",
                countryId: 6
            },
            {
                stateId: 284,
                label: "Cordoba",
                value: "Cordoba",
                countryId: 6
            },
            {
                stateId: 287,
                label: "Corrientes",
                value: "Corrientes",
                countryId: 6
            },
            {
                stateId: 371,
                label: "Entre Rios",
                value: "Entre Rios",
                countryId: 6
            },
            {
                stateId: 394,
                label: "Formosa",
                value: "Formosa",
                countryId: 6
            },
            {
                stateId: 560,
                label: "Jujuy",
                value: "Jujuy",
                countryId: 6
            },
            {
                stateId: 665,
                label: "La Pampa",
                value: "La Pampa",
                countryId: 6
            },
            {
                stateId: 666,
                label: "La Rioja",
                value: "La Rioja",
                countryId: 6
            },
            {
                stateId: 764,
                label: "Mendoza",
                value: "Mendoza",
                countryId: 6
            },
            {
                stateId: 781,
                label: "Misiones",
                value: "Misiones",
                countryId: 6
            },
            {
                stateId: 835,
                label: "Neuquen",
                value: "Neuquen",
                countryId: 6
            },
            {
                stateId: 1055,
                label: "Rio Negro",
                value: "Rio Negro",
                countryId: 6
            },
            {
                stateId: 1108,
                label: "Salta",
                value: "Salta",
                countryId: 6
            },
            {
                stateId: 1120,
                label: "San Juan",
                value: "San Juan",
                countryId: 6
            },
            {
                stateId: 1123,
                label: "San Luis",
                value: "San Luis",
                countryId: 6
            },
            {
                stateId: 1131,
                label: "Santa Cruz",
                value: "Santa Cruz",
                countryId: 6
            },
            {
                stateId: 1132,
                label: "Santa Fe",
                value: "Santa Fe",
                countryId: 6
            },
            {
                stateId: 1136,
                label: "Santiago Del Estero",
                value: "Santiago Del Estero",
                countryId: 6
            },
            {
                stateId: 1265,
                label: "Tierra Del Fuego",
                value: "Tierra Del Fuego",
                countryId: 6
            },
            {
                stateId: 1303,
                label: "Tucuman",
                value: "Tucuman",
                countryId: 6
            }
        ]
    },
    {
        countryId: 104,
        code: "AM",
        label: "Armenia",
        value: "Armenia",
        states: [
            {
                stateId: 1575,
                label: "Yerevan",
                value: "Yerevan",
                countryId: 104
            }
        ]
    },
    {
        countryId: 105,
        code: "AW",
        label: "Aruba",
        value: "Aruba",
        states: [
            {
                stateId: 1576,
                label: "Oranjestad",
                value: "Oranjestad",
                countryId: 105
            }
        ]
    },
    {
        countryId: 7,
        code: "AU",
        label: "Australia",
        value: "Australia",
        states: [
            {
                stateId: 87,
                label: "Australian Capital Territory",
                value: "Australian Capital Territory",
                countryId: 7
            },
            {
                stateId: 842,
                label: "New South Wales",
                value: "New South Wales",
                countryId: 7
            },
            {
                stateId: 874,
                label: "Northern Territory",
                value: "Northern Territory",
                countryId: 7
            },
            {
                stateId: 1005,
                label: "Queensland",
                value: "Queensland",
                countryId: 7
            },
            {
                stateId: 1194,
                label: "South Australia",
                value: "South Australia",
                countryId: 7
            },
            {
                stateId: 1246,
                label: "Tasmania",
                value: "Tasmania",
                countryId: 7
            },
            {
                stateId: 1360,
                label: "Victoria",
                value: "Victoria",
                countryId: 7
            },
            {
                stateId: 1394,
                label: "Western Australia",
                value: "Western Australia",
                countryId: 7
            }
        ]
    },
    {
        countryId: 8,
        code: "AT",
        label: "Austria",
        value: "Austria",
        states: [
            {
                stateId: 178,
                label: "Burgenland",
                value: "Burgenland",
                countryId: 8
            },
            {
                stateId: 599,
                label: "Kärnten",
                value: "Kärnten",
                countryId: 8
            },
            {
                stateId: 846,
                label: "Niederösterreich",
                value: "Niederösterreich",
                countryId: 8
            },
            {
                stateId: 883,
                label: "Oberösterreich",
                value: "Oberösterreich",
                countryId: 8
            },
            {
                stateId: 1111,
                label: "Salzburg",
                value: "Salzburg",
                countryId: 8
            },
            {
                stateId: 1211,
                label: "Steiermark",
                value: "Steiermark",
                countryId: 8
            },
            {
                stateId: 1271,
                label: "Tirol",
                value: "Tirol",
                countryId: 8
            },
            {
                stateId: 1378,
                label: "Vorarlberg",
                value: "Vorarlberg",
                countryId: 8
            },
            {
                stateId: 1396,
                label: "Wien",
                value: "Wien",
                countryId: 8
            }
        ]
    },
    {
        countryId: 9,
        code: "AZ",
        label: "Azerbaijan",
        value: "Azerbaijan",
        states: [
            {
                stateId: 4,
                label: "Abşeron",
                value: "Abşeron",
                countryId: 9
            },
            {
                stateId: 13,
                label: "Ağcabədi",
                value: "Ağcabədi",
                countryId: 9
            },
            {
                stateId: 14,
                label: "Ağdam",
                value: "Ağdam",
                countryId: 9
            },
            {
                stateId: 15,
                label: "Ağdaş",
                value: "Ağdaş",
                countryId: 9
            },
            {
                stateId: 18,
                label: "Ağstafa",
                value: "Ağstafa",
                countryId: 9
            },
            {
                stateId: 19,
                label: "Ağsu",
                value: "Ağsu",
                countryId: 9
            },
            {
                stateId: 80,
                label: "Astara",
                value: "Astara",
                countryId: 9
            },
            {
                stateId: 99,
                label: "Baki",
                value: "Baki",
                countryId: 9
            },
            {
                stateId: 100,
                label: "Balakən",
                value: "Balakən",
                countryId: 9
            },
            {
                stateId: 134,
                label: "Beyləqan",
                value: "Beyləqan",
                countryId: 9
            },
            {
                stateId: 138,
                label: "Biləsuvar",
                value: "Biləsuvar",
                countryId: 9
            },
            {
                stateId: 184,
                label: "Bərdə",
                value: "Bərdə",
                countryId: 9
            },
            {
                stateId: 298,
                label: "Cəlilabad",
                value: "Cəlilabad",
                countryId: 9
            },
            {
                stateId: 304,
                label: "Daşkəsən",
                value: "Daşkəsən",
                countryId: 9
            },
            {
                stateId: 400,
                label: "Füzuli",
                value: "Füzuli",
                countryId: 9
            },
            {
                stateId: 419,
                label: "Goranboy",
                value: "Goranboy",
                countryId: 9
            },
            {
                stateId: 422,
                label: "Göy-Göl",
                value: "Göy-Göl",
                countryId: 9
            },
            {
                stateId: 423,
                label: "Göyçay",
                value: "Göyçay",
                countryId: 9
            },
            {
                stateId: 453,
                label: "Gədəbəy",
                value: "Gədəbəy",
                countryId: 9
            },
            {
                stateId: 454,
                label: "Gəncə",
                value: "Gəncə",
                countryId: 9
            },
            {
                stateId: 455,
                label: "Haciqabul",
                value: "Haciqabul",
                countryId: 9
            },
            {
                stateId: 516,
                label: "Imişli",
                value: "Imişli",
                countryId: 9
            },
            {
                stateId: 527,
                label: "Ismayilli",
                value: "Ismayilli",
                countryId: 9
            },
            {
                stateId: 646,
                label: "Kürdəmir",
                value: "Kürdəmir",
                countryId: 9
            },
            {
                stateId: 652,
                label: "Kəlbəcər",
                value: "Kəlbəcər",
                countryId: 9
            },
            {
                stateId: 671,
                label: "Laçin",
                value: "Laçin",
                countryId: 9
            },
            {
                stateId: 686,
                label: "Lerik",
                value: "Lerik",
                countryId: 9
            },
            {
                stateId: 713,
                label: "Lənkəran",
                value: "Lənkəran",
                countryId: 9
            },
            {
                stateId: 747,
                label: "Masalli",
                value: "Masalli",
                countryId: 9
            },
            {
                stateId: 777,
                label: "Mingəçevir",
                value: "Mingəçevir",
                countryId: 9
            },
            {
                stateId: 809,
                label: "Naftalan",
                value: "Naftalan",
                countryId: 9
            },
            {
                stateId: 830,
                label: "Neftçala",
                value: "Neftçala",
                countryId: 9
            },
            {
                stateId: 889,
                label: "Oğuz",
                value: "Oğuz",
                countryId: 9
            },
            {
                stateId: 997,
                label: "Qax",
                value: "Qax",
                countryId: 9
            },
            {
                stateId: 998,
                label: "Qazax",
                value: "Qazax",
                countryId: 9
            },
            {
                stateId: 999,
                label: "Qobustan",
                value: "Qobustan",
                countryId: 9
            },
            {
                stateId: 1001,
                label: "Quba",
                value: "Quba",
                countryId: 9
            },
            {
                stateId: 1002,
                label: "Qubadli",
                value: "Qubadli",
                countryId: 9
            },
            {
                stateId: 1009,
                label: "Qusar",
                value: "Qusar",
                countryId: 9
            },
            {
                stateId: 1010,
                label: "Qəbələ",
                value: "Qəbələ",
                countryId: 9
            },
            {
                stateId: 1078,
                label: "Saatli",
                value: "Saatli",
                countryId: 9
            },
            {
                stateId: 1082,
                label: "Sabirabad",
                value: "Sabirabad",
                countryId: 9
            },
            {
                stateId: 1083,
                label: "Şabran",
                value: "Şabran",
                countryId: 9
            },
            {
                stateId: 1110,
                label: "Salyan",
                value: "Salyan",
                countryId: 9
            },
            {
                stateId: 1112,
                label: "Şamaxi",
                value: "Şamaxi",
                countryId: 9
            },
            {
                stateId: 1117,
                label: "Samux",
                value: "Samux",
                countryId: 9
            },
            {
                stateId: 1173,
                label: "Şirvan",
                value: "Şirvan",
                countryId: 9
            },
            {
                stateId: 1176,
                label: "Siyəzən",
                value: "Siyəzən",
                countryId: 9
            },
            {
                stateId: 1221,
                label: "Sumqayit",
                value: "Sumqayit",
                countryId: 9
            },
            {
                stateId: 1225,
                label: "Şuşa",
                value: "Şuşa",
                countryId: 9
            },
            {
                stateId: 1230,
                label: "Şəki",
                value: "Şəki",
                countryId: 9
            },
            {
                stateId: 1231,
                label: "Şəmkir",
                value: "Şəmkir",
                countryId: 9
            },
            {
                stateId: 1287,
                label: "Tovuz",
                value: "Tovuz",
                countryId: 9
            },
            {
                stateId: 1307,
                label: "Tər-Tər",
                value: "Tər-Tər",
                countryId: 9
            },
            {
                stateId: 1309,
                label: "Ucar",
                value: "Ucar",
                countryId: 9
            },
            {
                stateId: 1400,
                label: "Xaçmaz",
                value: "Xaçmaz",
                countryId: 9
            },
            {
                stateId: 1401,
                label: "Xankəndi",
                value: "Xankəndi",
                countryId: 9
            },
            {
                stateId: 1402,
                label: "Xizi",
                value: "Xizi",
                countryId: 9
            },
            {
                stateId: 1403,
                label: "Xocali",
                value: "Xocali",
                countryId: 9
            },
            {
                stateId: 1404,
                label: "Xocavənd",
                value: "Xocavənd",
                countryId: 9
            },
            {
                stateId: 1411,
                label: "Yardimli",
                value: "Yardimli",
                countryId: 9
            },
            {
                stateId: 1414,
                label: "Yevlax",
                value: "Yevlax",
                countryId: 9
            },
            {
                stateId: 1424,
                label: "Zaqatala",
                value: "Zaqatala",
                countryId: 9
            },
            {
                stateId: 1432,
                label: "Zəngilan",
                value: "Zəngilan",
                countryId: 9
            },
            {
                stateId: 1433,
                label: "Zərdab",
                value: "Zərdab",
                countryId: 9
            }
        ]
    },
    {
        countryId: 109,
        code: "BS",
        label: "Bahamas",
        value: "Bahamas",
        states: [
            {
                stateId: 1577,
                label: "Nassau",
                value: "Nassau",
                countryId: 109
            }
        ]
    },
    {
        countryId: 110,
        code: "BH",
        label: "Bahrain",
        value: "Bahrain",
        states: [
            {
                stateId: 1578,
                label: "Manama",
                value: "Manama",
                countryId: 110
            }
        ]
    },
    {
        countryId: 10,
        code: "BD",
        label: "Bangladesh",
        value: "Bangladesh",
        states: [
            {
                stateId: 116,
                label: "Barisal Division",
                value: "Barisal Division",
                countryId: 10
            },
            {
                stateId: 256,
                label: "Chittagong",
                value: "Chittagong",
                countryId: 10
            },
            {
                stateId: 333,
                label: "Dhaka Division",
                value: "Dhaka Division",
                countryId: 10
            },
            {
                stateId: 616,
                label: "Khulna Division",
                value: "Khulna Division",
                countryId: 10
            },
            {
                stateId: 1012,
                label: "Rājshāhi Division",
                value: "Rājshāhi Division",
                countryId: 10
            },
            {
                stateId: 1013,
                label: "Rangpur Division",
                value: "Rangpur Division",
                countryId: 10
            },
            {
                stateId: 1228,
                label: "Sylhet Division",
                value: "Sylhet Division",
                countryId: 10
            }
        ]
    },
    {
        countryId: 112,
        code: "BB",
        label: "Barbados",
        value: "Barbados",
        states: [
            {
                stateId: 1579,
                label: "Bridgetown",
                value: "Bridgetown",
                countryId: 112
            }
        ]
    },
    {
        countryId: 11,
        code: "BY",
        label: "Belarus",
        value: "Belarus",
        states: [
            {
                stateId: 167,
                label: "Brest",
                value: "Brest",
                countryId: 11
            },
            {
                stateId: 418,
                label: "Gomel",
                value: "Gomel",
                countryId: 11
            },
            {
                stateId: 430,
                label: "Grodno",
                value: "Grodno",
                countryId: 11
            },
            {
                stateId: 432,
                label: "Grosno",
                value: "Grosno",
                countryId: 11
            },
            {
                stateId: 779,
                label: "Minsk",
                value: "Minsk",
                countryId: 11
            },
            {
                stateId: 788,
                label: "Moghilev",
                value: "Moghilev",
                countryId: 11
            },
            {
                stateId: 789,
                label: "Mogholev",
                value: "Mogholev",
                countryId: 11
            },
            {
                stateId: 1374,
                label: "Vitebk",
                value: "Vitebk",
                countryId: 11
            },
            {
                stateId: 1375,
                label: "Vitebsk",
                value: "Vitebsk",
                countryId: 11
            }
        ]
    },
    {
        countryId: 12,
        code: "BE",
        label: "Belgium",
        value: "Belgium",
        states: [
            {
                stateId: 173,
                label: "Bruxelles-Capitale",
                value: "Bruxelles-Capitale",
                countryId: 12
            },
            {
                stateId: 1376,
                label: "Vlaanderen",
                value: "Vlaanderen",
                countryId: 12
            },
            {
                stateId: 1385,
                label: "Wallonie",
                value: "Wallonie",
                countryId: 12
            }
        ]
    },
    {
        countryId: 115,
        code: "BZ",
        label: "Belize",
        value: "Belize",
        states: [
            {
                stateId: 1580,
                label: "Belmopan",
                value: "Belmopan",
                countryId: 115
            }
        ]
    },
    {
        countryId: 116,
        code: "BJ",
        label: "Benin",
        value: "Benin",
        states: [
            {
                stateId: 1581,
                label: "Porto-Novo",
                value: "Porto-Novo",
                countryId: 116
            }
        ]
    },
    {
        countryId: 13,
        code: "BM",
        label: "Bermuda",
        value: "Bermuda",
        states: [
            {
                stateId: 332,
                label: "Devonshire Parish",
                value: "Devonshire Parish",
                countryId: 13
            },
            {
                stateId: 460,
                label: "Hamilton",
                value: "Hamilton",
                countryId: 13
            },
            {
                stateId: 920,
                label: "Paget Parish",
                value: "Paget Parish",
                countryId: 13
            },
            {
                stateId: 940,
                label: "Pembroke Parish",
                value: "Pembroke Parish",
                countryId: 13
            },
            {
                stateId: 1090,
                label: "Saint George",
                value: "Saint George",
                countryId: 13
            },
            {
                stateId: 1091,
                label: "Saint George’s Parish",
                value: "Saint George’s Parish",
                countryId: 13
            },
            {
                stateId: 1126,
                label: "Sandys Parish",
                value: "Sandys Parish",
                countryId: 13
            },
            {
                stateId: 1183,
                label: "Smith’s Parish",
                value: "Smith’s Parish",
                countryId: 13
            },
            {
                stateId: 1199,
                label: "Southampton Parish",
                value: "Southampton Parish",
                countryId: 13
            },
            {
                stateId: 1387,
                label: "Warwick Parish",
                value: "Warwick Parish",
                countryId: 13
            }
        ]
    },
    {
        countryId: 118,
        code: "BT",
        label: "Bhutan",
        value: "Bhutan",
        states: [
            {
                stateId: 1582,
                label: "Thimphu",
                value: "Thimphu",
                countryId: 118
            }
        ]
    },
    {
        countryId: 119,
        code: "BO",
        label: "Bolivia (Plurinational State of)",
        value: "Bolivia (Plurinational State of)",
        states: [
            {
                stateId: 1583,
                label: "Sucre",
                value: "Sucre",
                countryId: 119
            }
        ]
    },
    {
        countryId: 120,
        code: "BQ",
        label: "Bonaire, Sint Eustatius and Saba",
        value: "Bonaire, Sint Eustatius and Saba",
        states: [
            {
                stateId: 1584,
                label: "Kralendijk",
                value: "Kralendijk",
                countryId: 120
            },
            {
                stateId: 1585,
                label: "Oranjestad",
                value: "Oranjestad",
                countryId: 120
            },
            {
                stateId: 1586,
                label: "The Bottom",
                value: "The Bottom",
                countryId: 120
            }
        ]
    },
    {
        countryId: 121,
        code: "BA",
        label: "Bosnia and Herzegovina",
        value: "Bosnia and Herzegovina",
        states: [
            {
                stateId: 1587,
                label: "Sarajevo",
                value: "Sarajevo",
                countryId: 121
            }
        ]
    },
    {
        countryId: 122,
        code: "BW",
        label: "Botswana",
        value: "Botswana",
        states: [
            {
                stateId: 1588,
                label: "Gaborone",
                value: "Gaborone",
                countryId: 122
            }
        ]
    },
    // {
    //     countryId: 123,
    //     code: "BV",
    //     label: "Bouvet Island",
    //     value: "Bouvet Island",
    //     states: []
    // },
    {
        countryId: 14,
        code: "BR",
        label: "Brazil",
        value: "Brazil",
        states: [
            {
                stateId: 6,
                label: "Acre",
                value: "Acre",
                countryId: 14
            },
            {
                stateId: 35,
                label: "Alagoas ",
                value: "Alagoas ",
                countryId: 14
            },
            {
                stateId: 46,
                label: "Amapa",
                value: "Amapa",
                countryId: 14
            },
            {
                stateId: 49,
                label: "Amazonas ",
                value: "Amazonas ",
                countryId: 14
            },
            {
                stateId: 96,
                label: "Bahia",
                value: "Bahia",
                countryId: 14
            },
            {
                stateId: 227,
                label: "Ceara",
                value: "Ceara",
                countryId: 14
            },
            {
                stateId: 337,
                label: "Distrito Federal",
                value: "Distrito Federal",
                countryId: 14
            },
            {
                stateId: 379,
                label: "Espirito Santo",
                value: "Espirito Santo",
                countryId: 14
            },
            {
                stateId: 417,
                label: "Goias",
                value: "Goias",
                countryId: 14
            },
            {
                stateId: 735,
                label: "Maranhao ",
                value: "Maranhao ",
                countryId: 14
            },
            {
                stateId: 750,
                label: "Mato Grosso ",
                value: "Mato Grosso ",
                countryId: 14
            },
            {
                stateId: 751,
                label: "Mato Grosso do Sul",
                value: "Mato Grosso do Sul",
                countryId: 14
            },
            {
                stateId: 776,
                label: "Minas Gerais",
                value: "Minas Gerais",
                countryId: 14
            },
            {
                stateId: 927,
                label: "Para",
                value: "Para",
                countryId: 14
            },
            {
                stateId: 928,
                label: "Paraiba",
                value: "Paraiba",
                countryId: 14
            },
            {
                stateId: 929,
                label: "Parana",
                value: "Parana",
                countryId: 14
            },
            {
                stateId: 945,
                label: "Pernambuco ",
                value: "Pernambuco ",
                countryId: 14
            },
            {
                stateId: 956,
                label: "Piaui",
                value: "Piaui",
                countryId: 14
            },
            {
                stateId: 1051,
                label: "Rio de Janeiro ",
                value: "Rio de Janeiro ",
                countryId: 14
            },
            {
                stateId: 1053,
                label: "Rio Grande do Norte ",
                value: "Rio Grande do Norte ",
                countryId: 14
            },
            {
                stateId: 1054,
                label: "Rio Grande do Sul",
                value: "Rio Grande do Sul",
                countryId: 14
            },
            {
                stateId: 1066,
                label: "Rondonia",
                value: "Rondonia",
                countryId: 14
            },
            {
                stateId: 1068,
                label: "Roraima",
                value: "Roraima",
                countryId: 14
            },
            {
                stateId: 1130,
                label: "Santa Catarina ",
                value: "Santa Catarina ",
                countryId: 14
            },
            {
                stateId: 1137,
                label: "Sao Paulo",
                value: "Sao Paulo",
                countryId: 14
            },
            {
                stateId: 1152,
                label: "Sergipe",
                value: "Sergipe",
                countryId: 14
            },
            {
                stateId: 1278,
                label: "Tocantins",
                value: "Tocantins",
                countryId: 14
            }
        ]
    },
    // {
    //     countryId: 125,
    //     code: "IO",
    //     label: "British Indian Ocean Territory",
    //     value: "British Indian Ocean Territory",
    //     states: []
    // },
    {
        countryId: 129,
        code: "BN",
        label: "Brunei Darussalam",
        value: "Brunei Darussalam",
        states: [
            {
                stateId: 1589,
                label: "Bandar Seri Begawan",
                value: "Bandar Seri Begawan",
                countryId: 129
            }
        ]
    },
    {
        countryId: 15,
        code: "BG",
        label: "Bulgaria",
        value: "Bulgaria",
        states: [
            {
                stateId: 1449,
                label: "Благоевград / Blagoevgrad",
                value: "Благоевград / Blagoevgrad",
                countryId: 15
            },
            {
                stateId: 1451,
                label: "Бургас / Burgas",
                value: "Бургас / Burgas",
                countryId: 15
            },
            {
                stateId: 1453,
                label: "Варна / Varna",
                value: "Варна / Varna",
                countryId: 15
            },
            {
                stateId: 1454,
                label: "Велико Търново / Veliko Turnovo",
                value: "Велико Търново / Veliko Turnovo",
                countryId: 15
            },
            {
                stateId: 1455,
                label: "Видин / Vidin",
                value: "Видин / Vidin",
                countryId: 15
            },
            {
                stateId: 1460,
                label: "Враца / Vraca",
                value: "Враца / Vraca",
                countryId: 15
            },
            {
                stateId: 1461,
                label: "Габрово / Gabrovo",
                value: "Габрово / Gabrovo",
                countryId: 15
            },
            {
                stateId: 1463,
                label: "Добрич / Dobrich",
                value: "Добрич / Dobrich",
                countryId: 15
            },
            {
                stateId: 1482,
                label: "Кърджали / Kurdzhali",
                value: "Кърджали / Kurdzhali",
                countryId: 15
            },
            {
                stateId: 1483,
                label: "Кюстендил / Kjustendil",
                value: "Кюстендил / Kjustendil",
                countryId: 15
            },
            {
                stateId: 1486,
                label: "Ловеч / Lovech",
                value: "Ловеч / Lovech",
                countryId: 15
            },
            {
                stateId: 1489,
                label: "Монтана / Montana",
                value: "Монтана / Montana",
                countryId: 15
            },
            {
                stateId: 1500,
                label: "Пазарджик / Pazardzhik",
                value: "Пазарджик / Pazardzhik",
                countryId: 15
            },
            {
                stateId: 1503,
                label: "Перник / Pernik",
                value: "Перник / Pernik",
                countryId: 15
            },
            {
                stateId: 1504,
                label: "Плевен / Pleven",
                value: "Плевен / Pleven",
                countryId: 15
            },
            {
                stateId: 1505,
                label: "Пловдив / Plovdiv",
                value: "Пловдив / Plovdiv",
                countryId: 15
            },
            {
                stateId: 1508,
                label: "Разград / Razgrad",
                value: "Разград / Razgrad",
                countryId: 15
            },
            {
                stateId: 1510,
                label: "Русе / Ruse",
                value: "Русе / Ruse",
                countryId: 15
            },
            {
                stateId: 1519,
                label: "Силистра / Silistra",
                value: "Силистра / Silistra",
                countryId: 15
            },
            {
                stateId: 1520,
                label: "Сливен / Sliven",
                value: "Сливен / Sliven",
                countryId: 15
            },
            {
                stateId: 1522,
                label: "Смолян / Smoljan",
                value: "Смолян / Smoljan",
                countryId: 15
            },
            {
                stateId: 1523,
                label: "София (столица) / Sofija (stolica)",
                value: "София (столица) / Sofija (stolica)",
                countryId: 15
            },
            {
                stateId: 1524,
                label: "София / Sofija",
                value: "София / Sofija",
                countryId: 15
            },
            {
                stateId: 1526,
                label: "Стара Загора / Stara Zagora",
                value: "Стара Загора / Stara Zagora",
                countryId: 15
            },
            {
                stateId: 1532,
                label: "Търговище / Turgovishhe",
                value: "Търговище / Turgovishhe",
                countryId: 15
            },
            {
                stateId: 1539,
                label: "Хасково / Khaskovo",
                value: "Хасково / Khaskovo",
                countryId: 15
            },
            {
                stateId: 1544,
                label: "Шумен / Shumen",
                value: "Шумен / Shumen",
                countryId: 15
            },
            {
                stateId: 1545,
                label: "Ямбол / Jambol",
                value: "Ямбол / Jambol",
                countryId: 15
            }
        ]
    },
    {
        countryId: 131,
        code: "BF",
        label: "Burkina Faso",
        value: "Burkina Faso",
        states: [
            {
                stateId: 1590,
                label: "Ouagadougou",
                value: "Ouagadougou",
                countryId: 131
            }
        ]
    },
    {
        countryId: 132,
        code: "BI",
        label: "Burundi",
        value: "Burundi",
        states: [
            {
                stateId: 1591,
                label: "Gitega",
                value: "Gitega",
                countryId: 132
            }
        ]
    },
    {
        countryId: 136,
        code: "CV",
        label: "Cabo Verde",
        value: "Cabo Verde",
        states: [
            {
                stateId: 1592,
                label: "Praia",
                value: "Praia",
                countryId: 136
            }
        ]
    },
    {
        countryId: 133,
        code: "KH",
        label: "Cambodia",
        value: "Cambodia",
        states: [
            {
                stateId: 1593,
                label: "Phnom Penh",
                value: "Phnom Penh",
                countryId: 133
            }
        ]
    },
    {
        countryId: 134,
        code: "CM",
        label: "Cameroon",
        value: "Cameroon",
        states: [
            {
                stateId: 1738,
                label: "Yaounde",
                value: "Yaounde",
                countryId: 134
            }
        ]
    },
    {
        countryId: 16,
        code: "CA",
        label: "Canada",
        value: "Canada",
        states: [
            {
                stateId: 40,
                label: "Alberta",
                value: "Alberta",
                countryId: 16
            },
            {
                stateId: 170,
                label: "British Columbia",
                value: "British Columbia",
                countryId: 16
            },
            {
                stateId: 733,
                label: "Manitoba",
                value: "Manitoba",
                countryId: 16
            },
            {
                stateId: 838,
                label: "New Brunswick",
                value: "New Brunswick",
                countryId: 16
            },
            {
                stateId: 844,
                label: "Newfoundland and Labrador",
                value: "Newfoundland and Labrador",
                countryId: 16
            },
            {
                stateId: 876,
                label: "Northwest Territory",
                value: "Northwest Territory",
                countryId: 16
            },
            {
                stateId: 878,
                label: "Nova Scotia",
                value: "Nova Scotia",
                countryId: 16
            },
            {
                stateId: 880,
                label: "Nunavut Territory",
                value: "Nunavut Territory",
                countryId: 16
            },
            {
                stateId: 898,
                label: "Ontario",
                value: "Ontario",
                countryId: 16
            },
            {
                stateId: 979,
                label: "Prince Edward Island",
                value: "Prince Edward Island",
                countryId: 16
            },
            {
                stateId: 1003,
                label: "Quebec",
                value: "Quebec",
                countryId: 16
            },
            {
                stateId: 1141,
                label: "Saskatchewan",
                value: "Saskatchewan",
                countryId: 16
            },
            {
                stateId: 1417,
                label: "Yukon",
                value: "Yukon",
                countryId: 16
            }
        ]
    },
    {
        countryId: 137,
        code: "KY",
        label: "Cayman Islands",
        value: "Cayman Islands",
        states: [
            {
                stateId: 1594,
                label: "George Town",
                value: "George Town",
                countryId: 137
            }
        ]
    },
    {
        countryId: 138,
        code: "CF",
        label: "Central African Republic",
        value: "Central African Republic",
        states: [
            {
                stateId: 1595,
                label: "Bangui",
                value: "Bangui",
                countryId: 138
            }
        ]
    },
    {
        countryId: 139,
        code: "TD",
        label: "Chad",
        value: "Chad",
        states: [
            {
                stateId: 1596,
                label: "N'Djamena",
                value: "N'Djamena",
                countryId: 139
            }
        ]
    },
    {
        countryId: 17,
        code: "CL",
        label: "Chile",
        value: "Chile",
        states: [
            {
                stateId: 1020,
                label: "Región Aysén",
                value: "Región Aysén",
                countryId: 17
            },
            {
                stateId: 1021,
                label: "Región de Antofagasta",
                value: "Región de Antofagasta",
                countryId: 17
            },
            {
                stateId: 1022,
                label: "Región de Arica y Parinacota",
                value: "Región de Arica y Parinacota",
                countryId: 17
            },
            {
                stateId: 1023,
                label: "Región de Atacama",
                value: "Región de Atacama",
                countryId: 17
            },
            {
                stateId: 1024,
                label: "Región de Coquimbo",
                value: "Región de Coquimbo",
                countryId: 17
            },
            {
                stateId: 1025,
                label: "Región de la Araucanía",
                value: "Región de la Araucanía",
                countryId: 17
            },
            {
                stateId: 1026,
                label: "Región de los Lagos",
                value: "Región de los Lagos",
                countryId: 17
            },
            {
                stateId: 1027,
                label: "Región de los Ríos",
                value: "Región de los Ríos",
                countryId: 17
            },
            {
                stateId: 1028,
                label: "Región de Magallanes y Antártica Chilena",
                value: "Región de Magallanes y Antártica Chilena",
                countryId: 17
            },
            {
                stateId: 1029,
                label: "Región de Tarapacá",
                value: "Región de Tarapacá",
                countryId: 17
            },
            {
                stateId: 1030,
                label: "Región de Valparaíso",
                value: "Región de Valparaíso",
                countryId: 17
            },
            {
                stateId: 1031,
                label: "Región del Biobío",
                value: "Región del Biobío",
                countryId: 17
            },
            {
                stateId: 1032,
                label: "Región del Libertador General Bernardo O’Higgins",
                value: "Región del Libertador General Bernardo O’Higgins",
                countryId: 17
            },
            {
                stateId: 1033,
                label: "Región del Maule",
                value: "Región del Maule",
                countryId: 17
            },
            {
                stateId: 1035,
                label: "Región Metropolitana",
                value: "Región Metropolitana",
                countryId: 17
            }
        ]
    },
    {
        countryId: 141,
        code: "CN",
        label: "China",
        value: "China",
        states: [
            {
                stateId: 1597,
                label: "Beijing",
                value: "Beijing",
                countryId: 141
            }
        ]
    },
    {
        countryId: 142,
        code: "CX",
        label: "Christmas Island",
        value: "Christmas Island",
        states: [
            {
                stateId: 1598,
                label: "Flying Fish Cove",
                value: "Flying Fish Cove",
                countryId: 142
            }
        ]
    },
    {
        countryId: 143,
        code: "CC",
        label: "Cocos (Keeling) Islands",
        value: "Cocos (Keeling) Islands",
        states: [
            {
                stateId: 1599,
                label: "West Island",
                value: "West Island",
                countryId: 143
            }
        ]
    },
    {
        countryId: 18,
        code: "CO",
        label: "Colombia",
        value: "Colombia",
        states: [
            {
                stateId: 50,
                label: "Amazonas",
                value: "Amazonas",
                countryId: 18
            },
            {
                stateId: 62,
                label: "Antioquia",
                value: "Antioquia",
                countryId: 18
            },
            {
                stateId: 67,
                label: "Arauca",
                value: "Arauca",
                countryId: 18
            },
            {
                stateId: 68,
                label: "Archipielago De San Andres",
                value: "Archipielago De San Andres",
                countryId: 18
            },
            {
                stateId: 82,
                label: "Atlantico",
                value: "Atlantico",
                countryId: 18
            },
            {
                stateId: 148,
                label: "Bogota, D.C.",
                value: "Bogota, D.C.",
                countryId: 18
            },
            {
                stateId: 149,
                label: "Bolivar",
                value: "Bolivar",
                countryId: 18
            },
            {
                stateId: 159,
                label: "Boyaca",
                value: "Boyaca",
                countryId: 18
            },
            {
                stateId: 191,
                label: "Caldas",
                value: "Caldas",
                countryId: 18
            },
            {
                stateId: 213,
                label: "Caqueta",
                value: "Caqueta",
                countryId: 18
            },
            {
                stateId: 217,
                label: "Casanare",
                value: "Casanare",
                countryId: 18
            },
            {
                stateId: 224,
                label: "Cauca",
                value: "Cauca",
                countryId: 18
            },
            {
                stateId: 235,
                label: "Cesar",
                value: "Cesar",
                countryId: 18
            },
            {
                stateId: 258,
                label: "Choco",
                value: "Choco",
                countryId: 18
            },
            {
                stateId: 285,
                label: "Cordoba",
                value: "Cordoba",
                countryId: 18
            },
            {
                stateId: 297,
                label: "Cundinamarca",
                value: "Cundinamarca",
                countryId: 18
            },
            {
                stateId: 435,
                label: "Guainia",
                value: "Guainia",
                countryId: 18
            },
            {
                stateId: 439,
                label: "Guaviare",
                value: "Guaviare",
                countryId: 18
            },
            {
                stateId: 481,
                label: "Huila",
                value: "Huila",
                countryId: 18
            },
            {
                stateId: 663,
                label: "La Guajira",
                value: "La Guajira",
                countryId: 18
            },
            {
                stateId: 721,
                label: "Magdalena",
                value: "Magdalena",
                countryId: 18
            },
            {
                stateId: 768,
                label: "Meta",
                value: "Meta",
                countryId: 18
            },
            {
                stateId: 824,
                label: "Nariño",
                value: "Nariño",
                countryId: 18
            },
            {
                stateId: 863,
                label: "Norte De Santander",
                value: "Norte De Santander",
                countryId: 18
            },
            {
                stateId: 996,
                label: "Putumayo",
                value: "Putumayo",
                countryId: 18
            },
            {
                stateId: 1007,
                label: "Quindio",
                value: "Quindio",
                countryId: 18
            },
            {
                stateId: 1057,
                label: "Risaralda",
                value: "Risaralda",
                countryId: 18
            },
            {
                stateId: 1134,
                label: "Santander",
                value: "Santander",
                countryId: 18
            },
            {
                stateId: 1219,
                label: "Sucre",
                value: "Sucre",
                countryId: 18
            },
            {
                stateId: 1283,
                label: "Tolima",
                value: "Tolima",
                countryId: 18
            },
            {
                stateId: 1332,
                label: "Valle Del Cauca",
                value: "Valle Del Cauca",
                countryId: 18
            },
            {
                stateId: 1344,
                label: "Vaupes",
                value: "Vaupes",
                countryId: 18
            },
            {
                stateId: 1359,
                label: "Vichada",
                value: "Vichada",
                countryId: 18
            }
        ]
    },
    {
        countryId: 145,
        code: "KM",
        label: "Comoros",
        value: "Comoros",
        states: [
            {
                stateId: 1600,
                label: "Moroni",
                value: "Moroni",
                countryId: 145
            }
        ]
    },
    {
        countryId: 146,
        code: "CG",
        label: "Congo",
        value: "Congo",
        states: [
            {
                stateId: 1601,
                label: "Brazzaville",
                value: "Brazzaville",
                countryId: 146
            }
        ]
    },
    {
        countryId: 147,
        code: "CD",
        label: "Congo (Democratic Republic of the)",
        value: "Congo (Democratic Republic of the)",
        states: [
            {
                stateId: 1602,
                label: "Kinshasa",
                value: "Kinshasa",
                countryId: 147
            }
        ]
    },
    {
        countryId: 148,
        code: "CK",
        label: "Cook Islands",
        value: "Cook Islands",
        states: [
            {
                stateId: 1739,
                label: "Avarua",
                value: "Avarua",
                countryId: 35
            }
        ]
    },
    {
        countryId: 19,
        code: "CR",
        label: "Costa Rica",
        value: "Costa Rica",
        states: [
            {
                stateId: 984,
                label: "Provincia de Alajuela",
                value: "Provincia de Alajuela",
                countryId: 19
            },
            {
                stateId: 985,
                label: "Provincia de Cartago",
                value: "Provincia de Cartago",
                countryId: 19
            },
            {
                stateId: 986,
                label: "Provincia de Guanacaste",
                value: "Provincia de Guanacaste",
                countryId: 19
            },
            {
                stateId: 987,
                label: "Provincia de Heredia",
                value: "Provincia de Heredia",
                countryId: 19
            },
            {
                stateId: 988,
                label: "Provincia de Limón",
                value: "Provincia de Limón",
                countryId: 19
            },
            {
                stateId: 989,
                label: "Provincia de Puntarenas",
                value: "Provincia de Puntarenas",
                countryId: 19
            },
            {
                stateId: 990,
                label: "Provincia de San José",
                value: "Provincia de San José",
                countryId: 19
            }
        ]
    },
    {
        countryId: 199,
        code: "CI",
        label: "Côte d'Ivoire",
        value: "Côte d'Ivoire",
        states: [
            {
                stateId: 1603,
                label: "Yamoussoukro",
                value: "Yamoussoukro",
                countryId: 199
            }
        ]
    },
    {
        countryId: 20,
        code: "HR",
        label: "Croatia",
        value: "Croatia",
        states: [
            {
                stateId: 145,
                label: "Bjelovarsko-Bilogorska",
                value: "Bjelovarsko-Bilogorska",
                countryId: 20
            },
            {
                stateId: 172,
                label: "Brodsko-Posavska",
                value: "Brodsko-Posavska",
                countryId: 20
            },
            {
                stateId: 351,
                label: "Dubrovačko-Neretvanska",
                value: "Dubrovačko-Neretvanska",
                countryId: 20
            },
            {
                stateId: 424,
                label: "Grad Zagreb",
                value: "Grad Zagreb",
                countryId: 20
            },
            {
                stateId: 530,
                label: "Istarska",
                value: "Istarska",
                countryId: 20
            },
            {
                stateId: 596,
                label: "Karlovačka",
                value: "Karlovačka",
                countryId: 20
            },
            {
                stateId: 631,
                label: "Koprivničko-Križevačka",
                value: "Koprivničko-Križevačka",
                countryId: 20
            },
            {
                stateId: 637,
                label: "Krapinsko-Zagorska",
                value: "Krapinsko-Zagorska",
                countryId: 20
            },
            {
                stateId: 689,
                label: "Ličko-Senjska",
                value: "Ličko-Senjska",
                countryId: 20
            },
            {
                stateId: 770,
                label: "Međimurska",
                value: "Međimurska",
                countryId: 20
            },
            {
                stateId: 909,
                label: "Osječko-Baranjska",
                value: "Osječko-Baranjska",
                countryId: 20
            },
            {
                stateId: 970,
                label: "Požeško-Slavonska",
                value: "Požeško-Slavonska",
                countryId: 20
            },
            {
                stateId: 978,
                label: "Primorsko-Goranska",
                value: "Primorsko-Goranska",
                countryId: 20
            },
            {
                stateId: 1160,
                label: "Šibensko-Kninska",
                value: "Šibensko-Kninska",
                countryId: 20
            },
            {
                stateId: 1174,
                label: "Sisačko-Moslavačka",
                value: "Sisačko-Moslavačka",
                countryId: 20
            },
            {
                stateId: 1205,
                label: "Splitsko-Dalmatinska",
                value: "Splitsko-Dalmatinska",
                countryId: 20
            },
            {
                stateId: 1335,
                label: "Varaždinska",
                value: "Varaždinska",
                countryId: 20
            },
            {
                stateId: 1372,
                label: "Virovitičko-Podravska",
                value: "Virovitičko-Podravska",
                countryId: 20
            },
            {
                stateId: 1381,
                label: "Vukovarsko-Srijemska",
                value: "Vukovarsko-Srijemska",
                countryId: 20
            },
            {
                stateId: 1419,
                label: "Zadarska",
                value: "Zadarska",
                countryId: 20
            },
            {
                stateId: 1420,
                label: "Zagrebačka",
                value: "Zagrebačka",
                countryId: 20
            }
        ]
    },
    {
        countryId: 151,
        code: "CU",
        label: "Cuba",
        value: "Cuba",
        states: [
            {
                stateId: 1604,
                label: "Havana",
                value: "Havana",
                countryId: 151
            }
        ]
    },
    {
        countryId: 152,
        code: "CW",
        label: "Curaçao",
        value: "Curaçao",
        states: [
            {
                stateId: 1605,
                label: "Willemstad",
                value: "Willemstad",
                countryId: 152
            }
        ]
    },
    {
        countryId: 153,
        code: "CY",
        label: "Cyprus",
        value: "Cyprus",
        states: [
            {
                stateId: 1606,
                label: "Nicosia",
                value: "Nicosia",
                countryId: 153
            }
        ]
    },
    {
        countryId: 21,
        code: "CZ",
        label: "Czech Republic",
        value: "Czech Republic",
        states: [
            {
                stateId: 477,
                label: "Hlavní město Praha",
                value: "Hlavní město Praha",
                countryId: 21
            },
            {
                stateId: 553,
                label: "Jihočeský kraj",
                value: "Jihočeský kraj",
                countryId: 21
            },
            {
                stateId: 554,
                label: "Jihomoravský kraj",
                value: "Jihomoravský kraj",
                countryId: 21
            },
            {
                stateId: 597,
                label: "Karlovarský kraj",
                value: "Karlovarský kraj",
                countryId: 21
            },
            {
                stateId: 635,
                label: "Kraj Vysočina",
                value: "Kraj Vysočina",
                countryId: 21
            },
            {
                stateId: 636,
                label: "Královéhradecký kraj",
                value: "Královéhradecký kraj",
                countryId: 21
            },
            {
                stateId: 688,
                label: "Liberecký kraj",
                value: "Liberecký kraj",
                countryId: 21
            },
            {
                stateId: 794,
                label: "Moravskoslezský kraj",
                value: "Moravskoslezský kraj",
                countryId: 21
            },
            {
                stateId: 896,
                label: "Olomoucký kraj",
                value: "Olomoucký kraj",
                countryId: 21
            },
            {
                stateId: 930,
                label: "Pardubický kraj",
                value: "Pardubický kraj",
                countryId: 21
            },
            {
                stateId: 961,
                label: "Plzeňský kraj",
                value: "Plzeňský kraj",
                countryId: 21
            },
            {
                stateId: 1215,
                label: "Středočeský kraj",
                value: "Středočeský kraj",
                countryId: 21
            },
            {
                stateId: 1316,
                label: "Ústecký kraj",
                value: "Ústecký kraj",
                countryId: 21
            },
            {
                stateId: 1429,
                label: "Zlínský kraj",
                value: "Zlínský kraj",
                countryId: 21
            }
        ]
    },
    {
        countryId: 22,
        code: "DK",
        label: "Denmark",
        value: "Denmark",
        states: [
            {
                stateId: 1034,
                label: "Region Hovedstaden",
                value: "Region Hovedstaden",
                countryId: 22
            },
            {
                stateId: 1036,
                label: "Region Midtjylland",
                value: "Region Midtjylland",
                countryId: 22
            },
            {
                stateId: 1037,
                label: "Region Nordjylland",
                value: "Region Nordjylland",
                countryId: 22
            },
            {
                stateId: 1038,
                label: "Region Sjælland",
                value: "Region Sjælland",
                countryId: 22
            },
            {
                stateId: 1039,
                label: "Region Syddanmark",
                value: "Region Syddanmark",
                countryId: 22
            }
        ]
    },
    {
        countryId: 156,
        code: "DJ",
        label: "Djibouti",
        value: "Djibouti",
        states: [
            {
                stateId: 1607,
                label: "Djibouti",
                value: "Djibouti",
                countryId: 156
            }
        ]
    },
    {
        countryId: 157,
        code: "DM",
        label: "Dominica",
        value: "Dominica",
        states: [
            {
                stateId: 1608,
                label: "Roseau",
                value: "Roseau",
                countryId: 157
            }
        ]
    },
    {
        countryId: 23,
        code: "DO",
        label: "Dominican Republic",
        value: "Dominican Republic",
        states: [
            {
                stateId: 1609,
                label: "Santo Domingo",
                value: "Santo Domingo",
                countryId: 23
            }
        ]
    },
    {
        countryId: 159,
        code: "EC",
        label: "Ecuador",
        value: "Ecuador",
        states: [
            {
                stateId: 1610,
                label: "Quito",
                value: "Quito",
                countryId: 159
            }
        ]
    },
    {
        countryId: 160,
        code: "EG",
        label: "Egypt",
        value: "Egypt",
        states: [
            {
                stateId: 1611,
                label: "Cairo",
                value: "Cairo",
                countryId: 160
            }
        ]
    },
    {
        countryId: 161,
        code: "SV",
        label: "El Salvador",
        value: "El Salvador",
        states: [
            {
                stateId: 1612,
                label: "San Salvador",
                value: "San Salvador",
                countryId: 161
            }
        ]
    },
    {
        countryId: 162,
        code: "GQ",
        label: "Equatorial Guinea",
        value: "Equatorial Guinea",
        states: [
            {
                stateId: 1613,
                label: "Malabo",
                value: "Malabo",
                countryId: 162
            }
        ]
    },
    {
        countryId: 163,
        code: "ER",
        label: "Eritrea",
        value: "Eritrea",
        states: [
            {
                stateId: 1614,
                label: "Asmara",
                value: "Asmara",
                countryId: 163
            }
        ]
    },
    {
        countryId: 24,
        code: "EE",
        label: "Estonia",
        value: "Estonia",
        states: [
            {
                stateId: 462,
                label: "Harju maakond",
                value: "Harju maakond",
                countryId: 24
            },
            {
                stateId: 473,
                label: "Hiiu maakond",
                value: "Hiiu maakond",
                countryId: 24
            },
            {
                stateId: 490,
                label: "Ida-Viru maakond",
                value: "Ida-Viru maakond",
                countryId: 24
            },
            {
                stateId: 544,
                label: "Järva maakond",
                value: "Järva maakond",
                countryId: 24
            },
            {
                stateId: 556,
                label: "Jõgeva maakond",
                value: "Jõgeva maakond",
                countryId: 24
            },
            {
                stateId: 668,
                label: "Lääne maakond",
                value: "Lääne maakond",
                countryId: 24
            },
            {
                stateId: 669,
                label: "Lääne-Viru maakond",
                value: "Lääne-Viru maakond",
                countryId: 24
            },
            {
                stateId: 932,
                label: "Pärnu maakond",
                value: "Pärnu maakond",
                countryId: 24
            },
            {
                stateId: 964,
                label: "Põlva maakond",
                value: "Põlva maakond",
                countryId: 24
            },
            {
                stateId: 1015,
                label: "Rapla maakond",
                value: "Rapla maakond",
                countryId: 24
            },
            {
                stateId: 1076,
                label: "Saare maakond",
                value: "Saare maakond",
                countryId: 24
            },
            {
                stateId: 1242,
                label: "Tartu maakond",
                value: "Tartu maakond",
                countryId: 24
            },
            {
                stateId: 1329,
                label: "Valga maakond",
                value: "Valga maakond",
                countryId: 24
            },
            {
                stateId: 1367,
                label: "Viljandi maakond",
                value: "Viljandi maakond",
                countryId: 24
            },
            {
                stateId: 1379,
                label: "Võru maakond",
                value: "Võru maakond",
                countryId: 24
            }
        ]
    },
    {
        countryId: 165,
        code: "ET",
        label: "Ethiopia",
        value: "Ethiopia",
        states: [
            {
                stateId: 1615,
                label: "Addis Ababa",
                value: "Addis Ababa",
                countryId: 165
            }
        ]
    },
    {
        countryId: 166,
        code: "FK",
        label: "Falkland Islands (Malvinas)",
        value: "Falkland Islands (Malvinas)",
        states: [
            {
                stateId: 1616,
                label: "Stanley",
                value: "Stanley",
                countryId: 166
            }
        ]
    },
    {
        countryId: 25,
        code: "FO",
        label: "Faroe Islands",
        value: "Faroe Islands",
        states: [
            {
                stateId: 1617,
                label: "Tórshavn",
                value: "Tórshavn",
                countryId: 25
            }
        ]
    },
    {
        countryId: 168,
        code: "FJ",
        label: "Fiji",
        value: "Fiji",
        states: [
            {
                stateId: 1618,
                label: "Suva",
                value: "Suva",
                countryId: 168
            }
        ]
    },
    {
        countryId: 26,
        code: "FI",
        label: "Finland",
        value: "Finland",
        states: [
            {
                stateId: 229,
                label: "Central Finland Region",
                value: "Central Finland Region",
                countryId: 26
            },
            {
                stateId: 230,
                label: "Central Ostrobothnia Region",
                value: "Central Ostrobothnia Region",
                countryId: 26
            },
            {
                stateId: 566,
                label: "Kainuu",
                value: "Kainuu",
                countryId: 26
            },
            {
                stateId: 575,
                label: "Kanta-Häme",
                value: "Kanta-Häme",
                countryId: 26
            },
            {
                stateId: 650,
                label: "Kymenlaakso",
                value: "Kymenlaakso",
                countryId: 26
            },
            {
                stateId: 677,
                label: "Lapland",
                value: "Lapland",
                countryId: 26
            },
            {
                stateId: 867,
                label: "North Karelia",
                value: "North Karelia",
                countryId: 26
            },
            {
                stateId: 868,
                label: "North Ostrobothnia Region",
                value: "North Ostrobothnia Region",
                countryId: 26
            },
            {
                stateId: 873,
                label: "Northern Savo",
                value: "Northern Savo",
                countryId: 26
            },
            {
                stateId: 913,
                label: "Ostrobothnia Region",
                value: "Ostrobothnia Region",
                countryId: 26
            },
            {
                stateId: 922,
                label: "Päijänne Tavastia",
                value: "Päijänne Tavastia",
                countryId: 26
            },
            {
                stateId: 958,
                label: "Pirkanmaa",
                value: "Pirkanmaa",
                countryId: 26
            },
            {
                stateId: 1142,
                label: "Satakunta",
                value: "Satakunta",
                countryId: 26
            },
            {
                stateId: 1197,
                label: "South Karelia",
                value: "South Karelia",
                countryId: 26
            },
            {
                stateId: 1198,
                label: "South Ostrobothnia Region",
                value: "South Ostrobothnia Region",
                countryId: 26
            },
            {
                stateId: 1202,
                label: "Southern Savonia",
                value: "Southern Savonia",
                countryId: 26
            },
            {
                stateId: 1204,
                label: "Southwest Finland",
                value: "Southwest Finland",
                countryId: 26
            },
            {
                stateId: 1325,
                label: "Uusimaa",
                value: "Uusimaa",
                countryId: 26
            }
        ]
    },
    {
        countryId: 27,
        code: "FR",
        label: "France",
        value: "France",
        states: [
            {
                stateId: 88,
                label: "Auvergne-Rhône-Alpes",
                value: "Auvergne-Rhône-Alpes",
                countryId: 27
            },
            {
                stateId: 158,
                label: "Bourgogne-Franche-Comté",
                value: "Bourgogne-Franche-Comté",
                countryId: 27
            },
            {
                stateId: 168,
                label: "Bretagne",
                value: "Bretagne",
                countryId: 27
            },
            {
                stateId: 233,
                label: "Centre-Val de Loire",
                value: "Centre-Val de Loire",
                countryId: 27
            },
            {
                stateId: 288,
                label: "Corse",
                value: "Corse",
                countryId: 27
            },
            {
                stateId: 425,
                label: "Grand Est",
                value: "Grand Est",
                countryId: 27
            },
            {
                stateId: 466,
                label: "Hauts-de-France",
                value: "Hauts-de-France",
                countryId: 27
            },
            {
                stateId: 510,
                label: "Île-de-France",
                value: "Île-de-France",
                countryId: 27
            },
            {
                stateId: 861,
                label: "Normandie",
                value: "Normandie",
                countryId: 27
            },
            {
                stateId: 877,
                label: "Nouvelle-Aquitaine",
                value: "Nouvelle-Aquitaine",
                countryId: 27
            },
            {
                stateId: 884,
                label: "Occitanie",
                value: "Occitanie",
                countryId: 27
            },
            {
                stateId: 937,
                label: "Pays de la Loire",
                value: "Pays de la Loire",
                countryId: 27
            },
            {
                stateId: 980,
                label: "Provence-Alpes-Côte d'Azur",
                value: "Provence-Alpes-Côte d'Azur",
                countryId: 27
            }
        ]
    },
    {
        countryId: 28,
        code: "GF",
        label: "French Guiana",
        value: "French Guiana",
        states: [
            {
                stateId: 450,
                label: "Guyane",
                value: "Guyane",
                countryId: 28
            }
        ]
    },
    {
        countryId: 172,
        code: "PF",
        label: "French Polynesia",
        value: "French Polynesia",
        states: [
            {
                stateId: 1619,
                label: "Papeete",
                value: "Papeete",
                countryId: 172
            }
        ]
    },
    {
        countryId: 173,
        code: "TF",
        label: "French Southern Territories",
        value: "French Southern Territories",
        states: [
            {
                stateId: 1620,
                label: "Saint Pierre, Réunion",
                value: "Saint Pierre, Réunion",
                countryId: 173
            }
        ]
    },
    {
        countryId: 174,
        code: "GA",
        label: "Gabon",
        value: "Gabon",
        states: [
            {
                stateId: 1621,
                label: "Gabon",
                value: "Gabon",
                countryId: 174
            }
        ]
    },
    {
        countryId: 175,
        code: "GM",
        label: "Gambia",
        value: "Gambia",
        states: [
            {
                stateId: 1622,
                label: "Banjul",
                value: "Banjul",
                countryId: 175
            }
        ]
    },
    {
        countryId: 176,
        code: "GE",
        label: "Georgia",
        value: "Georgia",
        states: [
            {
                stateId: 1623,
                label: "Tbilisi",
                value: "Tbilisi",
                countryId: 176
            }
        ]
    },
    {
        countryId: 29,
        code: "DE",
        label: "Germany",
        value: "Germany",
        states: [
            {
                stateId: 95,
                label: "Baden-Württemberg",
                value: "Baden-Württemberg",
                countryId: 29
            },
            {
                stateId: 126,
                label: "Bayern",
                value: "Bayern",
                countryId: 29
            },
            {
                stateId: 132,
                label: "Berlin",
                value: "Berlin",
                countryId: 29
            },
            {
                stateId: 163,
                label: "Brandenburg",
                value: "Brandenburg",
                countryId: 29
            },
            {
                stateId: 166,
                label: "Bremen",
                value: "Bremen",
                countryId: 29
            },
            {
                stateId: 459,
                label: "Hamburg",
                value: "Hamburg",
                countryId: 29
            },
            {
                stateId: 470,
                label: "Hessen",
                value: "Hessen",
                countryId: 29
            },
            {
                stateId: 758,
                label: "Mecklenburg-Vorpommern",
                value: "Mecklenburg-Vorpommern",
                countryId: 29
            },
            {
                stateId: 847,
                label: "Niedersachsen",
                value: "Niedersachsen",
                countryId: 29
            },
            {
                stateId: 859,
                label: "Nordrhein-Westfalen",
                value: "Nordrhein-Westfalen",
                countryId: 29
            },
            {
                stateId: 1046,
                label: "Rheinland-Pfalz",
                value: "Rheinland-Pfalz",
                countryId: 29
            },
            {
                stateId: 1077,
                label: "Saarland",
                value: "Saarland",
                countryId: 29
            },
            {
                stateId: 1084,
                label: "Sachsen",
                value: "Sachsen",
                countryId: 29
            },
            {
                stateId: 1085,
                label: "Sachsen-Anhalt",
                value: "Sachsen-Anhalt",
                countryId: 29
            },
            {
                stateId: 1148,
                label: "Schleswig-Holstein",
                value: "Schleswig-Holstein",
                countryId: 29
            },
            {
                stateId: 1262,
                label: "Thüringen",
                value: "Thüringen",
                countryId: 29
            }
        ]
    },
    {
        countryId: 178,
        code: "GH",
        label: "Ghana",
        value: "Ghana",
        states: [
            {
                stateId: 1624,
                label: "Accra",
                value: "Accra",
                countryId: 178
            }
        ]
    },
    {
        countryId: 179,
        code: "GI",
        label: "Gibraltar",
        value: "Gibraltar",
        states: [
            {
                stateId: 1625,
                label: "Gibraltar",
                value: "Gibraltar",
                countryId: 179
            }
        ]
    },
    {
        countryId: 180,
        code: "GR",
        label: "Greece",
        value: "Greece",
        states: [
            {
                stateId: 1626,
                label: "Athens",
                value: "Athens",
                countryId: 180
            }
        ]
    },
    {
        countryId: 30,
        code: "GL",
        label: "Greenland",
        value: "Greenland",
        states: [
            {
                stateId: 1627,
                label: "Nuuk",
                value: "Nuuk",
                countryId: 181
            }
        ]
    },
    {
        countryId: 182,
        code: "GD",
        label: "Grenada",
        value: "Grenada",
        states: [
            {
                stateId: 1628,
                label: "Saint George's",
                value: "Saint George's",
                countryId: 182
            }
        ]
    },
    {
        countryId: 31,
        code: "GP",
        label: "Guadeloupe",
        value: "Guadeloupe",
        states: [
            {
                stateId: 434,
                label: "Guadeloupe",
                value: "Guadeloupe",
                countryId: 31
            }
        ]
    },
    {
        countryId: 32,
        code: "GU",
        label: "Guam",
        value: "Guam",
        states: [
            {
                stateId: 433,
                label: "Gu",
                value: "Gu",
                countryId: 32
            }
        ]
    },
    {
        countryId: 33,
        code: "GT",
        label: "Guatemala",
        value: "Guatemala",
        states: [
            {
                stateId: 269,
                label: "Ciudad de Guatemala",
                value: "Ciudad de Guatemala",
                countryId: 33
            },
            {
                stateId: 310,
                label: "DEPTO DE ALTA VERAPAZ",
                value: "DEPTO DE ALTA VERAPAZ",
                countryId: 33
            },
            {
                stateId: 311,
                label: "DEPTO DE BAJA VERAPAZ",
                value: "DEPTO DE BAJA VERAPAZ",
                countryId: 33
            },
            {
                stateId: 312,
                label: "DEPTO DE CHIMALTENANGO",
                value: "DEPTO DE CHIMALTENANGO",
                countryId: 33
            },
            {
                stateId: 313,
                label: "DEPTO DE CHIQUIMULA",
                value: "DEPTO DE CHIQUIMULA",
                countryId: 33
            },
            {
                stateId: 314,
                label: "DEPTO DE EL PROGRESO",
                value: "DEPTO DE EL PROGRESO",
                countryId: 33
            },
            {
                stateId: 315,
                label: "DEPTO DE ESCUINTLA",
                value: "DEPTO DE ESCUINTLA",
                countryId: 33
            },
            {
                stateId: 316,
                label: "DEPTO DE GUATEMALA",
                value: "DEPTO DE GUATEMALA",
                countryId: 33
            },
            {
                stateId: 317,
                label: "DEPTO DE HUEHUETENANGO",
                value: "DEPTO DE HUEHUETENANGO",
                countryId: 33
            },
            {
                stateId: 318,
                label: "DEPTO DE IZABAL",
                value: "DEPTO DE IZABAL",
                countryId: 33
            },
            {
                stateId: 319,
                label: "DEPTO DE JALAPA",
                value: "DEPTO DE JALAPA",
                countryId: 33
            },
            {
                stateId: 320,
                label: "DEPTO DE JUTIAPA",
                value: "DEPTO DE JUTIAPA",
                countryId: 33
            },
            {
                stateId: 321,
                label: "DEPTO DE PETEN",
                value: "DEPTO DE PETEN",
                countryId: 33
            },
            {
                stateId: 322,
                label: "DEPTO DE QUETZALTENANGO",
                value: "DEPTO DE QUETZALTENANGO",
                countryId: 33
            },
            {
                stateId: 323,
                label: "DEPTO DE RETALHULEU",
                value: "DEPTO DE RETALHULEU",
                countryId: 33
            },
            {
                stateId: 324,
                label: "DEPTO DE SACATEPEQUEZ",
                value: "DEPTO DE SACATEPEQUEZ",
                countryId: 33
            },
            {
                stateId: 325,
                label: "DEPTO DE SAN MARCOS",
                value: "DEPTO DE SAN MARCOS",
                countryId: 33
            },
            {
                stateId: 326,
                label: "DEPTO DE SANTA ROSA",
                value: "DEPTO DE SANTA ROSA",
                countryId: 33
            },
            {
                stateId: 327,
                label: "DEPTO DE SOLOLA",
                value: "DEPTO DE SOLOLA",
                countryId: 33
            },
            {
                stateId: 328,
                label: "DEPTO DE SUCHITEPEQUEZ",
                value: "DEPTO DE SUCHITEPEQUEZ",
                countryId: 33
            },
            {
                stateId: 329,
                label: "DEPTO DE TOTONICAPAN",
                value: "DEPTO DE TOTONICAPAN",
                countryId: 33
            },
            {
                stateId: 330,
                label: "DEPTO DE ZACAPA",
                value: "DEPTO DE ZACAPA",
                countryId: 33
            },
            {
                stateId: 331,
                label: "DEPTO DEL QUICHE",
                value: "DEPTO DEL QUICHE",
                countryId: 33
            }
        ]
    },
    {
        countryId: 34,
        code: "GG",
        label: "Guernsey",
        value: "Guernsey",
        states: [
            {
                stateId: 1629,
                label: "Saint Peter Port",
                value: "Saint Peter Port",
                countryId: 34
            }
        ]
    },
    {
        countryId: 187,
        code: "GN",
        label: "Guinea",
        value: "Guinea",
        states: [
            {
                stateId: 1630,
                label: "Conakry",
                value: "Conakry",
                countryId: 187
            }
        ]
    },
    {
        countryId: 188,
        code: "GW",
        label: "Guinea-Bissau",
        value: "Guinea-Bissau",
        states: [
            {
                stateId: 1631,
                label: "Bissau",
                value: "Bissau",
                countryId: 188
            }
        ]
    },
    {
        countryId: 189,
        code: "GY",
        label: "Guyana",
        value: "Guyana",
        states: [
            {
                stateId: 1632,
                label: "Georgetown",
                value: "Georgetown",
                countryId: 189
            }
        ]
    },
    {
        countryId: 190,
        code: "HT",
        label: "Haiti",
        value: "Haiti",
        states: [
            {
                stateId: 1633,
                label: "Port-au-Prince",
                value: "Port-au-Prince",
                countryId: 190
            }
        ]
    },
    // {
    //     countryId: 191,
    //     code: "HM",
    //     label: "Heard Island and McDonald Islands",
    //     value: "Heard Island and McDonald Islands",
    //     states: []
    // },
    {
        countryId: 193,
        code: "HN",
        label: "Honduras",
        value: "Honduras",
        states: [
            {
                stateId: 1634,
                label: "Tegucigalpa",
                value: "Tegucigalpa",
                countryId: 193
            }
        ]
    },
    {
        countryId: 194,
        code: "HK",
        label: "Hong Kong",
        value: "Hong Kong",
        states: [
            {
                stateId: 1635,
                label: "Hong Kong",
                value: "Hong Kong",
                countryId: 194
            }
        ]
    },
    {
        countryId: 35,
        code: "HU",
        label: "Hungary",
        value: "Hungary",
        states: [
            {
                stateId: 94,
                label: "Bács-Kiskun",
                value: "Bács-Kiskun",
                countryId: 35
            },
            {
                stateId: 114,
                label: "Baranya",
                value: "Baranya",
                countryId: 35
            },
            {
                stateId: 130,
                label: "Békés",
                value: "Békés",
                countryId: 35
            },
            {
                stateId: 153,
                label: "Borsod-Abaúj-Zemplén",
                value: "Borsod-Abaúj-Zemplén",
                countryId: 35
            },
            {
                stateId: 175,
                label: "Budapest",
                value: "Budapest",
                countryId: 35
            },
            {
                stateId: 295,
                label: "Csongrád",
                value: "Csongrád",
                countryId: 35
            },
            {
                stateId: 386,
                label: "Fejér",
                value: "Fejér",
                countryId: 35
            },
            {
                stateId: 451,
                label: "Győr-Moson-Sopron",
                value: "Győr-Moson-Sopron",
                countryId: 35
            },
            {
                stateId: 456,
                label: "Hajdú-Bihar",
                value: "Hajdú-Bihar",
                countryId: 35
            },
            {
                stateId: 471,
                label: "Heves",
                value: "Heves",
                countryId: 35
            },
            {
                stateId: 545,
                label: "Jász-Nagykun-Szolnok",
                value: "Jász-Nagykun-Szolnok",
                countryId: 35
            },
            {
                stateId: 629,
                label: "Komárom-Esztergom",
                value: "Komárom-Esztergom",
                countryId: 35
            },
            {
                stateId: 852,
                label: "Nógrád",
                value: "Nógrád",
                countryId: 35
            },
            {
                stateId: 946,
                label: "Pest",
                value: "Pest",
                countryId: 35
            },
            {
                stateId: 1187,
                label: "Somogy",
                value: "Somogy",
                countryId: 35
            },
            {
                stateId: 1229,
                label: "Szabolcs-Szatmár-Bereg",
                value: "Szabolcs-Szatmár-Bereg",
                countryId: 35
            },
            {
                stateId: 1284,
                label: "Tolna",
                value: "Tolna",
                countryId: 35
            },
            {
                stateId: 1338,
                label: "Vas",
                value: "Vas",
                countryId: 35
            },
            {
                stateId: 1355,
                label: "Veszprém",
                value: "Veszprém",
                countryId: 35
            },
            {
                stateId: 1422,
                label: "Zala",
                value: "Zala",
                countryId: 35
            }
        ]
    },
    {
        countryId: 36,
        code: "IS",
        label: "Iceland",
        value: "Iceland",
        states: [
            {
                stateId: 1636,
                label: "Reykjavík",
                value: "Reykjavík",
                countryId: 36
            }
        ]
    },
    {
        countryId: 1,
        code: "IN",
        label: "India",
        value: "India",
        states: [
            {
                stateId: 1740,
                label: "New Delhi",
                value: "New Delhi",
                countryId: 1
            }
        ]
    },
    {
        countryId: 198,
        code: "ID",
        label: "Indonesia",
        value: "Indonesia",
        states: [
            {
                stateId: 1637,
                label: "Jakarta",
                value: "Jakarta",
                countryId: 198
            }
        ]
    },
    {
        countryId: 200,
        code: "IR",
        label: "Iran (Islamic Republic of)",
        value: "Iran (Islamic Republic of)",
        states: [
            {
                stateId: 1638,
                label: "Tehran",
                value: "Tehran",
                countryId: 200
            }
        ]
    },
    {
        countryId: 201,
        code: "IQ",
        label: "Iraq",
        value: "Iraq",
        states: [
            {
                stateId: 1639,
                label: "Baghdad",
                value: "Baghdad",
                countryId: 201
            }
        ]
    },
    {
        countryId: 38,
        code: "IE",
        label: "Ireland",
        value: "Ireland",
        states: [
            {
                stateId: 1640,
                label: "Dublin",
                value: "Dublin",
                countryId: 38
            }
        ]
    },
    {
        countryId: 39,
        code: "IM",
        label: "Isle Of Man",
        value: "Isle Of Man",
        states: [
            {
                stateId: 1641,
                label: "Douglas",
                value: "Douglas",
                countryId: 39
            }
        ]
    },
    {
        countryId: 204,
        code: "IL",
        label: "Israel",
        value: "Israel",
        states: [
            {
                stateId: 1642,
                label: "Jerusalem",
                value: "Jerusalem",
                countryId: 204
            }
        ]
    },
    {
        countryId: 40,
        code: "IT",
        label: "Italy",
        value: "Italy",
        states: [
            {
                stateId: 3,
                label: "Abruzzi",
                value: "Abruzzi",
                countryId: 40
            },
            {
                stateId: 119,
                label: "Basilicata",
                value: "Basilicata",
                countryId: 40
            },
            {
                stateId: 188,
                label: "Calabria",
                value: "Calabria",
                countryId: 40
            },
            {
                stateId: 194,
                label: "Campania",
                value: "Campania",
                countryId: 40
            },
            {
                stateId: 367,
                label: "Emilia-Romagna",
                value: "Emilia-Romagna",
                countryId: 40
            },
            {
                stateId: 396,
                label: "Friuli-Venezia Giulia",
                value: "Friuli-Venezia Giulia",
                countryId: 40
            },
            {
                stateId: 682,
                label: "Lazio",
                value: "Lazio",
                countryId: 40
            },
            {
                stateId: 692,
                label: "Liguria",
                value: "Liguria",
                countryId: 40
            },
            {
                stateId: 700,
                label: "Lombardia",
                value: "Lombardia",
                countryId: 40
            },
            {
                stateId: 736,
                label: "Marche",
                value: "Marche",
                countryId: 40
            },
            {
                stateId: 790,
                label: "Molise",
                value: "Molise",
                countryId: 40
            },
            {
                stateId: 957,
                label: "Piemonte",
                value: "Piemonte",
                countryId: 40
            },
            {
                stateId: 992,
                label: "Puglia",
                value: "Puglia",
                countryId: 40
            },
            {
                stateId: 1140,
                label: "Sardegna",
                value: "Sardegna",
                countryId: 40
            },
            {
                stateId: 1162,
                label: "Sicilia",
                value: "Sicilia",
                countryId: 40
            },
            {
                stateId: 1285,
                label: "Toscana",
                value: "Toscana",
                countryId: 40
            },
            {
                stateId: 1294,
                label: "Trentino-Alto Adige",
                value: "Trentino-Alto Adige",
                countryId: 40
            },
            {
                stateId: 1312,
                label: "Umbria",
                value: "Umbria",
                countryId: 40
            },
            {
                stateId: 1331,
                label: "Valle D'Aosta",
                value: "Valle D'Aosta",
                countryId: 40
            },
            {
                stateId: 1349,
                label: "Veneto",
                value: "Veneto",
                countryId: 40
            }
        ]
    },
    {
        countryId: 206,
        code: "JM",
        label: "Jamaica",
        value: "Jamaica",
        states: [
            {
                stateId: 1643,
                label: "Kingston",
                value: "Kingston",
                countryId: 206
            }
        ]
    },
    {
        countryId: 41,
        code: "JP",
        label: "Japan",
        value: "Japan",
        states: [
            {
                stateId: 25,
                label: "Aichi Ken",
                value: "Aichi Ken",
                countryId: 41
            },
            {
                stateId: 31,
                label: "Akita Ken",
                value: "Akita Ken",
                countryId: 41
            },
            {
                stateId: 63,
                label: "Aomori Ken",
                value: "Aomori Ken",
                countryId: 41
            },
            {
                stateId: 252,
                label: "Chiba Ken",
                value: "Chiba Ken",
                countryId: 41
            },
            {
                stateId: 362,
                label: "Ehime Ken",
                value: "Ehime Ken",
                countryId: 41
            },
            {
                stateId: 397,
                label: "Fukui Ken",
                value: "Fukui Ken",
                countryId: 41
            },
            {
                stateId: 398,
                label: "Fukuoka Ken",
                value: "Fukuoka Ken",
                countryId: 41
            },
            {
                stateId: 399,
                label: "Fukushima Ken",
                value: "Fukushima Ken",
                countryId: 41
            },
            {
                stateId: 411,
                label: "Gifu Ken",
                value: "Gifu Ken",
                countryId: 41
            },
            {
                stateId: 447,
                label: "Gumma Ken",
                value: "Gumma Ken",
                countryId: 41
            },
            {
                stateId: 476,
                label: "Hiroshima Ken",
                value: "Hiroshima Ken",
                countryId: 41
            },
            {
                stateId: 478,
                label: "Hokkaido",
                value: "Hokkaido",
                countryId: 41
            },
            {
                stateId: 485,
                label: "Hyogo Ken",
                value: "Hyogo Ken",
                countryId: 41
            },
            {
                stateId: 489,
                label: "Ibaraki Ken",
                value: "Ibaraki Ken",
                countryId: 41
            },
            {
                stateId: 526,
                label: "Ishikawa Ken",
                value: "Ishikawa Ken",
                countryId: 41
            },
            {
                stateId: 532,
                label: "Iwate Ken",
                value: "Iwate Ken",
                countryId: 41
            },
            {
                stateId: 563,
                label: "Kagawa Ken",
                value: "Kagawa Ken",
                countryId: 41
            },
            {
                stateId: 564,
                label: "Kagoshima Ken",
                value: "Kagoshima Ken",
                countryId: 41
            },
            {
                stateId: 570,
                label: "Kanagawa Ken",
                value: "Kanagawa Ken",
                countryId: 41
            },
            {
                stateId: 627,
                label: "Kochi Ken",
                value: "Kochi Ken",
                countryId: 41
            },
            {
                stateId: 645,
                label: "Kumamoto Ken",
                value: "Kumamoto Ken",
                countryId: 41
            },
            {
                stateId: 651,
                label: "Kyoto Fu",
                value: "Kyoto Fu",
                countryId: 41
            },
            {
                stateId: 774,
                label: "Mie Ken",
                value: "Mie Ken",
                countryId: 41
            },
            {
                stateId: 784,
                label: "Miyagi Ken",
                value: "Miyagi Ken",
                countryId: 41
            },
            {
                stateId: 785,
                label: "Miyazaki Ken",
                value: "Miyazaki Ken",
                countryId: 41
            },
            {
                stateId: 811,
                label: "Nagano Ken",
                value: "Nagano Ken",
                countryId: 41
            },
            {
                stateId: 812,
                label: "Nagasaki Ken",
                value: "Nagasaki Ken",
                countryId: 41
            },
            {
                stateId: 821,
                label: "Nara Ken",
                value: "Nara Ken",
                countryId: 41
            },
            {
                stateId: 849,
                label: "Niigata Ken",
                value: "Niigata Ken",
                countryId: 41
            },
            {
                stateId: 891,
                label: "Oita Ken",
                value: "Oita Ken",
                countryId: 41
            },
            {
                stateId: 892,
                label: "Okayama Ken",
                value: "Okayama Ken",
                countryId: 41
            },
            {
                stateId: 893,
                label: "Okinawa Ken",
                value: "Okinawa Ken",
                countryId: 41
            },
            {
                stateId: 908,
                label: "Osaka Fu",
                value: "Osaka Fu",
                countryId: 41
            },
            {
                stateId: 1088,
                label: "Saga Ken",
                value: "Saga Ken",
                countryId: 41
            },
            {
                stateId: 1100,
                label: "Saitama Ken",
                value: "Saitama Ken",
                countryId: 41
            },
            {
                stateId: 1155,
                label: "Shiga Ken",
                value: "Shiga Ken",
                countryId: 41
            },
            {
                stateId: 1156,
                label: "Shimane Ken",
                value: "Shimane Ken",
                countryId: 41
            },
            {
                stateId: 1157,
                label: "Shizuoka Ken",
                value: "Shizuoka Ken",
                countryId: 41
            },
            {
                stateId: 1279,
                label: "Tochigi Ken",
                value: "Tochigi Ken",
                countryId: 41
            },
            {
                stateId: 1281,
                label: "Tokushima Ken",
                value: "Tokushima Ken",
                countryId: 41
            },
            {
                stateId: 1282,
                label: "Tokyo To",
                value: "Tokyo To",
                countryId: 41
            },
            {
                stateId: 1286,
                label: "Tottori Ken",
                value: "Tottori Ken",
                countryId: 41
            },
            {
                stateId: 1288,
                label: "Toyama Ken",
                value: "Toyama Ken",
                countryId: 41
            },
            {
                stateId: 1383,
                label: "Wakayama Ken",
                value: "Wakayama Ken",
                countryId: 41
            },
            {
                stateId: 1408,
                label: "Yamagata Ken",
                value: "Yamagata Ken",
                countryId: 41
            },
            {
                stateId: 1409,
                label: "Yamaguchi Ken",
                value: "Yamaguchi Ken",
                countryId: 41
            },
            {
                stateId: 1410,
                label: "Yamanashi Ken",
                value: "Yamanashi Ken",
                countryId: 41
            }
        ]
    },
    {
        countryId: 42,
        code: "JE",
        label: "Jersey",
        value: "Jersey",
        states: [
            {
                stateId: 1644,
                label: "Saint Helier",
                value: "Saint Helier",
                countryId: 42
            }
        ]
    },
    {
        countryId: 209,
        code: "JO",
        label: "Jordan",
        value: "Jordan",
        states: [
            {
                stateId: 1645,
                label: "Amman",
                value: "Amman",
                countryId: 209
            }
        ]
    },
    {
        countryId: 210,
        code: "KZ",
        label: "Kazakhstan",
        value: "Kazakhstan",
        states: [
            {
                stateId: 1646,
                label: "Nursultan",
                value: "Nursultan",
                countryId: 210
            }
        ]
    },
    {
        countryId: 211,
        code: "KE",
        label: "Kenya",
        value: "Kenya",
        states: [
            {
                stateId: 1647,
                label: "Nairobi",
                value: "Nairobi",
                countryId: 211
            }
        ]
    },
    {
        countryId: 212,
        code: "KI",
        label: "Kiribati",
        value: "Kiribati",
        states: [
            {
                stateId: 1648,
                label: "Tarawa",
                value: "Tarawa",
                countryId: 212
            }
        ]
    },
    {
        countryId: 258,
        code: "KP",
        label: "Korea (Democratic People's Republic of)",
        value: "Korea (Democratic People's Republic of)",
        states: [
            {
                stateId: 1649,
                label: "Pyongyang",
                value: "Pyongyang",
                countryId: 258
            }
        ]
    },
    {
        countryId: 213,
        code: "KW",
        label: "Kuwait",
        value: "Kuwait",
        states: [
            {
                stateId: 1650,
                label: "Kuwait City",
                value: "Kuwait City",
                countryId: 213
            }
        ]
    },
    {
        countryId: 214,
        code: "KG",
        label: "Kyrgyzstan",
        value: "Kyrgyzstan",
        states: [
            {
                stateId: 1651,
                label: "Bishkek",
                value: "Bishkek",
                countryId: 214
            }
        ]
    },
    {
        countryId: 215,
        code: "LA",
        label: "Lao People's Democratic Republic",
        value: "Lao People's Democratic Republic",
        states: [
            {
                stateId: 1652,
                label: "Vientiane",
                value: "Vientiane",
                countryId: 215
            }
        ]
    },
    {
        countryId: 43,
        code: "LV",
        label: "Latvia",
        value: "Latvia",
        states: [
            {
                stateId: 8,
                label: "Ādažu nov.",
                value: "Ādažu nov.",
                countryId: 43
            },
            {
                stateId: 16,
                label: "Aglonas nov.",
                value: "Aglonas nov.",
                countryId: 43
            },
            {
                stateId: 28,
                label: "Aizkraukles nov.",
                value: "Aizkraukles nov.",
                countryId: 43
            },
            {
                stateId: 29,
                label: "Aizputes nov.",
                value: "Aizputes nov.",
                countryId: 43
            },
            {
                stateId: 32,
                label: "Aknīstes nov.",
                value: "Aknīstes nov.",
                countryId: 43
            },
            {
                stateId: 42,
                label: "Alojas nov.",
                value: "Alojas nov.",
                countryId: 43
            },
            {
                stateId: 43,
                label: "Alsungas nov.",
                value: "Alsungas nov.",
                countryId: 43
            },
            {
                stateId: 44,
                label: "Alūksnes nov.",
                value: "Alūksnes nov.",
                countryId: 43
            },
            {
                stateId: 48,
                label: "Amatas nov.",
                value: "Amatas nov.",
                countryId: 43
            },
            {
                stateId: 64,
                label: "Apes nov.",
                value: "Apes nov.",
                countryId: 43
            },
            {
                stateId: 84,
                label: "Auces nov.",
                value: "Auces nov.",
                countryId: 43
            },
            {
                stateId: 92,
                label: "Babītes nov.",
                value: "Babītes nov.",
                countryId: 43
            },
            {
                stateId: 101,
                label: "Baldones nov.",
                value: "Baldones nov.",
                countryId: 43
            },
            {
                stateId: 106,
                label: "Baltinavas nov.",
                value: "Baltinavas nov.",
                countryId: 43
            },
            {
                stateId: 107,
                label: "Balvu nov.",
                value: "Balvu nov.",
                countryId: 43
            },
            {
                stateId: 122,
                label: "Bauskas nov.",
                value: "Bauskas nov.",
                countryId: 43
            },
            {
                stateId: 133,
                label: "Beverīnas nov.",
                value: "Beverīnas nov.",
                countryId: 43
            },
            {
                stateId: 171,
                label: "Brocēnu nov.",
                value: "Brocēnu nov.",
                countryId: 43
            },
            {
                stateId: 181,
                label: "Burtnieku nov.",
                value: "Burtnieku nov.",
                countryId: 43
            },
            {
                stateId: 215,
                label: "Carnikavas nov.",
                value: "Carnikavas nov.",
                countryId: 43
            },
            {
                stateId: 236,
                label: "Cēsu nov.",
                value: "Cēsu nov.",
                countryId: 43
            },
            {
                stateId: 237,
                label: "Cesvaines nov.",
                value: "Cesvaines nov.",
                countryId: 43
            },
            {
                stateId: 263,
                label: "Ciblas nov.",
                value: "Ciblas nov.",
                countryId: 43
            },
            {
                stateId: 300,
                label: "Dagdas nov.",
                value: "Dagdas nov.",
                countryId: 43
            },
            {
                stateId: 305,
                label: "Daugavpils nov.",
                value: "Daugavpils nov.",
                countryId: 43
            },
            {
                stateId: 342,
                label: "Dobeles nov.",
                value: "Dobeles nov.",
                countryId: 43
            },
            {
                stateId: 352,
                label: "Dundagas nov.",
                value: "Dundagas nov.",
                countryId: 43
            },
            {
                stateId: 355,
                label: "Durbes nov.",
                value: "Durbes nov.",
                countryId: 43
            },
            {
                stateId: 370,
                label: "Engures nov.",
                value: "Engures nov.",
                countryId: 43
            },
            {
                stateId: 372,
                label: "Ērgļu nov.",
                value: "Ērgļu nov.",
                countryId: 43
            },
            {
                stateId: 404,
                label: "Garkalnes nov.",
                value: "Garkalnes nov.",
                countryId: 43
            },
            {
                stateId: 429,
                label: "Grobiņas nov.",
                value: "Grobiņas nov.",
                countryId: 43
            },
            {
                stateId: 446,
                label: "Gulbenes nov.",
                value: "Gulbenes nov.",
                countryId: 43
            },
            {
                stateId: 492,
                label: "Iecavas nov.",
                value: "Iecavas nov.",
                countryId: 43
            },
            {
                stateId: 494,
                label: "Ikšķiles nov.",
                value: "Ikšķiles nov.",
                countryId: 43
            },
            {
                stateId: 515,
                label: "Ilūkstes nov.",
                value: "Ilūkstes nov.",
                countryId: 43
            },
            {
                stateId: 519,
                label: "Inčukalna nov.",
                value: "Inčukalna nov.",
                countryId: 43
            },
            {
                stateId: 546,
                label: "Jaunjelgavas nov.",
                value: "Jaunjelgavas nov.",
                countryId: 43
            },
            {
                stateId: 547,
                label: "Jaunpiebalgas nov.",
                value: "Jaunpiebalgas nov.",
                countryId: 43
            },
            {
                stateId: 548,
                label: "Jaunpils nov.",
                value: "Jaunpils nov.",
                countryId: 43
            },
            {
                stateId: 550,
                label: "Jēkabpils nov.",
                value: "Jēkabpils nov.",
                countryId: 43
            },
            {
                stateId: 551,
                label: "Jelgavas nov.",
                value: "Jelgavas nov.",
                countryId: 43
            },
            {
                stateId: 572,
                label: "Kandavas nov.",
                value: "Kandavas nov.",
                countryId: 43
            },
            {
                stateId: 601,
                label: "Kārsavas nov.",
                value: "Kārsavas nov.",
                countryId: 43
            },
            {
                stateId: 606,
                label: "Ķeguma nov.",
                value: "Ķeguma nov.",
                countryId: 43
            },
            {
                stateId: 607,
                label: "Ķekavas nov.",
                value: "Ķekavas nov.",
                countryId: 43
            },
            {
                stateId: 626,
                label: "Kocēnu nov.",
                value: "Kocēnu nov.",
                countryId: 43
            },
            {
                stateId: 628,
                label: "Kokneses nov.",
                value: "Kokneses nov.",
                countryId: 43
            },
            {
                stateId: 638,
                label: "Krāslavas nov.",
                value: "Krāslavas nov.",
                countryId: 43
            },
            {
                stateId: 639,
                label: "Krimuldas nov.",
                value: "Krimuldas nov.",
                countryId: 43
            },
            {
                stateId: 641,
                label: "Krustpils nov.",
                value: "Krustpils nov.",
                countryId: 43
            },
            {
                stateId: 644,
                label: "Kuldīgas nov.",
                value: "Kuldīgas nov.",
                countryId: 43
            },
            {
                stateId: 690,
                label: "Lielvārdes nov.",
                value: "Lielvārdes nov.",
                countryId: 43
            },
            {
                stateId: 691,
                label: "Līgatnes nov.",
                value: "Līgatnes nov.",
                countryId: 43
            },
            {
                stateId: 694,
                label: "Limbažu nov.",
                value: "Limbažu nov.",
                countryId: 43
            },
            {
                stateId: 697,
                label: "Līvānu nov.",
                value: "Līvānu nov.",
                countryId: 43
            },
            {
                stateId: 704,
                label: "Lubānas nov.",
                value: "Lubānas nov.",
                countryId: 43
            },
            {
                stateId: 707,
                label: "Ludzas nov.",
                value: "Ludzas nov.",
                countryId: 43
            },
            {
                stateId: 718,
                label: "Madonas nov.",
                value: "Madonas nov.",
                countryId: 43
            },
            {
                stateId: 727,
                label: "Mālpils nov.",
                value: "Mālpils nov.",
                countryId: 43
            },
            {
                stateId: 745,
                label: "Mārupes nov.",
                value: "Mārupes nov.",
                countryId: 43
            },
            {
                stateId: 757,
                label: "Mazsalacas nov.",
                value: "Mazsalacas nov.",
                countryId: 43
            },
            {
                stateId: 767,
                label: "Mērsraga nov.",
                value: "Mērsraga nov.",
                countryId: 43
            },
            {
                stateId: 825,
                label: "Naukšēnu nov.",
                value: "Naukšēnu nov.",
                countryId: 43
            },
            {
                stateId: 833,
                label: "Neretas nov.",
                value: "Neretas nov.",
                countryId: 43
            },
            {
                stateId: 845,
                label: "Nīcas nov.",
                value: "Nīcas nov.",
                countryId: 43
            },
            {
                stateId: 888,
                label: "Ogres nov.",
                value: "Ogres nov.",
                countryId: 43
            },
            {
                stateId: 895,
                label: "Olaines nov.",
                value: "Olaines nov.",
                countryId: 43
            },
            {
                stateId: 919,
                label: "Ozolnieku nov.",
                value: "Ozolnieku nov.",
                countryId: 43
            },
            {
                stateId: 931,
                label: "Pārgaujas nov.",
                value: "Pārgaujas nov.",
                countryId: 43
            },
            {
                stateId: 936,
                label: "Pāvilostas nov.",
                value: "Pāvilostas nov.",
                countryId: 43
            },
            {
                stateId: 960,
                label: "Pļaviņu nov.",
                value: "Pļaviņu nov.",
                countryId: 43
            },
            {
                stateId: 974,
                label: "Preiļu nov.",
                value: "Preiļu nov.",
                countryId: 43
            },
            {
                stateId: 976,
                label: "Priekules nov.",
                value: "Priekules nov.",
                countryId: 43
            },
            {
                stateId: 977,
                label: "Priekuļu nov.",
                value: "Priekuļu nov.",
                countryId: 43
            },
            {
                stateId: 1017,
                label: "Raunas nov.",
                value: "Raunas nov.",
                countryId: 43
            },
            {
                stateId: 1044,
                label: "Rēzeknes nov.",
                value: "Rēzeknes nov.",
                countryId: 43
            },
            {
                stateId: 1049,
                label: "Riebiņu nov.",
                value: "Riebiņu nov.",
                countryId: 43
            },
            {
                stateId: 1065,
                label: "Rojas nov.",
                value: "Rojas nov.",
                countryId: 43
            },
            {
                stateId: 1067,
                label: "Ropažu nov.",
                value: "Ropažu nov.",
                countryId: 43
            },
            {
                stateId: 1070,
                label: "Rucavas nov.",
                value: "Rucavas nov.",
                countryId: 43
            },
            {
                stateId: 1071,
                label: "Rugāju nov.",
                value: "Rugāju nov.",
                countryId: 43
            },
            {
                stateId: 1073,
                label: "Rūjienas nov.",
                value: "Rūjienas nov.",
                countryId: 43
            },
            {
                stateId: 1074,
                label: "Rundāles nov.",
                value: "Rundāles nov.",
                countryId: 43
            },
            {
                stateId: 1104,
                label: "Salas nov.",
                value: "Salas nov.",
                countryId: 43
            },
            {
                stateId: 1105,
                label: "Salaspils nov.",
                value: "Salaspils nov.",
                countryId: 43
            },
            {
                stateId: 1106,
                label: "Saldus nov.",
                value: "Saldus nov.",
                countryId: 43
            },
            {
                stateId: 1145,
                label: "Saulkrastu nov.",
                value: "Saulkrastu nov.",
                countryId: 43
            },
            {
                stateId: 1150,
                label: "Sējas nov.",
                value: "Sējas nov.",
                countryId: 43
            },
            {
                stateId: 1164,
                label: "Siguldas nov.",
                value: "Siguldas nov.",
                countryId: 43
            },
            {
                stateId: 1179,
                label: "Skrīveru nov.",
                value: "Skrīveru nov.",
                countryId: 43
            },
            {
                stateId: 1180,
                label: "Skrundas nov.",
                value: "Skrundas nov.",
                countryId: 43
            },
            {
                stateId: 1182,
                label: "Smiltenes nov.",
                value: "Smiltenes nov.",
                countryId: 43
            },
            {
                stateId: 1213,
                label: "Stopiņu nov.",
                value: "Stopiņu nov.",
                countryId: 43
            },
            {
                stateId: 1216,
                label: "Strenču nov.",
                value: "Strenču nov.",
                countryId: 43
            },
            {
                stateId: 1236,
                label: "Talsu nov.",
                value: "Talsu nov.",
                countryId: 43
            },
            {
                stateId: 1260,
                label: "Tērvetes nov.",
                value: "Tērvetes nov.",
                countryId: 43
            },
            {
                stateId: 1304,
                label: "Tukuma nov.",
                value: "Tukuma nov.",
                countryId: 43
            },
            {
                stateId: 1327,
                label: "Vaiņodes nov.",
                value: "Vaiņodes nov.",
                countryId: 43
            },
            {
                stateId: 1330,
                label: "Valkas nov.",
                value: "Valkas nov.",
                countryId: 43
            },
            {
                stateId: 1334,
                label: "Varakļānu nov.",
                value: "Varakļānu nov.",
                countryId: 43
            },
            {
                stateId: 1336,
                label: "Vārkavas nov.",
                value: "Vārkavas nov.",
                countryId: 43
            },
            {
                stateId: 1345,
                label: "Vecpiebalgas nov.",
                value: "Vecpiebalgas nov.",
                countryId: 43
            },
            {
                stateId: 1346,
                label: "Vecumnieku nov.",
                value: "Vecumnieku nov.",
                countryId: 43
            },
            {
                stateId: 1350,
                label: "Ventspils nov.",
                value: "Ventspils nov.",
                countryId: 43
            },
            {
                stateId: 1363,
                label: "Viesītes nov.",
                value: "Viesītes nov.",
                countryId: 43
            },
            {
                stateId: 1365,
                label: "Viļakas nov.",
                value: "Viļakas nov.",
                countryId: 43
            },
            {
                stateId: 1366,
                label: "Viļānu nov.",
                value: "Viļānu nov.",
                countryId: 43
            },
            {
                stateId: 1428,
                label: "Zilupes nov.",
                value: "Zilupes nov.",
                countryId: 43
            }
        ]
    },
    {
        countryId: 217,
        code: "LB",
        label: "Lebanon",
        value: "Lebanon",
        states: [
            {
                stateId: 1653,
                label: "Beirut",
                value: "Beirut",
                countryId: 217
            }
        ]
    },
    {
        countryId: 218,
        code: "LS",
        label: "Lesotho",
        value: "Lesotho",
        states: [
            {
                stateId: 1654,
                label: "Maseru",
                value: "Maseru",
                countryId: 218
            }
        ]
    },
    {
        countryId: 219,
        code: "LR",
        label: "Liberia",
        value: "Liberia",
        states: [
            {
                stateId: 1655,
                label: "Monrovia",
                value: "Monrovia",
                countryId: 219
            }
        ]
    },
    {
        countryId: 220,
        code: "LY",
        label: "Libya",
        value: "Libya",
        states: [
            {
                stateId: 1741,
                label: "Tripoli",
                value: "Tripoli",
                countryId: 220
            }
        ]
    },
    {
        countryId: 44,
        code: "LI",
        label: "Liechtenstein",
        value: "Liechtenstein",
        states: [
            {
                stateId: 109,
                label: "Balzers",
                value: "Balzers",
                countryId: 44
            },
            {
                stateId: 377,
                label: "Eschen",
                value: "Eschen",
                countryId: 44
            },
            {
                stateId: 403,
                label: "Gamprin",
                value: "Gamprin",
                countryId: 44
            },
            {
                stateId: 753,
                label: "Mauren",
                value: "Mauren",
                countryId: 44
            },
            {
                stateId: 959,
                label: "Planken",
                value: "Planken",
                countryId: 44
            },
            {
                stateId: 1072,
                label: "Ruggell",
                value: "Ruggell",
                countryId: 44
            },
            {
                stateId: 1146,
                label: "Schaan",
                value: "Schaan",
                countryId: 44
            },
            {
                stateId: 1147,
                label: "Schellenberg",
                value: "Schellenberg",
                countryId: 44
            },
            {
                stateId: 1295,
                label: "Triesen",
                value: "Triesen",
                countryId: 44
            },
            {
                stateId: 1296,
                label: "Triesenberg",
                value: "Triesenberg",
                countryId: 44
            },
            {
                stateId: 1326,
                label: "Vaduz",
                value: "Vaduz",
                countryId: 44
            }
        ]
    },
    {
        countryId: 45,
        code: "LT",
        label: "Lithuania",
        value: "Lithuania",
        states: [
            {
                stateId: 45,
                label: "Alytus County",
                value: "Alytus County",
                countryId: 45
            },
            {
                stateId: 603,
                label: "Kaunas County",
                value: "Kaunas County",
                countryId: 45
            },
            {
                stateId: 624,
                label: "Klaipėda County",
                value: "Klaipėda County",
                countryId: 45
            },
            {
                stateId: 740,
                label: "Marijampolė County",
                value: "Marijampolė County",
                countryId: 45
            },
            {
                stateId: 925,
                label: "Panevėžys",
                value: "Panevėžys",
                countryId: 45
            },
            {
                stateId: 1159,
                label: "Šiauliai County",
                value: "Šiauliai County",
                countryId: 45
            },
            {
                stateId: 1247,
                label: "Tauragė County",
                value: "Tauragė County",
                countryId: 45
            },
            {
                stateId: 1256,
                label: "Telšių apskritis",
                value: "Telšių apskritis",
                countryId: 45
            },
            {
                stateId: 1318,
                label: "Utena County",
                value: "Utena County",
                countryId: 45
            },
            {
                stateId: 1369,
                label: "Vilniaus apskritis",
                value: "Vilniaus apskritis",
                countryId: 45
            }
        ]
    },
    {
        countryId: 46,
        code: "LU",
        label: "Luxembourg",
        value: "Luxembourg",
        states: [
            {
                stateId: 212,
                label: "Capellen",
                value: "Capellen",
                countryId: 46
            },
            {
                stateId: 270,
                label: "Clervaux",
                value: "Clervaux",
                countryId: 46
            },
            {
                stateId: 334,
                label: "Diekirch",
                value: "Diekirch",
                countryId: 46
            },
            {
                stateId: 359,
                label: "Echternach",
                value: "Echternach",
                countryId: 46
            },
            {
                stateId: 376,
                label: "Esch-sur-Alzette",
                value: "Esch-sur-Alzette",
                countryId: 46
            },
            {
                stateId: 427,
                label: "Grevenmacher",
                value: "Grevenmacher",
                countryId: 46
            },
            {
                stateId: 711,
                label: "Luxembourg",
                value: "Luxembourg",
                countryId: 46
            },
            {
                stateId: 765,
                label: "Mersch",
                value: "Mersch",
                countryId: 46
            },
            {
                stateId: 1019,
                label: "Redange",
                value: "Redange",
                countryId: 46
            },
            {
                stateId: 1041,
                label: "Remich",
                value: "Remich",
                countryId: 46
            },
            {
                stateId: 1358,
                label: "Vianden",
                value: "Vianden",
                countryId: 46
            },
            {
                stateId: 1397,
                label: "Wiltz",
                value: "Wiltz",
                countryId: 46
            }
        ]
    },
    {
        countryId: 224,
        code: "MO",
        label: "Macao",
        value: "Macao",
        states: [
            {
                stateId: 1656,
                label: "Concelho de Macau",
                value: "Concelho de Macau",
                countryId: 224
            }
        ]
    },
    {
        countryId: 226,
        code: "MG",
        label: "Madagascar",
        value: "Madagascar",
        states: [
            {
                stateId: 1657,
                label: "Antananarivo",
                value: "Antananarivo",
                countryId: 226
            }
        ]
    },
    {
        countryId: 47,
        code: "MW",
        label: "Malawi",
        value: "Malawi",
        states: [
            {
                stateId: 232,
                label: "Central Region",
                value: "Central Region",
                countryId: 47
            },
            {
                stateId: 872,
                label: "Northern Region",
                value: "Northern Region",
                countryId: 47
            },
            {
                stateId: 1201,
                label: "Southern Region",
                value: "Southern Region",
                countryId: 47
            }
        ]
    },
    {
        countryId: 48,
        code: "MY",
        label: "Malaysia",
        value: "Malaysia",
        states: [
            {
                stateId: 557,
                label: "Johor",
                value: "Johor",
                countryId: 48
            },
            {
                stateId: 605,
                label: "Kedah",
                value: "Kedah",
                countryId: 48
            },
            {
                stateId: 608,
                label: "Kelantan",
                value: "Kelantan",
                countryId: 48
            },
            {
                stateId: 642,
                label: "Kuala Lumpur",
                value: "Kuala Lumpur",
                countryId: 48
            },
            {
                stateId: 670,
                label: "Labuan",
                value: "Labuan",
                countryId: 48
            },
            {
                stateId: 762,
                label: "Melaka",
                value: "Melaka",
                countryId: 48
            },
            {
                stateId: 831,
                label: "Negeri Sembilan",
                value: "Negeri Sembilan",
                countryId: 48
            },
            {
                stateId: 921,
                label: "Pahang",
                value: "Pahang",
                countryId: 48
            },
            {
                stateId: 943,
                label: "Perak",
                value: "Perak",
                countryId: 48
            },
            {
                stateId: 944,
                label: "Perlis",
                value: "Perlis",
                countryId: 48
            },
            {
                stateId: 993,
                label: "Pulau Pinang",
                value: "Pulau Pinang",
                countryId: 48
            },
            {
                stateId: 995,
                label: "Putrajaya",
                value: "Putrajaya",
                countryId: 48
            },
            {
                stateId: 1079,
                label: "Sabah",
                value: "Sabah",
                countryId: 48
            },
            {
                stateId: 1139,
                label: "Sarawak",
                value: "Sarawak",
                countryId: 48
            },
            {
                stateId: 1151,
                label: "Selangor",
                value: "Selangor",
                countryId: 48
            },
            {
                stateId: 1258,
                label: "Terengganu",
                value: "Terengganu",
                countryId: 48
            }
        ]
    },
    {
        countryId: 229,
        code: "MV",
        label: "Maldives",
        value: "Maldives",
        states: [
            {
                stateId: 1658,
                label: "Malé",
                value: "Malé",
                countryId: 229
            }
        ]
    },
    {
        countryId: 230,
        code: "ML",
        label: "Mali",
        value: "Mali",
        states: [
            {
                stateId: 1659,
                label: "Bamako",
                value: "Bamako",
                countryId: 230
            }
        ]
    },
    {
        countryId: 49,
        code: "MT",
        label: "Malta",
        value: "Malta",
        states: [
            {
                stateId: 83,
                label: "Attard",
                value: "Attard",
                countryId: 49
            },
            {
                stateId: 108,
                label: "Balzan",
                value: "Balzan",
                countryId: 49
            },
            {
                stateId: 140,
                label: "Birkirkara",
                value: "Birkirkara",
                countryId: 49
            },
            {
                stateId: 141,
                label: "Birżebbuġa",
                value: "Birżebbuġa",
                countryId: 49
            },
            {
                stateId: 152,
                label: "Bormla",
                value: "Bormla",
                countryId: 49
            },
            {
                stateId: 335,
                label: "Dingli",
                value: "Dingli",
                countryId: 49
            },
            {
                stateId: 452,
                label: "Għajnsielem",
                value: "Għajnsielem",
                countryId: 49
            },
            {
                stateId: 495,
                label: "Il-Belt Valletta",
                value: "Il-Belt Valletta",
                countryId: 49
            },
            {
                stateId: 496,
                label: "Il-Birgu",
                value: "Il-Birgu",
                countryId: 49
            },
            {
                stateId: 497,
                label: "Il-Fgura",
                value: "Il-Fgura",
                countryId: 49
            },
            {
                stateId: 498,
                label: "Il-Fontana",
                value: "Il-Fontana",
                countryId: 49
            },
            {
                stateId: 499,
                label: "Il-Furjana",
                value: "Il-Furjana",
                countryId: 49
            },
            {
                stateId: 500,
                label: "Il-Gudja",
                value: "Il-Gudja",
                countryId: 49
            },
            {
                stateId: 501,
                label: "Il-Gżira",
                value: "Il-Gżira",
                countryId: 49
            },
            {
                stateId: 502,
                label: "Il-Kalkara",
                value: "Il-Kalkara",
                countryId: 49
            },
            {
                stateId: 503,
                label: "Il-Marsa",
                value: "Il-Marsa",
                countryId: 49
            },
            {
                stateId: 504,
                label: "Il-Mellieħa",
                value: "Il-Mellieħa",
                countryId: 49
            },
            {
                stateId: 505,
                label: "Il-Mosta",
                value: "Il-Mosta",
                countryId: 49
            },
            {
                stateId: 506,
                label: "Il-Munxar",
                value: "Il-Munxar",
                countryId: 49
            },
            {
                stateId: 507,
                label: "Il-Qala",
                value: "Il-Qala",
                countryId: 49
            },
            {
                stateId: 508,
                label: "Il-Qrendi",
                value: "Il-Qrendi",
                countryId: 49
            },
            {
                stateId: 509,
                label: "Il-Ħamrun",
                value: "Il-Ħamrun",
                countryId: 49
            },
            {
                stateId: 517,
                label: "In-Nadur",
                value: "In-Nadur",
                countryId: 49
            },
            {
                stateId: 518,
                label: "In-Naxxar",
                value: "In-Naxxar",
                countryId: 49
            },
            {
                stateId: 522,
                label: "Ir-Rabat",
                value: "Ir-Rabat",
                countryId: 49
            },
            {
                stateId: 523,
                label: "Is-Siġġiewi",
                value: "Is-Siġġiewi",
                countryId: 49
            },
            {
                stateId: 524,
                label: "Is-Swieqi",
                value: "Is-Swieqi",
                countryId: 49
            },
            {
                stateId: 533,
                label: "Ix-Xagħra",
                value: "Ix-Xagħra",
                countryId: 49
            },
            {
                stateId: 534,
                label: "Ix-Xewkija",
                value: "Ix-Xewkija",
                countryId: 49
            },
            {
                stateId: 535,
                label: "Ix-Xgħajra",
                value: "Ix-Xgħajra",
                countryId: 49
            },
            {
                stateId: 536,
                label: "Iż-Żebbuġ",
                value: "Iż-Żebbuġ",
                countryId: 49
            },
            {
                stateId: 537,
                label: "Iż-Żejtun",
                value: "Iż-Żejtun",
                countryId: 49
            },
            {
                stateId: 538,
                label: "Iż-Żurrieq",
                value: "Iż-Żurrieq",
                countryId: 49
            },
            {
                stateId: 620,
                label: "Kirkop",
                value: "Kirkop",
                countryId: 49
            },
            {
                stateId: 653,
                label: "L-Għarb",
                value: "L-Għarb",
                countryId: 49
            },
            {
                stateId: 654,
                label: "L-Għasri",
                value: "L-Għasri",
                countryId: 49
            },
            {
                stateId: 655,
                label: "L-Iklin",
                value: "L-Iklin",
                countryId: 49
            },
            {
                stateId: 656,
                label: "L-Imdina",
                value: "L-Imdina",
                countryId: 49
            },
            {
                stateId: 657,
                label: "L-Imġarr",
                value: "L-Imġarr",
                countryId: 49
            },
            {
                stateId: 658,
                label: "L-Imqabba",
                value: "L-Imqabba",
                countryId: 49
            },
            {
                stateId: 659,
                label: "L-Imsida",
                value: "L-Imsida",
                countryId: 49
            },
            {
                stateId: 660,
                label: "L-Imtarfa",
                value: "L-Imtarfa",
                countryId: 49
            },
            {
                stateId: 661,
                label: "L-Isla",
                value: "L-Isla",
                countryId: 49
            },
            {
                stateId: 693,
                label: "Lija",
                value: "Lija",
                countryId: 49
            },
            {
                stateId: 709,
                label: "Luqa",
                value: "Luqa",
                countryId: 49
            },
            {
                stateId: 742,
                label: "Marsaskala",
                value: "Marsaskala",
                countryId: 49
            },
            {
                stateId: 743,
                label: "Marsaxlokk",
                value: "Marsaxlokk",
                countryId: 49
            },
            {
                stateId: 926,
                label: "Paola",
                value: "Paola",
                countryId: 49
            },
            {
                stateId: 939,
                label: "Pembroke",
                value: "Pembroke",
                countryId: 49
            },
            {
                stateId: 1000,
                label: "Qormi",
                value: "Qormi",
                countryId: 49
            },
            {
                stateId: 1087,
                label: "Safi",
                value: "Safi",
                countryId: 49
            },
            {
                stateId: 1092,
                label: "Saint John",
                value: "Saint John",
                countryId: 49
            },
            {
                stateId: 1093,
                label: "Saint Julian's",
                value: "Saint Julian's",
                countryId: 49
            },
            {
                stateId: 1094,
                label: "Saint Lawrence",
                value: "Saint Lawrence",
                countryId: 49
            },
            {
                stateId: 1095,
                label: "Saint Lucia",
                value: "Saint Lucia",
                countryId: 49
            },
            {
                stateId: 1096,
                label: "Saint Paul’s Bay",
                value: "Saint Paul’s Bay",
                countryId: 49
            },
            {
                stateId: 1097,
                label: "Saint Venera",
                value: "Saint Venera",
                countryId: 49
            },
            {
                stateId: 1128,
                label: "Sannat",
                value: "Sannat",
                countryId: 49
            },
            {
                stateId: 1235,
                label: "Tal-Pietà",
                value: "Tal-Pietà",
                countryId: 49
            },
            {
                stateId: 1243,
                label: "Tarxien",
                value: "Tarxien",
                countryId: 49
            },
            {
                stateId: 1244,
                label: "Tas-Sliema",
                value: "Tas-Sliema",
                countryId: 49
            },
            {
                stateId: 1248,
                label: "Ta’ Kerċem",
                value: "Ta’ Kerċem",
                countryId: 49
            },
            {
                stateId: 1249,
                label: "Ta’ Xbiex",
                value: "Ta’ Xbiex",
                countryId: 49
            },
            {
                stateId: 1361,
                label: "Victoria",
                value: "Victoria",
                countryId: 49
            },
            {
                stateId: 1435,
                label: "Ħal Għargħur",
                value: "Ħal Għargħur",
                countryId: 49
            },
            {
                stateId: 1436,
                label: "Ħal Għaxaq",
                value: "Ħal Għaxaq",
                countryId: 49
            },
            {
                stateId: 1437,
                label: "Ħaż-Żabbar",
                value: "Ħaż-Żabbar",
                countryId: 49
            },
            {
                stateId: 1438,
                label: "Ħaż-Żebbuġ",
                value: "Ħaż-Żebbuġ",
                countryId: 49
            }
        ]
    },
    {
        countryId: 50,
        code: "MH",
        label: "Marshall Islands",
        value: "Marshall Islands",
        states: [
            {
                stateId: 771,
                label: "Mh",
                value: "Mh",
                countryId: 50
            }
        ]
    },
    {
        countryId: 51,
        code: "MQ",
        label: "Martinique",
        value: "Martinique",
        states: [
            {
                stateId: 744,
                label: "Martinique",
                value: "Martinique",
                countryId: 51
            }
        ]
    },
    {
        countryId: 234,
        code: "MR",
        label: "Mauritania",
        value: "Mauritania",
        states: [
            {
                stateId: 1660,
                label: "Nouakchott",
                value: "Nouakchott",
                countryId: 234
            }
        ]
    },
    {
        countryId: 235,
        code: "MU",
        label: "Mauritius",
        value: "Mauritius",
        states: [
            {
                stateId: 1661,
                label: "Port Louis",
                value: "Port Louis",
                countryId: 235
            }
        ]
    },
    {
        countryId: 52,
        code: "YT",
        label: "Mayotte",
        value: "Mayotte",
        states: [
            {
                stateId: 5,
                label: "Acoua",
                value: "Acoua",
                countryId: 52
            },
            {
                stateId: 110,
                label: "Bandraboua",
                value: "Bandraboua",
                countryId: 52
            },
            {
                stateId: 111,
                label: "Bandrele",
                value: "Bandrele",
                countryId: 52
            },
            {
                stateId: 155,
                label: "Bouéni",
                value: "Bouéni",
                countryId: 52
            },
            {
                stateId: 253,
                label: "Chiconi",
                value: "Chiconi",
                countryId: 52
            },
            {
                stateId: 255,
                label: "Chirongui",
                value: "Chirongui",
                countryId: 52
            },
            {
                stateId: 308,
                label: "Dembeni",
                value: "Dembeni",
                countryId: 52
            },
            {
                stateId: 357,
                label: "Dzaoudzi",
                value: "Dzaoudzi",
                countryId: 52
            },
            {
                stateId: 573,
                label: "Kani-Kéli",
                value: "Kani-Kéli",
                countryId: 52
            },
            {
                stateId: 633,
                label: "Koungou",
                value: "Koungou",
                countryId: 52
            },
            {
                stateId: 715,
                label: "M'Tsangamouji",
                value: "M'Tsangamouji",
                countryId: 52
            },
            {
                stateId: 728,
                label: "Mamoudzou",
                value: "Mamoudzou",
                countryId: 52
            },
            {
                stateId: 755,
                label: "Mayotte (general)",
                value: "Mayotte (general)",
                countryId: 52
            },
            {
                stateId: 798,
                label: "Mtsamboro",
                value: "Mtsamboro",
                countryId: 52
            },
            {
                stateId: 915,
                label: "Ouangani",
                value: "Ouangani",
                countryId: 52
            },
            {
                stateId: 924,
                label: "Pamandzi",
                value: "Pamandzi",
                countryId: 52
            },
            {
                stateId: 1086,
                label: "Sada",
                value: "Sada",
                countryId: 52
            },
            {
                stateId: 1302,
                label: "Tsingoni",
                value: "Tsingoni",
                countryId: 52
            }
        ]
    },
    {
        countryId: 53,
        code: "MX",
        label: "Mexico",
        value: "Mexico",
        states: [
            {
                stateId: 23,
                label: "Aguascalientes",
                value: "Aguascalientes",
                countryId: 53
            },
            {
                stateId: 97,
                label: "Baja California",
                value: "Baja California",
                countryId: 53
            },
            {
                stateId: 98,
                label: "Baja California Sur",
                value: "Baja California Sur",
                countryId: 53
            },
            {
                stateId: 195,
                label: "Campeche",
                value: "Campeche",
                countryId: 53
            },
            {
                stateId: 251,
                label: "Chiapas",
                value: "Chiapas",
                countryId: 53
            },
            {
                stateId: 254,
                label: "Chihuahua",
                value: "Chihuahua",
                countryId: 53
            },
            {
                stateId: 272,
                label: "Coahuila de Zaragoza",
                value: "Coahuila de Zaragoza",
                countryId: 53
            },
            {
                stateId: 275,
                label: "Colima",
                value: "Colima",
                countryId: 53
            },
            {
                stateId: 338,
                label: "Distrito Federal",
                value: "Distrito Federal",
                countryId: 53
            },
            {
                stateId: 353,
                label: "Durango",
                value: "Durango",
                countryId: 53
            },
            {
                stateId: 436,
                label: "Guanajuato",
                value: "Guanajuato",
                countryId: 53
            },
            {
                stateId: 444,
                label: "Guerrero",
                value: "Guerrero",
                countryId: 53
            },
            {
                stateId: 472,
                label: "Hidalgo",
                value: "Hidalgo",
                countryId: 53
            },
            {
                stateId: 540,
                label: "Jalisco",
                value: "Jalisco",
                countryId: 53
            },
            {
                stateId: 769,
                label: "México",
                value: "México",
                countryId: 53
            },
            {
                stateId: 773,
                label: "Michoacán de Ocampo",
                value: "Michoacán de Ocampo",
                countryId: 53
            },
            {
                stateId: 795,
                label: "Morelos",
                value: "Morelos",
                countryId: 53
            },
            {
                stateId: 827,
                label: "Nayarit",
                value: "Nayarit",
                countryId: 53
            },
            {
                stateId: 879,
                label: "Nuevo León",
                value: "Nuevo León",
                countryId: 53
            },
            {
                stateId: 882,
                label: "Oaxaca",
                value: "Oaxaca",
                countryId: 53
            },
            {
                stateId: 991,
                label: "Puebla",
                value: "Puebla",
                countryId: 53
            },
            {
                stateId: 1006,
                label: "Querétaro",
                value: "Querétaro",
                countryId: 53
            },
            {
                stateId: 1008,
                label: "Quintana Roo",
                value: "Quintana Roo",
                countryId: 53
            },
            {
                stateId: 1124,
                label: "San Luis Potosí",
                value: "San Luis Potosí",
                countryId: 53
            },
            {
                stateId: 1168,
                label: "Sinaloa",
                value: "Sinaloa",
                countryId: 53
            },
            {
                stateId: 1189,
                label: "Sonora",
                value: "Sonora",
                countryId: 53
            },
            {
                stateId: 1232,
                label: "Tabasco",
                value: "Tabasco",
                countryId: 53
            },
            {
                stateId: 1238,
                label: "Tamaulipas",
                value: "Tamaulipas",
                countryId: 53
            },
            {
                stateId: 1274,
                label: "Tlaxcala",
                value: "Tlaxcala",
                countryId: 53
            },
            {
                stateId: 1351,
                label: "Veracruz de Ignacio de la Llave",
                value: "Veracruz de Ignacio de la Llave",
                countryId: 53
            },
            {
                stateId: 1416,
                label: "Yucatán",
                value: "Yucatán",
                countryId: 53
            },
            {
                stateId: 1418,
                label: "Zacatecas",
                value: "Zacatecas",
                countryId: 53
            }
        ]
    },
    {
        countryId: 54,
        code: "FM",
        label: "Micronesia",
        value: "Micronesia",
        states: [
            {
                stateId: 1206,
                label: "State of Chuuk",
                value: "State of Chuuk",
                countryId: 54
            },
            {
                stateId: 1207,
                label: "State of Kosrae",
                value: "State of Kosrae",
                countryId: 54
            },
            {
                stateId: 1208,
                label: "State of Pohnpei",
                value: "State of Pohnpei",
                countryId: 54
            },
            {
                stateId: 1209,
                label: "State of Yap",
                value: "State of Yap",
                countryId: 54
            }
        ]
    },
    {
        countryId: 55,
        code: "MD",
        label: "Moldova",
        value: "Moldova",
        states: [
            {
                stateId: 57,
                label: "Anenii Noi",
                value: "Anenii Noi",
                countryId: 55
            },
            {
                stateId: 105,
                label: "Balti",
                value: "Balti",
                countryId: 55
            },
            {
                stateId: 131,
                label: "Bender Tr.",
                value: "Bender Tr.",
                countryId: 55
            },
            {
                stateId: 169,
                label: "Briceni",
                value: "Briceni",
                countryId: 55
            },
            {
                stateId: 187,
                label: "Cahul",
                value: "Cahul",
                countryId: 55
            },
            {
                stateId: 189,
                label: "Calarasi",
                value: "Calarasi",
                countryId: 55
            },
            {
                stateId: 193,
                label: "Camenca Tr.",
                value: "Camenca Tr.",
                countryId: 55
            },
            {
                stateId: 204,
                label: "Cantemir",
                value: "Cantemir",
                countryId: 55
            },
            {
                stateId: 210,
                label: "Cantrmir",
                value: "Cantrmir",
                countryId: 55
            },
            {
                stateId: 211,
                label: "Canul",
                value: "Canul",
                countryId: 55
            },
            {
                stateId: 225,
                label: "Causeni",
                value: "Causeni",
                countryId: 55
            },
            {
                stateId: 265,
                label: "Cimislia",
                value: "Cimislia",
                countryId: 55
            },
            {
                stateId: 279,
                label: "Comrat",
                value: "Comrat",
                countryId: 55
            },
            {
                stateId: 291,
                label: "Criuleni",
                value: "Criuleni",
                countryId: 55
            },
            {
                stateId: 292,
                label: "Criuleni- Dub.",
                value: "Criuleni- Dub.",
                countryId: 55
            },
            {
                stateId: 293,
                label: "Criuleni-Dub.",
                value: "Criuleni-Dub.",
                countryId: 55
            },
            {
                stateId: 294,
                label: "Criulenii-Dub.",
                value: "Criulenii-Dub.",
                countryId: 55
            },
            {
                stateId: 344,
                label: "Donduseni",
                value: "Donduseni",
                countryId: 55
            },
            {
                stateId: 348,
                label: "Drochia",
                value: "Drochia",
                countryId: 55
            },
            {
                stateId: 349,
                label: "Dubasari Cr.",
                value: "Dubasari Cr.",
                countryId: 55
            },
            {
                stateId: 350,
                label: "Dubasari Tr.",
                value: "Dubasari Tr.",
                countryId: 55
            },
            {
                stateId: 360,
                label: "Edinet",
                value: "Edinet",
                countryId: 55
            },
            {
                stateId: 383,
                label: "Falesti",
                value: "Falesti",
                countryId: 55
            },
            {
                stateId: 390,
                label: "Floresti",
                value: "Floresti",
                countryId: 55
            },
            {
                stateId: 415,
                label: "Glodeni",
                value: "Glodeni",
                countryId: 55
            },
            {
                stateId: 428,
                label: "Grigoriopol Tr.",
                value: "Grigoriopol Tr.",
                countryId: 55
            },
            {
                stateId: 475,
                label: "Hincesti",
                value: "Hincesti",
                countryId: 55
            },
            {
                stateId: 487,
                label: "Ialoveni",
                value: "Ialoveni",
                countryId: 55
            },
            {
                stateId: 683,
                label: "Lazo",
                value: "Lazo",
                countryId: 55
            },
            {
                stateId: 685,
                label: "Leova",
                value: "Leova",
                countryId: 55
            },
            {
                stateId: 801,
                label: "Mun.Balti",
                value: "Mun.Balti",
                countryId: 55
            },
            {
                stateId: 802,
                label: "Mun.Chisinau",
                value: "Mun.Chisinau",
                countryId: 55
            },
            {
                stateId: 850,
                label: "Nisporeni",
                value: "Nisporeni",
                countryId: 55
            },
            {
                stateId: 885,
                label: "Ocnita",
                value: "Ocnita",
                countryId: 55
            },
            {
                stateId: 906,
                label: "Orhei",
                value: "Orhei",
                countryId: 55
            },
            {
                stateId: 1045,
                label: "Rezina",
                value: "Rezina",
                countryId: 55
            },
            {
                stateId: 1048,
                label: "Ribnita Tr.",
                value: "Ribnita Tr.",
                countryId: 55
            },
            {
                stateId: 1058,
                label: "Riscani",
                value: "Riscani",
                countryId: 55
            },
            {
                stateId: 1170,
                label: "Singerei",
                value: "Singerei",
                countryId: 55
            },
            {
                stateId: 1181,
                label: "Slobozia Tr.",
                value: "Slobozia Tr.",
                countryId: 55
            },
            {
                stateId: 1186,
                label: "Soldanesti",
                value: "Soldanesti",
                countryId: 55
            },
            {
                stateId: 1191,
                label: "Soroca",
                value: "Soroca",
                countryId: 55
            },
            {
                stateId: 1210,
                label: "Stefan-Voda",
                value: "Stefan-Voda",
                countryId: 55
            },
            {
                stateId: 1214,
                label: "Straseni",
                value: "Straseni",
                countryId: 55
            },
            {
                stateId: 1240,
                label: "Taraclia",
                value: "Taraclia",
                countryId: 55
            },
            {
                stateId: 1254,
                label: "Telenesti",
                value: "Telenesti",
                countryId: 55
            },
            {
                stateId: 1270,
                label: "Tiraspol Tr.",
                value: "Tiraspol Tr.",
                countryId: 55
            },
            {
                stateId: 1311,
                label: "Uhnheni",
                value: "Uhnheni",
                countryId: 55
            },
            {
                stateId: 1313,
                label: "Ungheni",
                value: "Ungheni",
                countryId: 55
            }
        ]
    },
    {
        countryId: 56,
        code: "MC",
        label: "Monaco",
        value: "Monaco",
        states: [
            {
                stateId: 791,
                label: "Monaco",
                value: "Monaco",
                countryId: 56
            }
        ]
    },
    {
        countryId: 241,
        code: "MN",
        label: "Mongolia",
        value: "Mongolia",
        states: [
            {
                stateId: 1662,
                label: "Ulaanbaatar",
                value: "Ulaanbaatar",
                countryId: 241
            }
        ]
    },
    {
        countryId: 242,
        code: "ME",
        label: "Montenegro",
        value: "Montenegro",
        states: [
            {
                stateId: 1663,
                label: "Podgorica",
                value: "Podgorica",
                countryId: 242
            }
        ]
    },
    {
        countryId: 243,
        code: "MS",
        label: "Montserrat",
        value: "Montserrat",
        states: [
            {
                stateId: 1664,
                label: "Brades",
                value: "Brades",
                countryId: 243
            }
        ]
    },
    {
        countryId: 244,
        code: "MA",
        label: "Morocco",
        value: "Morocco",
        states: [
            {
                stateId: 1665,
                label: "Rabat",
                value: "Rabat",
                countryId: 244
            }
        ]
    },
    {
        countryId: 245,
        code: "MZ",
        label: "Mozambique",
        value: "Mozambique",
        states: [
            {
                stateId: 1666,
                label: "Maputo",
                value: "Maputo",
                countryId: 245
            }
        ]
    },
    {
        countryId: 246,
        code: "MM",
        label: "Myanmar",
        value: "Myanmar",
        states: [
            {
                stateId: 1667,
                label: "Nay Pyi Taw",
                value: "Nay Pyi Taw",
                countryId: 246
            }
        ]
    },
    {
        countryId: 247,
        code: "NA",
        label: "Namibia",
        value: "Namibia",
        states: [
            {
                stateId: 1668,
                label: "Windhoek",
                value: "Windhoek",
                countryId: 247
            }
        ]
    },
    {
        countryId: 248,
        code: "NR",
        label: "Nauru",
        value: "Nauru",
        states: [
            {
                stateId: 1669,
                label: "Yaren",
                value: "Yaren",
                countryId: 248
            }
        ]
    },
    {
        countryId: 249,
        code: "NP",
        label: "Nepal",
        value: "Nepal",
        states: [
            {
                stateId: 1670,
                label: "Kathmandu",
                value: "Kathmandu",
                countryId: 249
            }
        ]
    },
    {
        countryId: 57,
        code: "NL",
        label: "Netherlands",
        value: "Netherlands",
        states: [
            {
                stateId: 347,
                label: "Drenthe",
                value: "Drenthe",
                countryId: 57
            },
            {
                stateId: 388,
                label: "Flevoland",
                value: "Flevoland",
                countryId: 57
            },
            {
                stateId: 395,
                label: "Friesland",
                value: "Friesland",
                countryId: 57
            },
            {
                stateId: 407,
                label: "Gelderland",
                value: "Gelderland",
                countryId: 57
            },
            {
                stateId: 431,
                label: "Groningen",
                value: "Groningen",
                countryId: 57
            },
            {
                stateId: 695,
                label: "Limburg",
                value: "Limburg",
                countryId: 57
            },
            {
                stateId: 856,
                label: "Noord-Brabant",
                value: "Noord-Brabant",
                countryId: 57
            },
            {
                stateId: 857,
                label: "Noord-Holland",
                value: "Noord-Holland",
                countryId: 57
            },
            {
                stateId: 918,
                label: "Overijssel",
                value: "Overijssel",
                countryId: 57
            },
            {
                stateId: 1320,
                label: "Utrecht",
                value: "Utrecht",
                countryId: 57
            },
            {
                stateId: 1425,
                label: "Zeeland",
                value: "Zeeland",
                countryId: 57
            },
            {
                stateId: 1431,
                label: "Zuid-Holland",
                value: "Zuid-Holland",
                countryId: 57
            }
        ]
    },
    {
        countryId: 58,
        code: "NC",
        label: "New Caledonia",
        value: "New Caledonia",
        states: [
            {
                stateId: 511,
                label: "Îles Loyauté",
                value: "Îles Loyauté",
                countryId: 58
            },
            {
                stateId: 981,
                label: "Province Nord",
                value: "Province Nord",
                countryId: 58
            },
            {
                stateId: 983,
                label: "Province Sud",
                value: "Province Sud",
                countryId: 58
            }
        ]
    },
    {
        countryId: 59,
        code: "NZ",
        label: "New Zealand",
        value: "New Zealand",
        states: [
            {
                stateId: 85,
                label: "Auckland",
                value: "Auckland",
                countryId: 59
            },
            {
                stateId: 123,
                label: "Bay of Plenty",
                value: "Bay of Plenty",
                countryId: 59
            },
            {
                stateId: 205,
                label: "Canterbury",
                value: "Canterbury",
                countryId: 59
            },
            {
                stateId: 413,
                label: "Gisborne",
                value: "Gisborne",
                countryId: 59
            },
            {
                stateId: 468,
                label: "Hawke's Bay",
                value: "Hawke's Bay",
                countryId: 59
            },
            {
                stateId: 730,
                label: "Manawatu-Wanganui",
                value: "Manawatu-Wanganui",
                countryId: 59
            },
            {
                stateId: 741,
                label: "Marlborough",
                value: "Marlborough",
                countryId: 59
            },
            {
                stateId: 832,
                label: "Nelson",
                value: "Nelson",
                countryId: 59
            },
            {
                stateId: 875,
                label: "Northland",
                value: "Northland",
                countryId: 59
            },
            {
                stateId: 914,
                label: "Otago",
                value: "Otago",
                countryId: 59
            },
            {
                stateId: 1203,
                label: "Southland",
                value: "Southland",
                countryId: 59
            },
            {
                stateId: 1241,
                label: "Taranaki",
                value: "Taranaki",
                countryId: 59
            },
            {
                stateId: 1245,
                label: "Tasman",
                value: "Tasman",
                countryId: 59
            },
            {
                stateId: 1382,
                label: "Waikato",
                value: "Waikato",
                countryId: 59
            },
            {
                stateId: 1389,
                label: "Wellington",
                value: "Wellington",
                countryId: 59
            },
            {
                stateId: 1391,
                label: "West Coast",
                value: "West Coast",
                countryId: 59
            }
        ]
    },
    {
        countryId: 253,
        code: "NI",
        label: "Nicaragua",
        value: "Nicaragua",
        states: [
            {
                stateId: 1671,
                label: "Managua",
                value: "Managua",
                countryId: 253
            }
        ]
    },
    {
        countryId: 254,
        code: "NE",
        label: "Niger",
        value: "Niger",
        states: [
            {
                stateId: 1672,
                label: "Niamey",
                value: "Niamey",
                countryId: 254
            }
        ]
    },
    {
        countryId: 255,
        code: "NG",
        label: "Nigeria",
        value: "Nigeria",
        states: [
            {
                stateId: 1673,
                label: "Abuja",
                value: "Abuja",
                countryId: 255
            }
        ]
    },
    {
        countryId: 256,
        code: "NU",
        label: "Niue",
        value: "Niue",
        states: [
            {
                stateId: 1674,
                label: "Alofi",
                value: "Alofi",
                countryId: 256
            }
        ]
    },
    {
        countryId: 257,
        code: "NF",
        label: "Norfolk Island",
        value: "Norfolk Island",
        states: [
            {
                stateId: 1675,
                label: "Kingston",
                value: "Kingston",
                countryId: 257
            }
        ]
    },
    {
        countryId: 60,
        code: "MK",
        label: "North Macedonia",
        value: "North Macedonia",
        states: [
            {
                stateId: 1676,
                label: "Skopje",
                value: "Skopje",
                countryId: 60
            }
        ]
    },
    {
        countryId: 61,
        code: "MP",
        label: "Northern Mariana Islands",
        value: "Northern Mariana Islands",
        states: [
            {
                stateId: 1069,
                label: "Rota",
                value: "Rota",
                countryId: 61
            },
            {
                stateId: 1099,
                label: "Saipan",
                value: "Saipan",
                countryId: 61
            },
            {
                stateId: 1268,
                label: "Tinian",
                value: "Tinian",
                countryId: 61
            }
        ]
    },
    {
        countryId: 62,
        code: "NO",
        label: "Norway",
        value: "Norway",
        states: [
            {
                stateId: 30,
                label: "Akershus",
                value: "Akershus",
                countryId: 62
            },
            {
                stateId: 86,
                label: "Aust-Agder",
                value: "Aust-Agder",
                countryId: 62
            },
            {
                stateId: 182,
                label: "Buskerud",
                value: "Buskerud",
                countryId: 62
            },
            {
                stateId: 387,
                label: "Finnmark",
                value: "Finnmark",
                countryId: 62
            },
            {
                stateId: 469,
                label: "Hedmark",
                value: "Hedmark",
                countryId: 62
            },
            {
                stateId: 479,
                label: "Hordaland",
                value: "Hordaland",
                countryId: 62
            },
            {
                stateId: 807,
                label: "Møre og Romsdal",
                value: "Møre og Romsdal",
                countryId: 62
            },
            {
                stateId: 858,
                label: "Nordland",
                value: "Nordland",
                countryId: 62
            },
            {
                stateId: 900,
                label: "Oppland",
                value: "Oppland",
                countryId: 62
            },
            {
                stateId: 910,
                label: "Oslo County",
                value: "Oslo County",
                countryId: 62
            },
            {
                stateId: 1063,
                label: "Rogaland",
                value: "Rogaland",
                countryId: 62
            },
            {
                stateId: 1185,
                label: "Sogn og Fjordane",
                value: "Sogn og Fjordane",
                countryId: 62
            },
            {
                stateId: 1253,
                label: "Telemark",
                value: "Telemark",
                countryId: 62
            },
            {
                stateId: 1299,
                label: "Troms",
                value: "Troms",
                countryId: 62
            },
            {
                stateId: 1301,
                label: "Trøndelag",
                value: "Trøndelag",
                countryId: 62
            },
            {
                stateId: 1353,
                label: "Vest-Agder",
                value: "Vest-Agder",
                countryId: 62
            },
            {
                stateId: 1354,
                label: "Vestfold",
                value: "Vestfold",
                countryId: 62
            },
            {
                stateId: 1434,
                label: "Østfold",
                value: "Østfold",
                countryId: 62
            }
        ]
    },
    {
        countryId: 261,
        code: "OM",
        label: "Oman",
        value: "Oman",
        states: [
            {
                stateId: 1677,
                label: "Muscat",
                value: "Muscat",
                countryId: 261
            }
        ]
    },
    {
        countryId: 63,
        code: "PK",
        label: "Pakistan",
        value: "Pakistan",
        states: [
            {
                stateId: 104,
                label: "Balochisan",
                value: "Balochisan",
                countryId: 63
            },
            {
                stateId: 385,
                label: "Federal Capial &AJK",
                value: "Federal Capial &AJK",
                countryId: 63
            },
            {
                stateId: 484,
                label: "Hyderabad",
                value: "Hyderabad",
                countryId: 63
            },
            {
                stateId: 672,
                label: "Lahore",
                value: "Lahore",
                countryId: 63
            },
            {
                stateId: 860,
                label: "Norhern Punajb Rawalpindi",
                value: "Norhern Punajb Rawalpindi",
                countryId: 63
            },
            {
                stateId: 881,
                label: "NWFP Peshawar",
                value: "NWFP Peshawar",
                countryId: 63
            },
            {
                stateId: 1192,
                label: "Souhern Punajb Mulan",
                value: "Souhern Punajb Mulan",
                countryId: 63
            }
        ]
    },
    {
        countryId: 64,
        code: "PW",
        label: "Palau",
        value: "Palau",
        states: [
            {
                stateId: 1678,
                label: "Melekeok",
                value: "Melekeok",
                countryId: 64
            }
        ]
    },
    {
        countryId: 264,
        code: "PS",
        label: "Palestine, State of",
        value: "Palestine, State of",
        states: [
            {
                stateId: 1679,
                label: "Ramallah",
                value: "Ramallah",
                countryId: 264
            }
        ]
    },
    {
        countryId: 265,
        code: "PA",
        label: "Panama",
        value: "Panama",
        states: [
            {
                stateId: 1680,
                label: "Panama City",
                value: "Panama City",
                countryId: 265
            }
        ]
    },
    {
        countryId: 266,
        code: "PG",
        label: "Papua New Guinea",
        value: "Papua New Guinea",
        states: [
            {
                stateId: 1681,
                label: "Port Moresby",
                value: "Port Moresby",
                countryId: 266
            }
        ]
    },
    {
        countryId: 267,
        code: "PY",
        label: "Paraguay",
        value: "Paraguay",
        states: [
            {
                stateId: 1682,
                label: "Asunción",
                value: "Asunción",
                countryId: 267
            }
        ]
    },
    {
        countryId: 268,
        code: "PE",
        label: "Peru",
        value: "Peru",
        states: [
            {
                stateId: 1683,
                label: "Lima",
                value: "Lima",
                countryId: 268
            }
        ]
    },
    {
        countryId: 65,
        code: "PH",
        label: "Philippines",
        value: "Philippines",
        states: [
            {
                stateId: 1684,
                label: "Manila",
                value: "Manila",
                countryId: 65
            }
        ]
    },
    {
        countryId: 270,
        code: "PN",
        label: "Pitcairn",
        value: "Pitcairn",
        states: [
            {
                stateId: 1685,
                label: "Adamstown",
                value: "Adamstown",
                countryId: 270
            }
        ]
    },
    {
        countryId: 66,
        code: "PL",
        label: "Poland",
        value: "Poland",
        states: [
            {
                stateId: 426,
                label: "Greater Poland",
                value: "Greater Poland",
                countryId: 66
            },
            {
                stateId: 643,
                label: "Kujawsko-Pomorskie",
                value: "Kujawsko-Pomorskie",
                countryId: 66
            },
            {
                stateId: 687,
                label: "Lesser Poland",
                value: "Lesser Poland",
                countryId: 66
            },
            {
                stateId: 703,
                label: "Lower Silesia",
                value: "Lower Silesia",
                countryId: 66
            },
            {
                stateId: 705,
                label: "Lublin",
                value: "Lublin",
                countryId: 66
            },
            {
                stateId: 706,
                label: "Lubusz",
                value: "Lubusz",
                countryId: 66
            },
            {
                stateId: 756,
                label: "Mazovia",
                value: "Mazovia",
                countryId: 66
            },
            {
                stateId: 899,
                label: "Opole Voivodeship",
                value: "Opole Voivodeship",
                countryId: 66
            },
            {
                stateId: 962,
                label: "Podlasie",
                value: "Podlasie",
                countryId: 66
            },
            {
                stateId: 965,
                label: "Pomerania",
                value: "Pomerania",
                countryId: 66
            },
            {
                stateId: 1167,
                label: "Silesia",
                value: "Silesia",
                countryId: 66
            },
            {
                stateId: 1217,
                label: "Subcarpathia",
                value: "Subcarpathia",
                countryId: 66
            },
            {
                stateId: 1227,
                label: "Świętokrzyskie",
                value: "Świętokrzyskie",
                countryId: 66
            },
            {
                stateId: 1386,
                label: "Warmia-Masuria",
                value: "Warmia-Masuria",
                countryId: 66
            },
            {
                stateId: 1392,
                label: "West Pomerania",
                value: "West Pomerania",
                countryId: 66
            },
            {
                stateId: 1439,
                label: "Łódź Voivodeship",
                value: "Łódź Voivodeship",
                countryId: 66
            }
        ]
    },
    {
        countryId: 67,
        code: "PT",
        label: "Portugal",
        value: "Portugal",
        states: [
            {
                stateId: 89,
                label: "Aveiro",
                value: "Aveiro",
                countryId: 67
            },
            {
                stateId: 91,
                label: "Azores",
                value: "Azores",
                countryId: 67
            },
            {
                stateId: 128,
                label: "Beja",
                value: "Beja",
                countryId: 67
            },
            {
                stateId: 160,
                label: "Braga",
                value: "Braga",
                countryId: 67
            },
            {
                stateId: 161,
                label: "Bragança",
                value: "Bragança",
                countryId: 67
            },
            {
                stateId: 218,
                label: "Castelo Branco",
                value: "Castelo Branco",
                countryId: 67
            },
            {
                stateId: 274,
                label: "Coimbra",
                value: "Coimbra",
                countryId: 67
            },
            {
                stateId: 380,
                label: "Évora",
                value: "Évora",
                countryId: 67
            },
            {
                stateId: 384,
                label: "Faro",
                value: "Faro",
                countryId: 67
            },
            {
                stateId: 438,
                label: "Guarda",
                value: "Guarda",
                countryId: 67
            },
            {
                stateId: 684,
                label: "Leiria",
                value: "Leiria",
                countryId: 67
            },
            {
                stateId: 696,
                label: "Lisboa",
                value: "Lisboa",
                countryId: 67
            },
            {
                stateId: 716,
                label: "Madeira",
                value: "Madeira",
                countryId: 67
            },
            {
                stateId: 968,
                label: "Portalegre",
                value: "Portalegre",
                countryId: 67
            },
            {
                stateId: 969,
                label: "Porto",
                value: "Porto",
                countryId: 67
            },
            {
                stateId: 1135,
                label: "Santarém",
                value: "Santarém",
                countryId: 67
            },
            {
                stateId: 1154,
                label: "Setúbal",
                value: "Setúbal",
                countryId: 67
            },
            {
                stateId: 1357,
                label: "Viana do Castelo",
                value: "Viana do Castelo",
                countryId: 67
            },
            {
                stateId: 1364,
                label: "Vila Real",
                value: "Vila Real",
                countryId: 67
            },
            {
                stateId: 1373,
                label: "Viseu",
                value: "Viseu",
                countryId: 67
            }
        ]
    },
    {
        countryId: 68,
        code: "PR",
        label: "Puerto Rico",
        value: "Puerto Rico",
        states: [
            {
                stateId: 10,
                label: "Adjuntas",
                value: "Adjuntas",
                countryId: 68
            },
            {
                stateId: 20,
                label: "Aguada",
                value: "Aguada",
                countryId: 68
            },
            {
                stateId: 21,
                label: "Aguadilla",
                value: "Aguadilla",
                countryId: 68
            },
            {
                stateId: 22,
                label: "Aguas Buenas",
                value: "Aguas Buenas",
                countryId: 68
            },
            {
                stateId: 24,
                label: "Aibonito",
                value: "Aibonito",
                countryId: 68
            },
            {
                stateId: 52,
                label: "Anasco",
                value: "Anasco",
                countryId: 68
            },
            {
                stateId: 70,
                label: "Arecibo",
                value: "Arecibo",
                countryId: 68
            },
            {
                stateId: 74,
                label: "Arroyo",
                value: "Arroyo",
                countryId: 68
            },
            {
                stateId: 115,
                label: "Barceloneta",
                value: "Barceloneta",
                countryId: 68
            },
            {
                stateId: 117,
                label: "Barranquitas",
                value: "Barranquitas",
                countryId: 68
            },
            {
                stateId: 124,
                label: "Bayamon",
                value: "Bayamon",
                countryId: 68
            },
            {
                stateId: 185,
                label: "Cabo Rojo",
                value: "Cabo Rojo",
                countryId: 68
            },
            {
                stateId: 186,
                label: "Caguas",
                value: "Caguas",
                countryId: 68
            },
            {
                stateId: 196,
                label: "Camuy",
                value: "Camuy",
                countryId: 68
            },
            {
                stateId: 202,
                label: "Canovanas",
                value: "Canovanas",
                countryId: 68
            },
            {
                stateId: 216,
                label: "Carolina",
                value: "Carolina",
                countryId: 68
            },
            {
                stateId: 223,
                label: "Catano",
                value: "Catano",
                countryId: 68
            },
            {
                stateId: 226,
                label: "Cayey",
                value: "Cayey",
                countryId: 68
            },
            {
                stateId: 228,
                label: "Ceiba",
                value: "Ceiba",
                countryId: 68
            },
            {
                stateId: 262,
                label: "Ciales",
                value: "Ciales",
                countryId: 68
            },
            {
                stateId: 264,
                label: "Cidra",
                value: "Cidra",
                countryId: 68
            },
            {
                stateId: 273,
                label: "Coamo",
                value: "Coamo",
                countryId: 68
            },
            {
                stateId: 278,
                label: "Comerio",
                value: "Comerio",
                countryId: 68
            },
            {
                stateId: 286,
                label: "Corozal",
                value: "Corozal",
                countryId: 68
            },
            {
                stateId: 296,
                label: "Culebra",
                value: "Culebra",
                countryId: 68
            },
            {
                stateId: 346,
                label: "Dorado",
                value: "Dorado",
                countryId: 68
            },
            {
                stateId: 382,
                label: "Fajardo",
                value: "Fajardo",
                countryId: 68
            },
            {
                stateId: 391,
                label: "Florida",
                value: "Florida",
                countryId: 68
            },
            {
                stateId: 437,
                label: "Guanica",
                value: "Guanica",
                countryId: 68
            },
            {
                stateId: 440,
                label: "Guayama",
                value: "Guayama",
                countryId: 68
            },
            {
                stateId: 441,
                label: "Guayanilla",
                value: "Guayanilla",
                countryId: 68
            },
            {
                stateId: 442,
                label: "Guaynabo",
                value: "Guaynabo",
                countryId: 68
            },
            {
                stateId: 449,
                label: "Gurabo",
                value: "Gurabo",
                countryId: 68
            },
            {
                stateId: 465,
                label: "Hatillo",
                value: "Hatillo",
                countryId: 68
            },
            {
                stateId: 480,
                label: "Hormigueros",
                value: "Hormigueros",
                countryId: 68
            },
            {
                stateId: 482,
                label: "Humacao",
                value: "Humacao",
                countryId: 68
            },
            {
                stateId: 525,
                label: "Isabela",
                value: "Isabela",
                countryId: 68
            },
            {
                stateId: 549,
                label: "Jayuya",
                value: "Jayuya",
                countryId: 68
            },
            {
                stateId: 559,
                label: "Juana Diaz",
                value: "Juana Diaz",
                countryId: 68
            },
            {
                stateId: 561,
                label: "Juncos",
                value: "Juncos",
                countryId: 68
            },
            {
                stateId: 673,
                label: "Lajas",
                value: "Lajas",
                countryId: 68
            },
            {
                stateId: 678,
                label: "Lares",
                value: "Lares",
                countryId: 68
            },
            {
                stateId: 679,
                label: "Las Marias",
                value: "Las Marias",
                countryId: 68
            },
            {
                stateId: 680,
                label: "Las Piedras",
                value: "Las Piedras",
                countryId: 68
            },
            {
                stateId: 699,
                label: "Loiza",
                value: "Loiza",
                countryId: 68
            },
            {
                stateId: 710,
                label: "Luquillo",
                value: "Luquillo",
                countryId: 68
            },
            {
                stateId: 729,
                label: "Manati",
                value: "Manati",
                countryId: 68
            },
            {
                stateId: 738,
                label: "Maricao",
                value: "Maricao",
                countryId: 68
            },
            {
                stateId: 752,
                label: "Maunabo",
                value: "Maunabo",
                countryId: 68
            },
            {
                stateId: 754,
                label: "Mayaguez",
                value: "Mayaguez",
                countryId: 68
            },
            {
                stateId: 787,
                label: "Moca",
                value: "Moca",
                countryId: 68
            },
            {
                stateId: 796,
                label: "Morovis",
                value: "Morovis",
                countryId: 68
            },
            {
                stateId: 813,
                label: "Naguabo",
                value: "Naguabo",
                countryId: 68
            },
            {
                stateId: 822,
                label: "Naranjito",
                value: "Naranjito",
                countryId: 68
            },
            {
                stateId: 907,
                label: "Orocovis",
                value: "Orocovis",
                countryId: 68
            },
            {
                stateId: 934,
                label: "Patillas",
                value: "Patillas",
                countryId: 68
            },
            {
                stateId: 942,
                label: "Penuelas",
                value: "Penuelas",
                countryId: 68
            },
            {
                stateId: 966,
                label: "Ponce",
                value: "Ponce",
                countryId: 68
            },
            {
                stateId: 1004,
                label: "Quebradillas",
                value: "Quebradillas",
                countryId: 68
            },
            {
                stateId: 1050,
                label: "Rincon",
                value: "Rincon",
                countryId: 68
            },
            {
                stateId: 1052,
                label: "Rio Grande",
                value: "Rio Grande",
                countryId: 68
            },
            {
                stateId: 1080,
                label: "Sabana Grande",
                value: "Sabana Grande",
                countryId: 68
            },
            {
                stateId: 1107,
                label: "Salinas",
                value: "Salinas",
                countryId: 68
            },
            {
                stateId: 1118,
                label: "San German",
                value: "San German",
                countryId: 68
            },
            {
                stateId: 1121,
                label: "San Juan",
                value: "San Juan",
                countryId: 68
            },
            {
                stateId: 1122,
                label: "San Lorenzo",
                value: "San Lorenzo",
                countryId: 68
            },
            {
                stateId: 1125,
                label: "San Sebastian",
                value: "San Sebastian",
                countryId: 68
            },
            {
                stateId: 1133,
                label: "Santa Isabel",
                value: "Santa Isabel",
                countryId: 68
            },
            {
                stateId: 1276,
                label: "Toa Alta",
                value: "Toa Alta",
                countryId: 68
            },
            {
                stateId: 1277,
                label: "Toa Baja",
                value: "Toa Baja",
                countryId: 68
            },
            {
                stateId: 1300,
                label: "Trujillo Alto",
                value: "Trujillo Alto",
                countryId: 68
            },
            {
                stateId: 1324,
                label: "Utuado",
                value: "Utuado",
                countryId: 68
            },
            {
                stateId: 1347,
                label: "Vega Alta",
                value: "Vega Alta",
                countryId: 68
            },
            {
                stateId: 1348,
                label: "Vega Baja",
                value: "Vega Baja",
                countryId: 68
            },
            {
                stateId: 1362,
                label: "Vieques",
                value: "Vieques",
                countryId: 68
            },
            {
                stateId: 1368,
                label: "Villalba",
                value: "Villalba",
                countryId: 68
            },
            {
                stateId: 1405,
                label: "Yabucoa",
                value: "Yabucoa",
                countryId: 68
            },
            {
                stateId: 1413,
                label: "Yauco",
                value: "Yauco",
                countryId: 68
            }
        ]
    },
    {
        countryId: 274,
        code: "QA",
        label: "Qatar",
        value: "Qatar",
        states: [
            {
                stateId: 1686,
                label: "Doha",
                value: "Doha",
                countryId: 274
            }
        ]
    },
    {
        countryId: 275,
        code: "XK",
        label: "Republic of Kosovo",
        value: "Republic of Kosovo",
        states: [
            {
                stateId: 1687,
                label: "Pristina",
                value: "Pristina",
                countryId: 275
            }
        ]
    },
    {
        countryId: 69,
        code: "RE",
        label: "Reunion",
        value: "Reunion",
        states: [
            {
                stateId: 1042,
                label: "Réunion",
                value: "Réunion",
                countryId: 69
            },
            {
                stateId: 1043,
                label: "Reunion (general)",
                value: "Reunion (general)",
                countryId: 69
            }
        ]
    },
    {
        countryId: 70,
        code: "RO",
        label: "Romania",
        value: "Romania",
        states: [
            {
                stateId: 39,
                label: "Alba",
                value: "Alba",
                countryId: 70
            },
            {
                stateId: 65,
                label: "Arad",
                value: "Arad",
                countryId: 70
            },
            {
                stateId: 71,
                label: "Argeş",
                value: "Argeş",
                countryId: 70
            },
            {
                stateId: 93,
                label: "Bacău",
                value: "Bacău",
                countryId: 70
            },
            {
                stateId: 136,
                label: "Bihor",
                value: "Bihor",
                countryId: 70
            },
            {
                stateId: 143,
                label: "Bistriţa-Năsăud",
                value: "Bistriţa-Năsăud",
                countryId: 70
            },
            {
                stateId: 154,
                label: "Botoşani",
                value: "Botoşani",
                countryId: 70
            },
            {
                stateId: 162,
                label: "Brăila",
                value: "Brăila",
                countryId: 70
            },
            {
                stateId: 164,
                label: "Braşov",
                value: "Braşov",
                countryId: 70
            },
            {
                stateId: 174,
                label: "Bucureşti",
                value: "Bucureşti",
                countryId: 70
            },
            {
                stateId: 183,
                label: "Buzău",
                value: "Buzău",
                countryId: 70
            },
            {
                stateId: 190,
                label: "Călăraşi",
                value: "Călăraşi",
                countryId: 70
            },
            {
                stateId: 214,
                label: "Caraş-Severin",
                value: "Caraş-Severin",
                countryId: 70
            },
            {
                stateId: 271,
                label: "Cluj",
                value: "Cluj",
                countryId: 70
            },
            {
                stateId: 282,
                label: "Constanţa",
                value: "Constanţa",
                countryId: 70
            },
            {
                stateId: 290,
                label: "Covasna",
                value: "Covasna",
                countryId: 70
            },
            {
                stateId: 303,
                label: "Dâmboviţa",
                value: "Dâmboviţa",
                countryId: 70
            },
            {
                stateId: 343,
                label: "Dolj",
                value: "Dolj",
                countryId: 70
            },
            {
                stateId: 401,
                label: "Galaţi",
                value: "Galaţi",
                countryId: 70
            },
            {
                stateId: 414,
                label: "Giurgiu",
                value: "Giurgiu",
                countryId: 70
            },
            {
                stateId: 420,
                label: "Gorj",
                value: "Gorj",
                countryId: 70
            },
            {
                stateId: 461,
                label: "Harghita",
                value: "Harghita",
                countryId: 70
            },
            {
                stateId: 483,
                label: "Hunedoara",
                value: "Hunedoara",
                countryId: 70
            },
            {
                stateId: 486,
                label: "Ialomiţa",
                value: "Ialomiţa",
                countryId: 70
            },
            {
                stateId: 488,
                label: "Iaşi",
                value: "Iaşi",
                countryId: 70
            },
            {
                stateId: 512,
                label: "Ilfov",
                value: "Ilfov",
                countryId: 70
            },
            {
                stateId: 734,
                label: "Maramureş",
                value: "Maramureş",
                countryId: 70
            },
            {
                stateId: 761,
                label: "Mehedinţi",
                value: "Mehedinţi",
                countryId: 70
            },
            {
                stateId: 804,
                label: "Mureş",
                value: "Mureş",
                countryId: 70
            },
            {
                stateId: 828,
                label: "Neamţ",
                value: "Neamţ",
                countryId: 70
            },
            {
                stateId: 897,
                label: "Olt",
                value: "Olt",
                countryId: 70
            },
            {
                stateId: 973,
                label: "Prahova",
                value: "Prahova",
                countryId: 70
            },
            {
                stateId: 1103,
                label: "Sălaj",
                value: "Sălaj",
                countryId: 70
            },
            {
                stateId: 1143,
                label: "Satu Mare",
                value: "Satu Mare",
                countryId: 70
            },
            {
                stateId: 1161,
                label: "Sibiu",
                value: "Sibiu",
                countryId: 70
            },
            {
                stateId: 1218,
                label: "Suceava",
                value: "Suceava",
                countryId: 70
            },
            {
                stateId: 1255,
                label: "Teleorman",
                value: "Teleorman",
                countryId: 70
            },
            {
                stateId: 1266,
                label: "Timiş",
                value: "Timiş",
                countryId: 70
            },
            {
                stateId: 1305,
                label: "Tulcea",
                value: "Tulcea",
                countryId: 70
            },
            {
                stateId: 1328,
                label: "Vâlcea",
                value: "Vâlcea",
                countryId: 70
            },
            {
                stateId: 1339,
                label: "Vaslui",
                value: "Vaslui",
                countryId: 70
            },
            {
                stateId: 1380,
                label: "Vrancea",
                value: "Vrancea",
                countryId: 70
            }
        ]
    },
    {
        countryId: 71,
        code: "RU",
        label: "Russia",
        value: "Russia",
        states: [
            {
                stateId: 1440,
                label: "Адыгея Республика",
                value: "Адыгея Республика",
                countryId: 71
            },
            {
                stateId: 1441,
                label: "Алтай Республика",
                value: "Алтай Республика",
                countryId: 71
            },
            {
                stateId: 1442,
                label: "Алтайский Край",
                value: "Алтайский Край",
                countryId: 71
            },
            {
                stateId: 1443,
                label: "Амурская Область",
                value: "Амурская Область",
                countryId: 71
            },
            {
                stateId: 1444,
                label: "Архангельская Область",
                value: "Архангельская Область",
                countryId: 71
            },
            {
                stateId: 1445,
                label: "Астраханская Область",
                value: "Астраханская Область",
                countryId: 71
            },
            {
                stateId: 1446,
                label: "Байконур",
                value: "Байконур",
                countryId: 71
            },
            {
                stateId: 1447,
                label: "Башкортостан Республика",
                value: "Башкортостан Республика",
                countryId: 71
            },
            {
                stateId: 1448,
                label: "Белгородская Область",
                value: "Белгородская Область",
                countryId: 71
            },
            {
                stateId: 1450,
                label: "Брянская Область",
                value: "Брянская Область",
                countryId: 71
            },
            {
                stateId: 1452,
                label: "Бурятия Республика",
                value: "Бурятия Республика",
                countryId: 71
            },
            {
                stateId: 1456,
                label: "Владимирская Область",
                value: "Владимирская Область",
                countryId: 71
            },
            {
                stateId: 1457,
                label: "Волгоградская Область",
                value: "Волгоградская Область",
                countryId: 71
            },
            {
                stateId: 1458,
                label: "Вологодская Область",
                value: "Вологодская Область",
                countryId: 71
            },
            {
                stateId: 1459,
                label: "Воронежская Область",
                value: "Воронежская Область",
                countryId: 71
            },
            {
                stateId: 1462,
                label: "Дагестан Республика",
                value: "Дагестан Республика",
                countryId: 71
            },
            {
                stateId: 1464,
                label: "Ивановская Область",
                value: "Ивановская Область",
                countryId: 71
            },
            {
                stateId: 1465,
                label: "Ингушетия Республика",
                value: "Ингушетия Республика",
                countryId: 71
            },
            {
                stateId: 1466,
                label: "Иркутская Область",
                value: "Иркутская Область",
                countryId: 71
            },
            {
                stateId: 1467,
                label: "Кабардино-Балкарская Республика",
                value: "Кабардино-Балкарская Республика",
                countryId: 71
            },
            {
                stateId: 1468,
                label: "Калининградская Область",
                value: "Калининградская Область",
                countryId: 71
            },
            {
                stateId: 1469,
                label: "Калмыкия Республика",
                value: "Калмыкия Республика",
                countryId: 71
            },
            {
                stateId: 1470,
                label: "Калужская Область",
                value: "Калужская Область",
                countryId: 71
            },
            {
                stateId: 1471,
                label: "Камчатская Область",
                value: "Камчатская Область",
                countryId: 71
            },
            {
                stateId: 1472,
                label: "Карачаево-Черкесская Республика",
                value: "Карачаево-Черкесская Республика",
                countryId: 71
            },
            {
                stateId: 1473,
                label: "Карелия Республика",
                value: "Карелия Республика",
                countryId: 71
            },
            {
                stateId: 1474,
                label: "Кемеровская Область",
                value: "Кемеровская Область",
                countryId: 71
            },
            {
                stateId: 1475,
                label: "Кировская Область",
                value: "Кировская Область",
                countryId: 71
            },
            {
                stateId: 1476,
                label: "Коми Республика",
                value: "Коми Республика",
                countryId: 71
            },
            {
                stateId: 1477,
                label: "Костромская Область",
                value: "Костромская Область",
                countryId: 71
            },
            {
                stateId: 1478,
                label: "Краснодарский Край",
                value: "Краснодарский Край",
                countryId: 71
            },
            {
                stateId: 1479,
                label: "Красноярский Край",
                value: "Красноярский Край",
                countryId: 71
            },
            {
                stateId: 1480,
                label: "Курганская Область",
                value: "Курганская Область",
                countryId: 71
            },
            {
                stateId: 1481,
                label: "Курская Область",
                value: "Курская Область",
                countryId: 71
            },
            {
                stateId: 1484,
                label: "Ленинградская Область",
                value: "Ленинградская Область",
                countryId: 71
            },
            {
                stateId: 1485,
                label: "Липецкая Область",
                value: "Липецкая Область",
                countryId: 71
            },
            {
                stateId: 1487,
                label: "Магаданская Область",
                value: "Магаданская Область",
                countryId: 71
            },
            {
                stateId: 1488,
                label: "Марий Эл Республика",
                value: "Марий Эл Республика",
                countryId: 71
            },
            {
                stateId: 1490,
                label: "Мордовия Республика",
                value: "Мордовия Республика",
                countryId: 71
            },
            {
                stateId: 1491,
                label: "Москва",
                value: "Москва",
                countryId: 71
            },
            {
                stateId: 1492,
                label: "Московская Область",
                value: "Московская Область",
                countryId: 71
            },
            {
                stateId: 1493,
                label: "Мурманская Область",
                value: "Мурманская Область",
                countryId: 71
            },
            {
                stateId: 1494,
                label: "Нижегородская Область",
                value: "Нижегородская Область",
                countryId: 71
            },
            {
                stateId: 1495,
                label: "Новгородская Область",
                value: "Новгородская Область",
                countryId: 71
            },
            {
                stateId: 1496,
                label: "Новосибирская Область",
                value: "Новосибирская Область",
                countryId: 71
            },
            {
                stateId: 1497,
                label: "Омская Область",
                value: "Омская Область",
                countryId: 71
            },
            {
                stateId: 1498,
                label: "Оренбургская Область",
                value: "Оренбургская Область",
                countryId: 71
            },
            {
                stateId: 1499,
                label: "Орловская Область",
                value: "Орловская Область",
                countryId: 71
            },
            {
                stateId: 1501,
                label: "Пензенская Область",
                value: "Пензенская Область",
                countryId: 71
            },
            {
                stateId: 1502,
                label: "Пермский Край",
                value: "Пермский Край",
                countryId: 71
            },
            {
                stateId: 1506,
                label: "Приморский Край",
                value: "Приморский Край",
                countryId: 71
            },
            {
                stateId: 1507,
                label: "Псковская Область",
                value: "Псковская Область",
                countryId: 71
            },
            {
                stateId: 1509,
                label: "Ростовская Область",
                value: "Ростовская Область",
                countryId: 71
            },
            {
                stateId: 1511,
                label: "Рязанская Область",
                value: "Рязанская Область",
                countryId: 71
            },
            {
                stateId: 1512,
                label: "Самарская Область",
                value: "Самарская Область",
                countryId: 71
            },
            {
                stateId: 1513,
                label: "Санкт-Петербург",
                value: "Санкт-Петербург",
                countryId: 71
            },
            {
                stateId: 1514,
                label: "Саратовская Область",
                value: "Саратовская Область",
                countryId: 71
            },
            {
                stateId: 1515,
                label: "Саха (Якутия) Республика",
                value: "Саха (Якутия) Республика",
                countryId: 71
            },
            {
                stateId: 1516,
                label: "Сахалинская Область",
                value: "Сахалинская Область",
                countryId: 71
            },
            {
                stateId: 1517,
                label: "Свердловская Область",
                value: "Свердловская Область",
                countryId: 71
            },
            {
                stateId: 1518,
                label: "Северная Осетия-Алания Республика",
                value: "Северная Осетия-Алания Республика",
                countryId: 71
            },
            {
                stateId: 1521,
                label: "Смоленская Область",
                value: "Смоленская Область",
                countryId: 71
            },
            {
                stateId: 1525,
                label: "Ставропольский Край",
                value: "Ставропольский Край",
                countryId: 71
            },
            {
                stateId: 1527,
                label: "Тамбовская Область",
                value: "Тамбовская Область",
                countryId: 71
            },
            {
                stateId: 1528,
                label: "Татарстан Республика",
                value: "Татарстан Республика",
                countryId: 71
            },
            {
                stateId: 1529,
                label: "Тверская Область",
                value: "Тверская Область",
                countryId: 71
            },
            {
                stateId: 1530,
                label: "Томская Область",
                value: "Томская Область",
                countryId: 71
            },
            {
                stateId: 1531,
                label: "Тульская Область",
                value: "Тульская Область",
                countryId: 71
            },
            {
                stateId: 1533,
                label: "Тыва Республика",
                value: "Тыва Республика",
                countryId: 71
            },
            {
                stateId: 1534,
                label: "Тюменская Область",
                value: "Тюменская Область",
                countryId: 71
            },
            {
                stateId: 1535,
                label: "Удмуртская Республика",
                value: "Удмуртская Республика",
                countryId: 71
            },
            {
                stateId: 1536,
                label: "Ульяновская Область",
                value: "Ульяновская Область",
                countryId: 71
            },
            {
                stateId: 1537,
                label: "Хабаровский Край",
                value: "Хабаровский Край",
                countryId: 71
            },
            {
                stateId: 1538,
                label: "Хакасия Республика",
                value: "Хакасия Республика",
                countryId: 71
            },
            {
                stateId: 1540,
                label: "Челябинская Область",
                value: "Челябинская Область",
                countryId: 71
            },
            {
                stateId: 1541,
                label: "Чеченская Республика",
                value: "Чеченская Республика",
                countryId: 71
            },
            {
                stateId: 1542,
                label: "Читинская Область",
                value: "Читинская Область",
                countryId: 71
            },
            {
                stateId: 1543,
                label: "Чувашская Республика",
                value: "Чувашская Республика",
                countryId: 71
            },
            {
                stateId: 1546,
                label: "Ярославская Область",
                value: "Ярославская Область",
                countryId: 71
            }
        ]
    },
    {
        countryId: 279,
        code: "RW",
        label: "Rwanda",
        value: "Rwanda",
        states: [
            {
                stateId: 1688,
                label: "Kigali",
                value: "Kigali",
                countryId: 279
            }
        ]
    },
    {
        countryId: 280,
        code: "BL",
        label: "Saint Barthélemy",
        value: "Saint Barthélemy",
        states: [
            {
                stateId: 1689,
                label: "Gustavia",
                value: "Gustavia",
                countryId: 280
            }
        ]
    },
    {
        countryId: 281,
        code: "SH",
        label: "Saint Helena, Ascension and Tristan da Cunha",
        value: "Saint Helena, Ascension and Tristan da Cunha",
        states: [
            {
                stateId: 1690,
                label: "Jamestown",
                value: "Jamestown",
                countryId: 281
            }
        ]
    },
    {
        countryId: 282,
        code: "KN",
        label: "Saint Kitts and Nevis",
        value: "Saint Kitts and Nevis",
        states: [
            {
                stateId: 1691,
                label: "Basseterre",
                value: "Basseterre",
                countryId: 35
            }
        ]
    },
    {
        countryId: 283,
        code: "LC",
        label: "Saint Lucia",
        value: "Saint Lucia",
        states: [
            {
                stateId: 1692,
                label: "Castries",
                value: "Castries",
                countryId: 283
            }
        ]
    },
    {
        countryId: 284,
        code: "MF",
        label: "Saint Martin (French part)",
        value: "Saint Martin (French part)",
        states: [
            {
                stateId: 1693,
                label: "Marigot",
                value: "Marigot",
                countryId: 284
            }
        ]
    },
    {
        countryId: 72,
        code: "PM",
        label: "Saint Pierre And Miquelon",
        value: "Saint Pierre And Miquelon",
        states: [
            {
                stateId: 780,
                label: "Miquelon-Langlade",
                value: "Miquelon-Langlade",
                countryId: 72
            },
            {
                stateId: 1098,
                label: "Saint-Pierre",
                value: "Saint-Pierre",
                countryId: 72
            }
        ]
    },
    {
        countryId: 286,
        code: "VC",
        label: "Saint Vincent and the Grenadines",
        value: "Saint Vincent and the Grenadines",
        states: [
            {
                stateId: 1694,
                label: "Kingstown",
                value: "Kingstown",
                countryId: 286
            }
        ]
    },
    {
        countryId: 287,
        code: "WS",
        label: "Samoa",
        value: "Samoa",
        states: [
            {
                stateId: 1695,
                label: "Apia",
                value: "Apia",
                countryId: 287
            }
        ]
    },
    {
        countryId: 73,
        code: "SM",
        label: "San Marino",
        value: "San Marino",
        states: [
            {
                stateId: 1696,
                label: "San Marino",
                value: "San Marino",
                countryId: 73
            }
        ]
    },
    {
        countryId: 289,
        code: "ST",
        label: "Sao Tome and Principe",
        value: "Sao Tome and Principe",
        states: [
            {
                stateId: 1697,
                label: "São Tomé",
                value: "São Tomé",
                countryId: 289
            }
        ]
    },
    {
        countryId: 290,
        code: "SA",
        label: "Saudi Arabia",
        value: "Saudi Arabia",
        states: [
            {
                stateId: 1698,
                label: "Riyadh",
                value: "Riyadh",
                countryId: 290
            }
        ]
    },
    {
        countryId: 291,
        code: "SN",
        label: "Senegal",
        value: "Senegal",
        states: [
            {
                stateId: 1699,
                label: "Dakar",
                value: "Dakar",
                countryId: 291
            }
        ]
    },
    {
        countryId: 292,
        code: "RS",
        label: "Serbia",
        value: "Serbia",
        states: [
            {
                stateId: 1700,
                label: "Belgrade",
                value: "Belgrade",
                countryId: 292
            }
        ]
    },
    {
        countryId: 293,
        code: "SC",
        label: "Seychelles",
        value: "Seychelles",
        states: [
            {
                stateId: 1701,
                label: "Victoria",
                value: "Victoria",
                countryId: 293
            }
        ]
    },
    {
        countryId: 294,
        code: "SL",
        label: "Sierra Leone",
        value: "Sierra Leone",
        states: [
            {
                stateId: 1702,
                label: "Freetown",
                value: "Freetown",
                countryId: 294
            }
        ]
    },
    {
        countryId: 74,
        code: "SG",
        label: "Singapore",
        value: "Singapore",
        states: [
            {
                stateId: 1703,
                label: "Singapore",
                value: "Singapore",
                countryId: 74
            }
        ]
    },
    {
        countryId: 296,
        code: "SX",
        label: "Sint Maarten (Dutch part)",
        value: "Sint Maarten (Dutch part)",
        states: [
            {
                stateId: 1704,
                label: "Philipsburg",
                value: "Philipsburg",
                countryId: 296
            }
        ]
    },
    {
        countryId: 75,
        code: "SK",
        label: "Slovakia",
        value: "Slovakia",
        states: [
            {
                stateId: 113,
                label: "Banskobystrický kraj",
                value: "Banskobystrický kraj",
                countryId: 75
            },
            {
                stateId: 165,
                label: "Bratislavský kraj",
                value: "Bratislavský kraj",
                countryId: 75
            },
            {
                stateId: 632,
                label: "Košický kraj",
                value: "Košický kraj",
                countryId: 75
            },
            {
                stateId: 851,
                label: "Nitriansky kraj",
                value: "Nitriansky kraj",
                countryId: 75
            },
            {
                stateId: 975,
                label: "Prešovský kraj",
                value: "Prešovský kraj",
                countryId: 75
            },
            {
                stateId: 1293,
                label: "Trenčiansky kraj",
                value: "Trenčiansky kraj",
                countryId: 75
            },
            {
                stateId: 1298,
                label: "Trnavský kraj",
                value: "Trnavský kraj",
                countryId: 75
            },
            {
                stateId: 1427,
                label: "Žilinský kraj",
                value: "Žilinský kraj",
                countryId: 75
            }
        ]
    },
    {
        countryId: 76,
        code: "SI",
        label: "Slovenia",
        value: "Slovenia",
        states: [
            {
                stateId: 1705,
                label: "Ljubljana",
                value: "Ljubljana",
                countryId: 76
            }
        ]
    },
    {
        countryId: 299,
        code: "SB",
        label: "Solomon Islands",
        value: "Solomon Islands",
        states: [
            {
                stateId: 1706,
                label: "Honiara",
                value: "Honiara",
                countryId: 299
            }
        ]
    },
    {
        countryId: 300,
        code: "SO",
        label: "Somalia",
        value: "Somalia",
        states: [
            {
                stateId: 1707,
                label: "Mogadishu",
                value: "Mogadishu",
                countryId: 300
            }
        ]
    },
    {
        countryId: 77,
        code: "ZA",
        label: "South Africa",
        value: "South Africa",
        states: [
            {
                stateId: 1708,
                label: "Pretoria",
                value: "Pretoria",
                countryId: 77
            }
        ]
    },
    {
        countryId: 302,
        code: "GS",
        label: "South Georgia and the South Sandwich Islands",
        value: "South Georgia and the South Sandwich Islands",
        states: [
            {
                stateId: 1709,
                label: "King Edward Point",
                value: "King Edward Point",
                countryId: 302
            }
        ]
    },
    {
        countryId: 78,
        code: "KR",
        label: "South Korea",
        value: "South Korea",
        states: [
            {
                stateId: 1547,
                label: "강원도",
                value: "강원도",
                countryId: 78
            },
            {
                stateId: 1548,
                label: "경기도",
                value: "경기도",
                countryId: 78
            },
            {
                stateId: 1549,
                label: "경상남도",
                value: "경상남도",
                countryId: 78
            },
            {
                stateId: 1550,
                label: "경상북도",
                value: "경상북도",
                countryId: 78
            },
            {
                stateId: 1551,
                label: "광주광역시",
                value: "광주광역시",
                countryId: 78
            },
            {
                stateId: 1552,
                label: "대구광역시",
                value: "대구광역시",
                countryId: 78
            },
            {
                stateId: 1553,
                label: "대전광역시",
                value: "대전광역시",
                countryId: 78
            },
            {
                stateId: 1554,
                label: "부산광역시",
                value: "부산광역시",
                countryId: 78
            },
            {
                stateId: 1555,
                label: "서울특별시",
                value: "서울특별시",
                countryId: 78
            },
            {
                stateId: 1556,
                label: "세종특별자치시",
                value: "세종특별자치시",
                countryId: 78
            },
            {
                stateId: 1557,
                label: "울산광역시",
                value: "울산광역시",
                countryId: 78
            },
            {
                stateId: 1558,
                label: "인천광역시",
                value: "인천광역시",
                countryId: 78
            },
            {
                stateId: 1559,
                label: "전라남도",
                value: "전라남도",
                countryId: 78
            },
            {
                stateId: 1560,
                label: "전라북도",
                value: "전라북도",
                countryId: 78
            },
            {
                stateId: 1561,
                label: "제주특별자치도",
                value: "제주특별자치도",
                countryId: 78
            },
            {
                stateId: 1562,
                label: "충청남도",
                value: "충청남도",
                countryId: 78
            },
            {
                stateId: 1563,
                label: "충청북도",
                value: "충청북도",
                countryId: 78
            }
        ]
    },
    {
        countryId: 304,
        code: "SS",
        label: "South Sudan",
        value: "South Sudan",
        states: [
            {
                stateId: 1710,
                label: "Juba",
                value: "Juba",
                countryId: 304
            }
        ]
    },
    {
        countryId: 79,
        code: "ES",
        label: "Spain",
        value: "Spain",
        states: [
            {
                stateId: 53,
                label: "Andalucia",
                value: "Andalucia",
                countryId: 79
            },
            {
                stateId: 66,
                label: "Aragon",
                value: "Aragon",
                countryId: 79
            },
            {
                stateId: 81,
                label: "Asturias",
                value: "Asturias",
                countryId: 79
            },
            {
                stateId: 102,
                label: "Baleares",
                value: "Baleares",
                countryId: 79
            },
            {
                stateId: 198,
                label: "Canarias",
                value: "Canarias",
                countryId: 79
            },
            {
                stateId: 203,
                label: "Cantabria",
                value: "Cantabria",
                countryId: 79
            },
            {
                stateId: 219,
                label: "Castilla - La Mancha",
                value: "Castilla - La Mancha",
                countryId: 79
            },
            {
                stateId: 220,
                label: "Castilla - Leon",
                value: "Castilla - Leon",
                countryId: 79
            },
            {
                stateId: 221,
                label: "Cataluna",
                value: "Cataluna",
                countryId: 79
            },
            {
                stateId: 238,
                label: "Ceuta",
                value: "Ceuta",
                countryId: 79
            },
            {
                stateId: 280,
                label: "Comunidad Valenciana",
                value: "Comunidad Valenciana",
                countryId: 79
            },
            {
                stateId: 381,
                label: "Extremadura",
                value: "Extremadura",
                countryId: 79
            },
            {
                stateId: 402,
                label: "Galicia",
                value: "Galicia",
                countryId: 79
            },
            {
                stateId: 667,
                label: "La Rioja",
                value: "La Rioja",
                countryId: 79
            },
            {
                stateId: 719,
                label: "Madrid",
                value: "Madrid",
                countryId: 79
            },
            {
                stateId: 763,
                label: "Melilla",
                value: "Melilla",
                countryId: 79
            },
            {
                stateId: 803,
                label: "Murcia",
                value: "Murcia",
                countryId: 79
            },
            {
                stateId: 826,
                label: "Navarra",
                value: "Navarra",
                countryId: 79
            },
            {
                stateId: 923,
                label: "Pais Vasco",
                value: "Pais Vasco",
                countryId: 79
            }
        ]
    },
    {
        countryId: 80,
        code: "LK",
        label: "Sri Lanka",
        value: "Sri Lanka",
        states: [
            {
                stateId: 231,
                label: "Central Province",
                value: "Central Province",
                countryId: 80
            },
            {
                stateId: 358,
                label: "Eastern Province",
                value: "Eastern Province",
                countryId: 80
            },
            {
                stateId: 865,
                label: "North Central Province",
                value: "North Central Province",
                countryId: 80
            },
            {
                stateId: 869,
                label: "North Western Province",
                value: "North Western Province",
                countryId: 80
            },
            {
                stateId: 871,
                label: "Northern Province",
                value: "Northern Province",
                countryId: 80
            },
            {
                stateId: 982,
                label: "Province of Uva",
                value: "Province of Uva",
                countryId: 80
            },
            {
                stateId: 1081,
                label: "Sabaragamuwa Province",
                value: "Sabaragamuwa Province",
                countryId: 80
            },
            {
                stateId: 1200,
                label: "Southern Province",
                value: "Southern Province",
                countryId: 80
            },
            {
                stateId: 1395,
                label: "Western Province",
                value: "Western Province",
                countryId: 80
            }
        ]
    },
    {
        countryId: 307,
        code: "SD",
        label: "Sudan",
        value: "Sudan",
        states: [
            {
                stateId: 1711,
                label: "Khartoum",
                value: "Khartoum",
                countryId: 35
            }
        ]
    },
    {
        countryId: 308,
        code: "SR",
        label: "Suriname",
        value: "Suriname",
        states: [
            {
                stateId: 1712,
                label: "Paramaribo",
                value: "Paramaribo",
                countryId: 309
            }
        ]
    },
    {
        countryId: 81,
        code: "SJ",
        label: "Svalbard And Jan Mayen",
        value: "Svalbard And Jan Mayen",
        states: [
            {
                stateId: 543,
                label: "Jan Mayen",
                value: "Jan Mayen",
                countryId: 81
            },
            {
                stateId: 1226,
                label: "Svalbard",
                value: "Svalbard",
                countryId: 81
            }
        ]
    },
    {
        countryId: 310,
        code: "SZ",
        label: "Swaziland",
        value: "Swaziland",
        states: [
            {
                stateId: 1713,
                label: "Mbabana",
                value: "Mbabana",
                countryId: 310
            }
        ]
    },
    {
        countryId: 82,
        code: "SE",
        label: "Sweden",
        value: "Sweden",
        states: [
            {
                stateId: 146,
                label: "Blekinge",
                value: "Blekinge",
                countryId: 82
            },
            {
                stateId: 301,
                label: "Dalarna",
                value: "Dalarna",
                countryId: 82
            },
            {
                stateId: 405,
                label: "Gävleborg",
                value: "Gävleborg",
                countryId: 82
            },
            {
                stateId: 421,
                label: "Gotland",
                value: "Gotland",
                countryId: 82
            },
            {
                stateId: 458,
                label: "Halland",
                value: "Halland",
                countryId: 82
            },
            {
                stateId: 542,
                label: "Jämtland",
                value: "Jämtland",
                countryId: 82
            },
            {
                stateId: 558,
                label: "Jönköping",
                value: "Jönköping",
                countryId: 82
            },
            {
                stateId: 568,
                label: "Kalmar",
                value: "Kalmar",
                countryId: 82
            },
            {
                stateId: 640,
                label: "Kronoberg",
                value: "Kronoberg",
                countryId: 82
            },
            {
                stateId: 862,
                label: "Norrbotten",
                value: "Norrbotten",
                countryId: 82
            },
            {
                stateId: 904,
                label: "Örebro",
                value: "Örebro",
                countryId: 82
            },
            {
                stateId: 912,
                label: "Östergötland",
                value: "Östergötland",
                countryId: 82
            },
            {
                stateId: 1177,
                label: "Skåne",
                value: "Skåne",
                countryId: 82
            },
            {
                stateId: 1184,
                label: "Södermanland",
                value: "Södermanland",
                countryId: 82
            },
            {
                stateId: 1212,
                label: "Stockholm",
                value: "Stockholm",
                countryId: 82
            },
            {
                stateId: 1314,
                label: "Uppsala",
                value: "Uppsala",
                countryId: 82
            },
            {
                stateId: 1337,
                label: "Värmland",
                value: "Värmland",
                countryId: 82
            },
            {
                stateId: 1340,
                label: "Västerbotten",
                value: "Västerbotten",
                countryId: 82
            },
            {
                stateId: 1341,
                label: "Västernorrland",
                value: "Västernorrland",
                countryId: 82
            },
            {
                stateId: 1342,
                label: "Västmanland",
                value: "Västmanland",
                countryId: 82
            },
            {
                stateId: 1343,
                label: "Västra Götaland",
                value: "Västra Götaland",
                countryId: 82
            }
        ]
    },
    {
        countryId: 83,
        code: "CH",
        label: "Switzerland",
        value: "Switzerland",
        states: [
            {
                stateId: 206,
                label: "Canton de Berne",
                value: "Canton de Berne",
                countryId: 83
            },
            {
                stateId: 207,
                label: "Canton de Fribourg",
                value: "Canton de Fribourg",
                countryId: 83
            },
            {
                stateId: 208,
                label: "Canton de Vaud",
                value: "Canton de Vaud",
                countryId: 83
            },
            {
                stateId: 209,
                label: "Canton du Valais",
                value: "Canton du Valais",
                countryId: 83
            },
            {
                stateId: 408,
                label: "Genève",
                value: "Genève",
                countryId: 83
            },
            {
                stateId: 562,
                label: "Jura",
                value: "Jura",
                countryId: 83
            },
            {
                stateId: 576,
                label: "Kanton Aargau",
                value: "Kanton Aargau",
                countryId: 83
            },
            {
                stateId: 577,
                label: "Kanton Appenzell Ausserrhoden",
                value: "Kanton Appenzell Ausserrhoden",
                countryId: 83
            },
            {
                stateId: 578,
                label: "Kanton Appenzell Innerrhoden",
                value: "Kanton Appenzell Innerrhoden",
                countryId: 83
            },
            {
                stateId: 579,
                label: "Kanton Basel-Landschaft",
                value: "Kanton Basel-Landschaft",
                countryId: 83
            },
            {
                stateId: 580,
                label: "Kanton Basel-Stadt",
                value: "Kanton Basel-Stadt",
                countryId: 83
            },
            {
                stateId: 581,
                label: "Kanton Glarus",
                value: "Kanton Glarus",
                countryId: 83
            },
            {
                stateId: 582,
                label: "Kanton Graubünden",
                value: "Kanton Graubünden",
                countryId: 83
            },
            {
                stateId: 583,
                label: "Kanton Luzern",
                value: "Kanton Luzern",
                countryId: 83
            },
            {
                stateId: 584,
                label: "Kanton Nidwalden",
                value: "Kanton Nidwalden",
                countryId: 83
            },
            {
                stateId: 585,
                label: "Kanton Obwalden",
                value: "Kanton Obwalden",
                countryId: 83
            },
            {
                stateId: 586,
                label: "Kanton Schaffhausen",
                value: "Kanton Schaffhausen",
                countryId: 83
            },
            {
                stateId: 587,
                label: "Kanton Schwyz",
                value: "Kanton Schwyz",
                countryId: 83
            },
            {
                stateId: 588,
                label: "Kanton Solothurn",
                value: "Kanton Solothurn",
                countryId: 83
            },
            {
                stateId: 589,
                label: "Kanton St. Gallen",
                value: "Kanton St. Gallen",
                countryId: 83
            },
            {
                stateId: 590,
                label: "Kanton Thurgau",
                value: "Kanton Thurgau",
                countryId: 83
            },
            {
                stateId: 591,
                label: "Kanton Uri",
                value: "Kanton Uri",
                countryId: 83
            },
            {
                stateId: 592,
                label: "Kanton Zug",
                value: "Kanton Zug",
                countryId: 83
            },
            {
                stateId: 593,
                label: "Kanton Zürich",
                value: "Kanton Zürich",
                countryId: 83
            },
            {
                stateId: 834,
                label: "Neuchâtel",
                value: "Neuchâtel",
                countryId: 83
            },
            {
                stateId: 1264,
                label: "Ticino",
                value: "Ticino",
                countryId: 83
            }
        ]
    },
    {
        countryId: 313,
        code: "SY",
        label: "Syrian Arab Republic",
        value: "Syrian Arab Republic",
        states: [
            {
                stateId: 1714,
                label: "Damascus",
                value: "Damascus",
                countryId: 313
            }
        ]
    },
    {
        countryId: 314,
        code: "TW",
        label: "Taiwan",
        value: "Taiwan",
        states: [
            {
                stateId: 1715,
                label: "Taipei",
                value: "Taipei",
                countryId: 314
            }
        ]
    },
    {
        countryId: 315,
        code: "TJ",
        label: "Tajikistan",
        value: "Tajikistan",
        states: [
            {
                stateId: 1716,
                label: "Dushanbe",
                value: "Dushanbe",
                countryId: 315
            }
        ]
    },
    {
        countryId: 316,
        code: "TZ",
        label: "Tanzania, United Republic of",
        value: "Tanzania, United Republic of",
        states: [
            {
                stateId: 1717,
                label: "Dodoma",
                value: "Dodoma",
                countryId: 316
            }
        ]
    },
    {
        countryId: 84,
        code: "TH",
        label: "Thailand",
        value: "Thailand",
        states: [
            {
                stateId: 51,
                label: "Amnat Charoen",
                value: "Amnat Charoen",
                countryId: 84
            },
            {
                stateId: 58,
                label: "Ang Thong",
                value: "Ang Thong",
                countryId: 84
            },
            {
                stateId: 112,
                label: "Bangkok",
                value: "Bangkok",
                countryId: 84
            },
            {
                stateId: 179,
                label: "Buri Ram",
                value: "Buri Ram",
                countryId: 84
            },
            {
                stateId: 239,
                label: "Chachoengsao",
                value: "Chachoengsao",
                countryId: 84
            },
            {
                stateId: 241,
                label: "Chai Nat",
                value: "Chai Nat",
                countryId: 84
            },
            {
                stateId: 242,
                label: "Chaiyaphum",
                value: "Chaiyaphum",
                countryId: 84
            },
            {
                stateId: 244,
                label: "Chanthaburi",
                value: "Chanthaburi",
                countryId: 84
            },
            {
                stateId: 249,
                label: "Chiang Mai",
                value: "Chiang Mai",
                countryId: 84
            },
            {
                stateId: 250,
                label: "Chiang Rai",
                value: "Chiang Rai",
                countryId: 84
            },
            {
                stateId: 259,
                label: "Chon Buri",
                value: "Chon Buri",
                countryId: 84
            },
            {
                stateId: 261,
                label: "Chumphon",
                value: "Chumphon",
                countryId: 84
            },
            {
                stateId: 567,
                label: "Kalasin",
                value: "Kalasin",
                countryId: 84
            },
            {
                stateId: 569,
                label: "Kamphaeng Phet",
                value: "Kamphaeng Phet",
                countryId: 84
            },
            {
                stateId: 571,
                label: "Kanchanaburi",
                value: "Kanchanaburi",
                countryId: 84
            },
            {
                stateId: 615,
                label: "Khon Kaen",
                value: "Khon Kaen",
                countryId: 84
            },
            {
                stateId: 634,
                label: "Krabi",
                value: "Krabi",
                countryId: 84
            },
            {
                stateId: 675,
                label: "Lampang",
                value: "Lampang",
                countryId: 84
            },
            {
                stateId: 676,
                label: "Lamphun",
                value: "Lamphun",
                countryId: 84
            },
            {
                stateId: 698,
                label: "Loei",
                value: "Loei",
                countryId: 84
            },
            {
                stateId: 701,
                label: "Lopburi",
                value: "Lopburi",
                countryId: 84
            },
            {
                stateId: 720,
                label: "Mae Hong Son",
                value: "Mae Hong Son",
                countryId: 84
            },
            {
                stateId: 722,
                label: "Maha Sarakham",
                value: "Maha Sarakham",
                countryId: 84
            },
            {
                stateId: 800,
                label: "Mukdahan",
                value: "Mukdahan",
                countryId: 84
            },
            {
                stateId: 814,
                label: "Nakhon Nayok",
                value: "Nakhon Nayok",
                countryId: 84
            },
            {
                stateId: 815,
                label: "Nakhon Pathom",
                value: "Nakhon Pathom",
                countryId: 84
            },
            {
                stateId: 816,
                label: "Nakhon Phanom",
                value: "Nakhon Phanom",
                countryId: 84
            },
            {
                stateId: 817,
                label: "Nakhon Ratchasima",
                value: "Nakhon Ratchasima",
                countryId: 84
            },
            {
                stateId: 818,
                label: "Nakhon Sawan",
                value: "Nakhon Sawan",
                countryId: 84
            },
            {
                stateId: 819,
                label: "Nakhon Si Thammarat",
                value: "Nakhon Si Thammarat",
                countryId: 84
            },
            {
                stateId: 820,
                label: "Nan",
                value: "Nan",
                countryId: 84
            },
            {
                stateId: 823,
                label: "Narathiwat",
                value: "Narathiwat",
                countryId: 84
            },
            {
                stateId: 853,
                label: "Nong Bua Lam Phu",
                value: "Nong Bua Lam Phu",
                countryId: 84
            },
            {
                stateId: 854,
                label: "Nong Khai",
                value: "Nong Khai",
                countryId: 84
            },
            {
                stateId: 855,
                label: "Nonthaburi",
                value: "Nonthaburi",
                countryId: 84
            },
            {
                stateId: 933,
                label: "Pathum Thani",
                value: "Pathum Thani",
                countryId: 84
            },
            {
                stateId: 935,
                label: "Pattani",
                value: "Pattani",
                countryId: 84
            },
            {
                stateId: 947,
                label: "Phang Nga",
                value: "Phang Nga",
                countryId: 84
            },
            {
                stateId: 948,
                label: "Phatthalung",
                value: "Phatthalung",
                countryId: 84
            },
            {
                stateId: 949,
                label: "Phayao",
                value: "Phayao",
                countryId: 84
            },
            {
                stateId: 950,
                label: "Phetchaburi",
                value: "Phetchaburi",
                countryId: 84
            },
            {
                stateId: 951,
                label: "Phichit",
                value: "Phichit",
                countryId: 84
            },
            {
                stateId: 952,
                label: "Phitsanulok",
                value: "Phitsanulok",
                countryId: 84
            },
            {
                stateId: 953,
                label: "Phra Nakhon Si Ayutthaya",
                value: "Phra Nakhon Si Ayutthaya",
                countryId: 84
            },
            {
                stateId: 954,
                label: "Phrae",
                value: "Phrae",
                countryId: 84
            },
            {
                stateId: 955,
                label: "Phuket",
                value: "Phuket",
                countryId: 84
            },
            {
                stateId: 971,
                label: "Prachin Buri",
                value: "Prachin Buri",
                countryId: 84
            },
            {
                stateId: 972,
                label: "Prachuap Khiri Khan",
                value: "Prachuap Khiri Khan",
                countryId: 84
            },
            {
                stateId: 1014,
                label: "Ranong",
                value: "Ranong",
                countryId: 84
            },
            {
                stateId: 1016,
                label: "Ratchaburi",
                value: "Ratchaburi",
                countryId: 84
            },
            {
                stateId: 1018,
                label: "Rayong",
                value: "Rayong",
                countryId: 84
            },
            {
                stateId: 1064,
                label: "Roi Et",
                value: "Roi Et",
                countryId: 84
            },
            {
                stateId: 1075,
                label: "Sa Kaeo",
                value: "Sa Kaeo",
                countryId: 84
            },
            {
                stateId: 1102,
                label: "Sakon Nakhon",
                value: "Sakon Nakhon",
                countryId: 84
            },
            {
                stateId: 1114,
                label: "Samut Prakan",
                value: "Samut Prakan",
                countryId: 84
            },
            {
                stateId: 1115,
                label: "Samut Sakhon",
                value: "Samut Sakhon",
                countryId: 84
            },
            {
                stateId: 1116,
                label: "Samut Songkhram",
                value: "Samut Songkhram",
                countryId: 84
            },
            {
                stateId: 1138,
                label: "Saraburi",
                value: "Saraburi",
                countryId: 84
            },
            {
                stateId: 1144,
                label: "Satun",
                value: "Satun",
                countryId: 84
            },
            {
                stateId: 1158,
                label: "Si Sa Ket",
                value: "Si Sa Ket",
                countryId: 84
            },
            {
                stateId: 1169,
                label: "Sing Buri",
                value: "Sing Buri",
                countryId: 84
            },
            {
                stateId: 1188,
                label: "Songkhla",
                value: "Songkhla",
                countryId: 84
            },
            {
                stateId: 1220,
                label: "Sukhothai",
                value: "Sukhothai",
                countryId: 84
            },
            {
                stateId: 1223,
                label: "Suphanburi",
                value: "Suphanburi",
                countryId: 84
            },
            {
                stateId: 1224,
                label: "Surat Thani",
                value: "Surat Thani",
                countryId: 84
            },
            {
                stateId: 1234,
                label: "Tak",
                value: "Tak",
                countryId: 84
            },
            {
                stateId: 1290,
                label: "Trang",
                value: "Trang",
                countryId: 84
            },
            {
                stateId: 1291,
                label: "Trat",
                value: "Trat",
                countryId: 84
            },
            {
                stateId: 1308,
                label: "Ubon Ratchathani",
                value: "Ubon Ratchathani",
                countryId: 84
            },
            {
                stateId: 1310,
                label: "Udon Thani",
                value: "Udon Thani",
                countryId: 84
            },
            {
                stateId: 1319,
                label: "Uthai Thani",
                value: "Uthai Thani",
                countryId: 84
            },
            {
                stateId: 1322,
                label: "Uttaradit",
                value: "Uttaradit",
                countryId: 84
            },
            {
                stateId: 1406,
                label: "Yala",
                value: "Yala",
                countryId: 84
            },
            {
                stateId: 1412,
                label: "Yasothon",
                value: "Yasothon",
                countryId: 84
            }
        ]
    },
    {
        countryId: 318,
        code: "TL",
        label: "Timor-Leste",
        value: "Timor-Leste",
        states: [
            {
                stateId: 1718,
                label: "Dili",
                value: "Dili",
                countryId: 318
            }
        ]
    },
    {
        countryId: 319,
        code: "TG",
        label: "Togo",
        value: "Togo",
        states: [
            {
                stateId: 1719,
                label: "Lomé",
                value: "Lomé",
                countryId: 319
            }
        ]
    },
    {
        countryId: 320,
        code: "TK",
        label: "Tokelau",
        value: "Tokelau",
        states: [
            {
                stateId: 1720,
                label: "Nukunonu",
                value: "Nukunonu",
                countryId: 320
            }
        ]
    },
    {
        countryId: 321,
        code: "TO",
        label: "Tonga",
        value: "Tonga",
        states: [
            {
                stateId: 1721,
                label: "Nuku‘alofa",
                value: "Nuku‘alofa",
                countryId: 321
            }
        ]
    },
    {
        countryId: 322,
        code: "TT",
        label: "Trinidad and Tobago",
        value: "Trinidad and Tobago",
        states: [
            {
                stateId: 1722,
                label: "Port-of-Spain",
                value: "Port-of-Spain",
                countryId: 322
            }
        ]
    },
    {
        countryId: 323,
        code: "TN",
        label: "Tunisia",
        value: "Tunisia",
        states: [
            {
                stateId: 1723,
                label: "Tunis",
                value: "Tunis",
                countryId: 323
            }
        ]
    },
    {
        countryId: 85,
        code: "TR",
        label: "Turkey",
        value: "Turkey",
        states: [
            {
                stateId: 7,
                label: "Adana",
                value: "Adana",
                countryId: 85
            },
            {
                stateId: 9,
                label: "Adiyaman",
                value: "Adiyaman",
                countryId: 85
            },
            {
                stateId: 12,
                label: "Afyonkarahisar",
                value: "Afyonkarahisar",
                countryId: 85
            },
            {
                stateId: 17,
                label: "Ağri",
                value: "Ağri",
                countryId: 85
            },
            {
                stateId: 33,
                label: "Aksaray",
                value: "Aksaray",
                countryId: 85
            },
            {
                stateId: 47,
                label: "Amasya",
                value: "Amasya",
                countryId: 85
            },
            {
                stateId: 59,
                label: "Ankara",
                value: "Ankara",
                countryId: 85
            },
            {
                stateId: 61,
                label: "Antalya",
                value: "Antalya",
                countryId: 85
            },
            {
                stateId: 69,
                label: "Ardahan",
                value: "Ardahan",
                countryId: 85
            },
            {
                stateId: 76,
                label: "Artvin",
                value: "Artvin",
                countryId: 85
            },
            {
                stateId: 90,
                label: "Aydin",
                value: "Aydin",
                countryId: 85
            },
            {
                stateId: 103,
                label: "Balikesir",
                value: "Balikesir",
                countryId: 85
            },
            {
                stateId: 118,
                label: "Bartin",
                value: "Bartin",
                countryId: 85
            },
            {
                stateId: 120,
                label: "Batman",
                value: "Batman",
                countryId: 85
            },
            {
                stateId: 125,
                label: "Bayburt",
                value: "Bayburt",
                countryId: 85
            },
            {
                stateId: 137,
                label: "Bilecik",
                value: "Bilecik",
                countryId: 85
            },
            {
                stateId: 139,
                label: "Bingöl",
                value: "Bingöl",
                countryId: 85
            },
            {
                stateId: 144,
                label: "Bitlis",
                value: "Bitlis",
                countryId: 85
            },
            {
                stateId: 150,
                label: "Bolu",
                value: "Bolu",
                countryId: 85
            },
            {
                stateId: 177,
                label: "Burdur",
                value: "Burdur",
                countryId: 85
            },
            {
                stateId: 180,
                label: "Bursa",
                value: "Bursa",
                countryId: 85
            },
            {
                stateId: 197,
                label: "Çanakkale",
                value: "Çanakkale",
                countryId: 85
            },
            {
                stateId: 201,
                label: "Çankiri",
                value: "Çankiri",
                countryId: 85
            },
            {
                stateId: 289,
                label: "Çorum",
                value: "Çorum",
                countryId: 85
            },
            {
                stateId: 309,
                label: "Denizli",
                value: "Denizli",
                countryId: 85
            },
            {
                stateId: 339,
                label: "Diyarbakir",
                value: "Diyarbakir",
                countryId: 85
            },
            {
                stateId: 356,
                label: "Düzce",
                value: "Düzce",
                countryId: 85
            },
            {
                stateId: 361,
                label: "Edirne",
                value: "Edirne",
                countryId: 85
            },
            {
                stateId: 366,
                label: "Elaziğ",
                value: "Elaziğ",
                countryId: 85
            },
            {
                stateId: 373,
                label: "Erzincan",
                value: "Erzincan",
                countryId: 85
            },
            {
                stateId: 374,
                label: "Erzurum",
                value: "Erzurum",
                countryId: 85
            },
            {
                stateId: 378,
                label: "Eskişehir",
                value: "Eskişehir",
                countryId: 85
            },
            {
                stateId: 406,
                label: "Gaziantep",
                value: "Gaziantep",
                countryId: 85
            },
            {
                stateId: 412,
                label: "Giresun",
                value: "Giresun",
                countryId: 85
            },
            {
                stateId: 448,
                label: "Gümüşhane",
                value: "Gümüşhane",
                countryId: 85
            },
            {
                stateId: 457,
                label: "Hakkari",
                value: "Hakkari",
                countryId: 85
            },
            {
                stateId: 464,
                label: "Hatay",
                value: "Hatay",
                countryId: 85
            },
            {
                stateId: 493,
                label: "Iğdir",
                value: "Iğdir",
                countryId: 85
            },
            {
                stateId: 528,
                label: "Isparta",
                value: "Isparta",
                countryId: 85
            },
            {
                stateId: 529,
                label: "İstanbul",
                value: "İstanbul",
                countryId: 85
            },
            {
                stateId: 539,
                label: "İzmir",
                value: "İzmir",
                countryId: 85
            },
            {
                stateId: 565,
                label: "Kahramanmaraş",
                value: "Kahramanmaraş",
                countryId: 85
            },
            {
                stateId: 594,
                label: "Karabük",
                value: "Karabük",
                countryId: 85
            },
            {
                stateId: 595,
                label: "Karaman",
                value: "Karaman",
                countryId: 85
            },
            {
                stateId: 600,
                label: "Kars",
                value: "Kars",
                countryId: 85
            },
            {
                stateId: 602,
                label: "Kastamonu",
                value: "Kastamonu",
                countryId: 85
            },
            {
                stateId: 604,
                label: "Kayseri",
                value: "Kayseri",
                countryId: 85
            },
            {
                stateId: 617,
                label: "Kilis",
                value: "Kilis",
                countryId: 85
            },
            {
                stateId: 618,
                label: "Kirikkale",
                value: "Kirikkale",
                countryId: 85
            },
            {
                stateId: 619,
                label: "Kirklareli",
                value: "Kirklareli",
                countryId: 85
            },
            {
                stateId: 622,
                label: "Kirşehir",
                value: "Kirşehir",
                countryId: 85
            },
            {
                stateId: 623,
                label: "Kktc",
                value: "Kktc",
                countryId: 85
            },
            {
                stateId: 625,
                label: "Kocaeli",
                value: "Kocaeli",
                countryId: 85
            },
            {
                stateId: 630,
                label: "Konya",
                value: "Konya",
                countryId: 85
            },
            {
                stateId: 647,
                label: "Kütahya",
                value: "Kütahya",
                countryId: 85
            },
            {
                stateId: 725,
                label: "Malatya",
                value: "Malatya",
                countryId: 85
            },
            {
                stateId: 732,
                label: "Manisa",
                value: "Manisa",
                countryId: 85
            },
            {
                stateId: 737,
                label: "Mardin",
                value: "Mardin",
                countryId: 85
            },
            {
                stateId: 766,
                label: "Mersin(İçel)",
                value: "Mersin(İçel)",
                countryId: 85
            },
            {
                stateId: 799,
                label: "Muğla",
                value: "Muğla",
                countryId: 85
            },
            {
                stateId: 805,
                label: "Muş",
                value: "Muş",
                countryId: 85
            },
            {
                stateId: 837,
                label: "Nevşehir",
                value: "Nevşehir",
                countryId: 85
            },
            {
                stateId: 848,
                label: "Niğde",
                value: "Niğde",
                countryId: 85
            },
            {
                stateId: 903,
                label: "Ordu",
                value: "Ordu",
                countryId: 85
            },
            {
                stateId: 911,
                label: "Osmaniye",
                value: "Osmaniye",
                countryId: 85
            },
            {
                stateId: 1061,
                label: "Rize",
                value: "Rize",
                countryId: 85
            },
            {
                stateId: 1101,
                label: "Sakarya",
                value: "Sakarya",
                countryId: 85
            },
            {
                stateId: 1113,
                label: "Samsun",
                value: "Samsun",
                countryId: 85
            },
            {
                stateId: 1127,
                label: "Şanliurfa",
                value: "Şanliurfa",
                countryId: 85
            },
            {
                stateId: 1165,
                label: "Siirt",
                value: "Siirt",
                countryId: 85
            },
            {
                stateId: 1171,
                label: "Sinop",
                value: "Sinop",
                countryId: 85
            },
            {
                stateId: 1172,
                label: "Şirnak",
                value: "Şirnak",
                countryId: 85
            },
            {
                stateId: 1175,
                label: "Sivas",
                value: "Sivas",
                countryId: 85
            },
            {
                stateId: 1251,
                label: "Tekirdağ",
                value: "Tekirdağ",
                countryId: 85
            },
            {
                stateId: 1280,
                label: "Tokat",
                value: "Tokat",
                countryId: 85
            },
            {
                stateId: 1289,
                label: "Trabzon",
                value: "Trabzon",
                countryId: 85
            },
            {
                stateId: 1306,
                label: "Tunceli",
                value: "Tunceli",
                countryId: 85
            },
            {
                stateId: 1315,
                label: "Uşak",
                value: "Uşak",
                countryId: 85
            },
            {
                stateId: 1333,
                label: "Van",
                value: "Van",
                countryId: 85
            },
            {
                stateId: 1407,
                label: "Yalova",
                value: "Yalova",
                countryId: 85
            },
            {
                stateId: 1415,
                label: "Yozgat",
                value: "Yozgat",
                countryId: 85
            },
            {
                stateId: 1430,
                label: "Zonguldak",
                value: "Zonguldak",
                countryId: 85
            }
        ]
    },
    {
        countryId: 325,
        code: "TM",
        label: "Turkmenistan",
        value: "Turkmenistan",
        states: [
            {
                stateId: 1724,
                label: "Ashgabat",
                value: "Ashgabat",
                countryId: 325
            }
        ]
    },
    {
        countryId: 326,
        code: "TC",
        label: "Turks and Caicos Islands",
        value: "Turks and Caicos Islands",
        states: [
            {
                stateId: 1725,
                label: "Cockburn Town",
                value: "Cockburn Town",
                countryId: 326
            }
        ]
    },
    {
        countryId: 327,
        code: "TV",
        label: "Tuvalu",
        value: "Tuvalu",
        states: [
            {
                stateId: 1726,
                label: "Funafuti",
                value: "Funafuti",
                countryId: 327
            }
        ]
    },
    {
        countryId: 86,
        code: "VI",
        label: "U.S. Virgin Islands",
        value: "U.S. Virgin Islands",
        states: [
            {
                stateId: 1356,
                label: "Vi",
                value: "Vi",
                countryId: 86
            }
        ]
    },
    {
        countryId: 328,
        code: "UG",
        label: "Uganda",
        value: "Uganda",
        states: [
            {
                stateId: 1727,
                label: "Kampala",
                value: "Kampala",
                countryId: 328
            }
        ]
    },
    {
        countryId: 87,
        code: "UA",
        label: "Ukraine",
        value: "Ukraine",
        states: [
            {
                stateId: 246,
                label: "Cherkaska",
                value: "Cherkaska",
                countryId: 87
            },
            {
                stateId: 247,
                label: "Chernihivska",
                value: "Chernihivska",
                countryId: 87
            },
            {
                stateId: 248,
                label: "Chernivetska",
                value: "Chernivetska",
                countryId: 87
            },
            {
                stateId: 341,
                label: "Dnipropetrovska",
                value: "Dnipropetrovska",
                countryId: 87
            },
            {
                stateId: 345,
                label: "Donetska",
                value: "Donetska",
                countryId: 87
            },
            {
                stateId: 531,
                label: "Ivano-Frankivska",
                value: "Ivano-Frankivska",
                countryId: 87
            },
            {
                stateId: 611,
                label: "Kharkivska",
                value: "Kharkivska",
                countryId: 87
            },
            {
                stateId: 613,
                label: "Khersonska",
                value: "Khersonska",
                countryId: 87
            },
            {
                stateId: 614,
                label: "Khmelnytska",
                value: "Khmelnytska",
                countryId: 87
            },
            {
                stateId: 621,
                label: "Kirovohradska",
                value: "Kirovohradska",
                countryId: 87
            },
            {
                stateId: 648,
                label: "Kyiv",
                value: "Kyiv",
                countryId: 87
            },
            {
                stateId: 649,
                label: "Kyivska",
                value: "Kyivska",
                countryId: 87
            },
            {
                stateId: 708,
                label: "Luhanska",
                value: "Luhanska",
                countryId: 87
            },
            {
                stateId: 712,
                label: "Lvivska",
                value: "Lvivska",
                countryId: 87
            },
            {
                stateId: 806,
                label: "Mykolaivska",
                value: "Mykolaivska",
                countryId: 87
            },
            {
                stateId: 886,
                label: "Odeska",
                value: "Odeska",
                countryId: 87
            },
            {
                stateId: 963,
                label: "Poltavska",
                value: "Poltavska",
                countryId: 87
            },
            {
                stateId: 1060,
                label: "Rivnenska",
                value: "Rivnenska",
                countryId: 87
            },
            {
                stateId: 1222,
                label: "Sumska",
                value: "Sumska",
                countryId: 87
            },
            {
                stateId: 1259,
                label: "Ternopilska",
                value: "Ternopilska",
                countryId: 87
            },
            {
                stateId: 1370,
                label: "Vinnytska",
                value: "Vinnytska",
                countryId: 87
            },
            {
                stateId: 1377,
                label: "Volynska",
                value: "Volynska",
                countryId: 87
            },
            {
                stateId: 1421,
                label: "Zakarpatska",
                value: "Zakarpatska",
                countryId: 87
            },
            {
                stateId: 1423,
                label: "Zaporizka",
                value: "Zaporizka",
                countryId: 87
            },
            {
                stateId: 1426,
                label: "Zhytomyrska",
                value: "Zhytomyrska",
                countryId: 87
            }
        ]
    },
    {
        countryId: 330,
        code: "AE",
        label: "United Arab Emirates",
        value: "United Arab Emirates",
        states: [
            {
                stateId: 1728,
                label: "Abu Dhabi",
                value: "Abu Dhabi",
                countryId: 330
            }
        ]
    },
    {
        countryId: 88,
        code: "GB",
        label: "United Kingdom",
        value: "United Kingdom",
        states: [
            {
                stateId: 369,
                label: "England",
                value: "England",
                countryId: 88
            },
            {
                stateId: 870,
                label: "Northern Ireland",
                value: "Northern Ireland",
                countryId: 88
            },
            {
                stateId: 1149,
                label: "Scotland",
                value: "Scotland",
                countryId: 88
            },
            {
                stateId: 1384,
                label: "Wales",
                value: "Wales",
                countryId: 88
            }
        ]
    },
    {
        countryId: 126,
        code: "UM",
        label: "United States Minor Outlying Islands",
        value: "United States Minor Outlying Islands",
        states: []
    },
    {
        countryId: 90,
        code: "UY",
        label: "Uruguay",
        value: "Uruguay",
        states: [
            {
                stateId: 75,
                label: "Artigas",
                value: "Artigas",
                countryId: 90
            },
            {
                stateId: 199,
                label: "Canelones",
                value: "Canelones",
                countryId: 90
            },
            {
                stateId: 234,
                label: "Cerro Largo",
                value: "Cerro Largo",
                countryId: 90
            },
            {
                stateId: 276,
                label: "Colonia",
                value: "Colonia",
                countryId: 90
            },
            {
                stateId: 354,
                label: "Durazno",
                value: "Durazno",
                countryId: 90
            },
            {
                stateId: 389,
                label: "Flores",
                value: "Flores",
                countryId: 90
            },
            {
                stateId: 393,
                label: "Florida",
                value: "Florida",
                countryId: 90
            },
            {
                stateId: 681,
                label: "Lavalleja",
                value: "Lavalleja",
                countryId: 90
            },
            {
                stateId: 726,
                label: "Maldonado",
                value: "Maldonado",
                countryId: 90
            },
            {
                stateId: 793,
                label: "Montevideo",
                value: "Montevideo",
                countryId: 90
            },
            {
                stateId: 938,
                label: "Paysandu",
                value: "Paysandu",
                countryId: 90
            },
            {
                stateId: 1056,
                label: "Rio Negro",
                value: "Rio Negro",
                countryId: 90
            },
            {
                stateId: 1059,
                label: "Rivera",
                value: "Rivera",
                countryId: 90
            },
            {
                stateId: 1062,
                label: "Rocha",
                value: "Rocha",
                countryId: 90
            },
            {
                stateId: 1109,
                label: "Salto",
                value: "Salto",
                countryId: 90
            },
            {
                stateId: 1119,
                label: "San Jose",
                value: "San Jose",
                countryId: 90
            },
            {
                stateId: 1190,
                label: "Soriano",
                value: "Soriano",
                countryId: 90
            },
            {
                stateId: 1233,
                label: "Tacuarembo",
                value: "Tacuarembo",
                countryId: 90
            },
            {
                stateId: 1292,
                label: "Treinta y Tres",
                value: "Treinta y Tres",
                countryId: 90
            }
        ]
    },
    {
        countryId: 334,
        code: "UZ",
        label: "Uzbekistan",
        value: "Uzbekistan",
        states: [
            {
                stateId: 1729,
                label: "Tashkent",
                value: "Tashkent",
                countryId: 334
            }
        ]
    },
    {
        countryId: 335,
        code: "VU",
        label: "Vanuatu",
        value: "Vanuatu",
        states: [
            {
                stateId: 1730,
                label: "Port-Vila",
                value: "Port-Vila",
                countryId: 335
            }
        ]
    },
    {
        countryId: 91,
        code: "VA",
        label: "Vatican City",
        value: "Vatican City",
        states: [
            {
                stateId: 1731,
                label: "Vatican City",
                value: "Vatican City",
                countryId: 91
            }
        ]
    },
    {
        countryId: 336,
        code: "VE",
        label: "Venezuela (Bolivarian Republic of)",
        value: "Venezuela (Bolivarian Republic of)",
        states: [
            {
                stateId: 1732,
                label: "Caracas",
                value: "Caracas",
                countryId: 336
            }
        ]
    },
    {
        countryId: 337,
        code: "VN",
        label: "Viet Nam",
        value: "Viet Nam",
        states: [
            {
                stateId: 1733,
                label: "Hanoi",
                value: "Hanoi",
                countryId: 337
            }
        ]
    },
    {
        countryId: 127,
        code: "VG",
        label: "Virgin Islands (British)",
        value: "Virgin Islands (British)",
        states: [
            {
                stateId: 1734,
                label: "Road Town",
                value: "Road Town",
                countryId: 127
            }
        ]
    },
    {
        countryId: 92,
        code: "WF",
        label: "Wallis And Futuna",
        value: "Wallis And Futuna",
        states: [
            {
                stateId: 266,
                label: "Circonscription d'Alo",
                value: "Circonscription d'Alo",
                countryId: 92
            },
            {
                stateId: 267,
                label: "Circonscription d'Uvéa",
                value: "Circonscription d'Uvéa",
                countryId: 92
            },
            {
                stateId: 268,
                label: "Circonscription de Sigave",
                value: "Circonscription de Sigave",
                countryId: 92
            }
        ]
    },
    {
        countryId: 339,
        code: "EH",
        label: "Western Sahara",
        value: "Western Sahara",
        states: [
            {
                stateId: 1735,
                label: "El Aaiún",
                value: "El Aaiún",
                countryId: 339
            }
        ]
    },
    {
        countryId: 340,
        code: "YE",
        label: "Yemen",
        value: "Yemen",
        states: [
            {
                stateId: 1736,
                label: "Sanaa",
                value: "Sanaa",
                countryId: 340
            }
        ]
    },
    {
        countryId: 341,
        code: "ZM",
        label: "Zambia",
        value: "Zambia",
        states: [
            {
                stateId: 1737,
                label: "Lusaka",
                value: "Lusaka",
                countryId: 341
            }
        ]
    }
]

const options3 = [
    {label: "Yes", value: "Yes"},
    {label: "No", value: "No"}
]

const hearAboutUs = [
    {value: "youtube", label: "Youtube"},
    {value: "google", label: "Google"},
    {value: "facebook", label: "Facebook"},
    {value: "twitter", label: "Twitter"},
    {value: "instagram", label: "Instagram"},
    {value: "email", label: "Email"},
    {value: "tv", label: "TV"},
    {value: "newspaper", label: "Newspaper"},
    {value: "other", label: "Other"}
]

const mandatory = {
    presence: {allowEmpty: false}
}

const rules = {
    email: {
        email: true
    }
}

const signUpRules = {
    otp: mandatory,
    first_name: {...mandatory, length: {minimum: 1}},
    last_name: {...mandatory, length: {minimum: 1}},
    email: {
        email: true
    },
    password: {
        ...mandatory,
        length: {minimum: 3},
        format: {
            // /^(?=.*[A-Z])(?=(.*[a-z]){3,})(?=.*([!_@.]){1})(?=.*[0-9].*[0-9]).{8,}$/
            // ^password needs to have one uppercase letter three lowercase letters, one special case letter (!_@.), two digits and 8 chars at minimum.
            pattern: /^.{8,}$/,
            flags: "gm",
            message: "^password needs to have at least 8 chars at minimum."
        }
    },
    confirm_password: {
        ...mandatory,
        equality: "password"
    },
    captcha_value: mandatory
}

const nestedRules = {
    preferred_contact_time: mandatory,
    phone_number: mandatory,
    previously_applied: mandatory,
    about_us: mandatory,
    address: mandatory,
    country: mandatory,
    city: mandatory,
    state: mandatory,
    zip: mandatory
}

const customPasswordConfirmRule = {
    password: {
        ...mandatory,
        length: {minimum: 3},
        format: {
            pattern: /^.{8,}$/,
            flags: "gm",
            message: "^password needs to have at least 8 chars at minimum."
        }
    },
    confirm_password: {
        ...mandatory,
        equality: "password"
    }
}

@observer
export class SignUp extends Component<Props, {}> {
    @observable
    private errors: {[key: string]: string} = {}

    @observable
    private nestedErrors: {[key: string]: string} = {}

    @observable
    private backendErrors: string | null = ""

    @observable
    private passwordOptions: any = {
        options: CHECK_PASSWORD_OPTIONS.default
    }

    @observable
    isVisible: boolean = false

    @observable
    isVisibleOtp: boolean = false

    @observable
    private user: SignUpUser = {
        otp: "",
        first_name: "",
        middle_name: "",
        last_name: "",
        email: "",
        password: "",
        confirm_password: "",
        json_data: {
            phone_number: "",
            crm_id: "",
            rep_code: "",
            about_us: "",
            about_us_text: "",
            address: "",
            city: "",
            zip: ""
        },
        captcha_value: ""
    }

    private OTHER_CONSTANT = {
        keyOther: "about_us",
        valueOther: "Other"
    }

    private recaptchaRef: any = React.createRef()

    private get citizenshipStates(): any[] {
        return this.getStatesByCountryName(this.user.json_data["country"])
    }

    private get newCountries(): any[] {
        const allCountries = countries
        return allCountries.map((country) => ({
            ...country,
            value: `${country.countryId}${DELIMITER}${country.label}${DELIMITER}${country.value}${DELIMITER}${country.code}`
        }))
    }

    private getStatesByCountryName = (countryInfo: string) => {
        if (!countryInfo) {
            return []
        }
        const allCountries = countries
        if (allCountries) {
            const [countryId, label, value, code] = getPartsByDelimiter(countryInfo)
            const country = allCountries.filter(
                (country) => country.countryId == +countryId && country.code === code
            )[0]
            if (country) {
                return country.states
            }
            return []
        }
        return []
    }

    private onChangeCaptchaText = (id: string, value: string) => {
        this.user[id] = value
    }

    private isValidEmail = () => {
        const {isValid, errors} = findErrors(this.user, rules)
        this.errors = errors
        return isValid
    }

    private isValid = () => {
        const newRules = {
            ...rules,
            ...signUpRules
        }
        const {isValid, errors} = findErrors(this.user, newRules)

        const {isValid: nestedIsValid, errors: nestedErrors} = findErrors(
            this.user.json_data,
            nestedRules
        )
        this.errors = errors
        this.nestedErrors = nestedErrors
        const {isValid: isValidPassword} = this.passwordOptions
        this.isVisible = !isValidPassword
        // console.log("@@@@@@@ isValid SignUp:", {
        //     errors: {
        //         isValid,
        //         errors: toJS(this.errors)
        //     },
        //     nestedErrors: {
        //         nestedIsValid,
        //         errors: toJS(this.nestedErrors)
        //     },
        //     passwordError: toJS(this.passwordOptions)
        // })
        return isValid && nestedIsValid && isValidPassword
    }

    private isValidPassword = () => {
        const {isValid, options} = findPasswordErrors(this.user)
        this.passwordOptions = {
            isValid,
            options
        }
    }

    private onKeyUpPassword = (event: KeyboardEvent<Element>) => {
        this.isValidPassword()
    }

    private isValidConfirmPassword = () => {
        const {isValid, errors} = findErrors(this.user, customPasswordConfirmRule)
        this.errors = errors
    }

    private onKeyUpConfirmPassword = (event: KeyboardEvent<Element>) => {
        this.isValidConfirmPassword()
    }

    public render() {
        const user = this.user
        // const {model} = this.props
        const {
            onChangeCaptchaText,
            backendErrors,
            onKeyUpPassword,
            onKeyUpConfirmPassword,
            isVisible
        } = this
        const {valueOther} = this.OTHER_CONSTANT
        return (
            <LoginWrapper className={styles.wrapper}>
                <div className={styles.root}>
                    <header className={styles.header}>
                        <h2 className={styles.h2}>Create a New Account</h2>
                        <Link to="/sign-in" className={styles.link}>
                            Sign In
                        </Link>
                    </header>
                    <p className={styles.text}>
                        Thank you for your interest in applying to <br /> IntelliTec College.
                    </p>
                    <br />
                    <p className={styles.text}>
                        Please complete the following information and use the Sign Up button to
                        begin the application process.
                    </p>
                    <br />
                    <p className={styles.textRed}>
                        Name <u>MUST</u> be Legal Name as listed on Drivers License
                    </p>
                    <div className={styles.formArea}>
                        <Label
                            text="Email Address"
                            className={styles.inputUser}
                            error={this.errors["email"]}
                            required>
                            <Input
                                onChange={(v) => {
                                    user.email = v
                                }}
                                value={user.email}
                                type="email"
                            />
                        </Label>
                        {this.isVisibleOtp && (
                            <>
                                <Label
                                    text="One time password"
                                    additionaText="(6-Digit Code from email)"
                                    className={styles.inputUser}
                                    error={this.errors["otp"]}
                                    required>
                                    <Input
                                        onChange={(v) => {
                                            this.user.otp = v.trim()
                                        }}
                                        value={this.user.otp}
                                        type="password"
                                    />
                                </Label>

                                <LabelPassword
                                    text="Password"
                                    required
                                    className={styles.inputPass}
                                    isVisible={isVisible}
                                    minChars={8}
                                    options={this.passwordOptions.options}>
                                    <Input
                                        onChange={(v) => {
                                            user.password = v
                                        }}
                                        value={user.password}
                                        type="password"
                                        onKeyUp={onKeyUpPassword}
                                        onFocus={() => (this.isVisible = true)}
                                        onBlur={() =>
                                            (this.isVisible =
                                                this.passwordOptions.options.value !==
                                                    CHECK_PASSWORD_OPTIONS.values.strong &&
                                                this.passwordOptions.options.value !==
                                                    CHECK_PASSWORD_OPTIONS.values.medium)
                                        }
                                    />
                                </LabelPassword>

                                <Label
                                    text="Confirm Password"
                                    required
                                    className={styles.inputPass}
                                    error={this.errors["confirm_password"]}>
                                    <Input
                                        onChange={(v) => {
                                            user.confirm_password = v
                                        }}
                                        value={user.confirm_password}
                                        type="password"
                                        onKeyUp={onKeyUpConfirmPassword}
                                    />
                                </Label>

                                <Label
                                    text="First Name"
                                    required
                                    className={styles.inputPass}
                                    error={this.errors["first_name"]}>
                                    <Input
                                        onChange={(v) => {
                                            user.first_name = v
                                        }}
                                        value={user.first_name}
                                    />
                                </Label>

                                <Label text="Middle Name" className={styles.inputPass}>
                                    <Input
                                        onChange={(v) => {
                                            user.middle_name = v
                                        }}
                                        value={user.middle_name}
                                    />
                                </Label>

                                <Label
                                    text="Last Name"
                                    required
                                    className={styles.inputPass}
                                    error={this.errors["last_name"]}>
                                    <Input
                                        onChange={(v) => {
                                            user.last_name = v
                                        }}
                                        value={user.last_name}
                                    />
                                </Label>

                                <Label
                                    text="Address"
                                    required
                                    className={styles.inputPass}
                                    error={this.nestedErrors["address"]}>
                                    <Input
                                        onChange={(v) => {
                                            user.json_data.address = v
                                        }}
                                        value={user.json_data.address}
                                    />
                                </Label>

                                <Label text="Country" required error={this.nestedErrors["country"]}>
                                    <KlassDropdown
                                        onChange={(v) => {
                                            user.json_data.country = v.value
                                        }}
                                        options={this.newCountries}
                                        value={this.newCountries.find((el) => {
                                            return el.value === user.json_data.country
                                        })}
                                    />
                                </Label>

                                <Label
                                    text="City"
                                    required
                                    className={styles.inputPass}
                                    error={this.nestedErrors["city"]}>
                                    <Input
                                        onChange={(v) => {
                                            user.json_data.city = v
                                        }}
                                        value={user.json_data.city}
                                    />
                                </Label>

                                <Label text="State" required error={this.nestedErrors["country"]}>
                                    <KlassDropdown
                                        onChange={(v) => {
                                            user.json_data.state = v.value
                                        }}
                                        options={this.citizenshipStates}
                                        value={this.citizenshipStates.find((el) => {
                                            return el.value === user.json_data.state
                                        })}
                                    />
                                </Label>

                                <Label
                                    text="Zip"
                                    required
                                    className={styles.inputPass}
                                    error={this.nestedErrors["city"]}>
                                    <Input
                                        onChange={(v) => {
                                            user.json_data.zip = v
                                        }}
                                        value={user.json_data.zip}
                                    />
                                </Label>

                                <Label
                                    text="Phone Number"
                                    required
                                    className={styles.inputPass}
                                    error={this.nestedErrors["phone_number"]}>
                                    <Input
                                        onChange={(v) => {
                                            user.json_data.phone_number = v
                                        }}
                                        value={user.json_data.phone_number}
                                    />
                                </Label>

                                <Label
                                    text="Preferred Contact Time"
                                    required
                                    error={this.nestedErrors["preferred_contact_time"]}>
                                    <KlassDropdown
                                        onChange={(v) => {
                                            user.json_data.preferred_contact_time = v.value
                                        }}
                                        options={options1}
                                        value={options1.find((el) => {
                                            return (
                                                el.value === user.json_data.preferred_contact_time
                                            )
                                        })}
                                    />
                                </Label>

                                {/* <Label
                            text="How would you like to attend?"
                            required
                            error={this.nestedErrors["how_attend"]}>
                            <KlassDropdown
                                onChange={(v) => {
                                    user.json_data.how_attend = v.value
                                }}
                                options={options2}
                                value={options2.find((el) => {
                                    return el.value === user.json_data.how_attend
                                })}
                            />
                        </Label> */}

                                <Label
                                    text="How did you hear about us?"
                                    required
                                    error={this.nestedErrors["about_us"]}>
                                    <KlassDropdown
                                        onChange={(v) => {
                                            user.json_data.about_us = v.value
                                        }}
                                        options={hearAboutUs}
                                        value={hearAboutUs.find((el) => {
                                            return el.value === user.json_data.about_us
                                        })}
                                    />
                                </Label>

                                {user.json_data.about_us === valueOther && (
                                    <Label
                                        text="Describe how did you hear about us / Referal name"
                                        className={styles.inputPass}>
                                        <Input
                                            onChange={(v) => {
                                                user.json_data.about_us_text = v
                                            }}
                                            value={user.json_data.about_us_text}
                                        />
                                    </Label>
                                )}

                                <Label
                                    text="Have you previously applied to Intellitec?"
                                    required
                                    error={this.nestedErrors["previously_applied"]}>
                                    <KlassDropdown
                                        onChange={(v) => {
                                            user.json_data.previously_applied = v.value
                                        }}
                                        options={options3}
                                        value={options3.find((el) => {
                                            return el.value === user.json_data.previously_applied
                                        })}
                                    />
                                </Label>

                                <Captcha
                                    recaptchaRef={this.recaptchaRef}
                                    id={`captcha_value`}
                                    user={this.user}
                                    onChange={onChangeCaptchaText}
                                    errors={this.errors}
                                    backendErrors={backendErrors}
                                />
                            </>
                        )}
                    </div>
                    {this.isVisibleOtp && (
                        <>
                            <p className={styles.textUnderForm}>
                                Please make a note of your email address and password as they will
                                be required should you wish to make application changes in the
                                future.
                            </p>
                            <p className={styles.tcpaText}>
                                By submitting this form, you are giving your express written consent
                                for <strong>IntelliTec College</strong> to contact you regarding our
                                programs and services using email, sms, telephone or text -
                                including our use of automated technology for calls and periodic
                                texts to any wireless number you provide. Message and data rates may
                                apply. <br /> This consent is not required to purchase
                                goods/services and you may always call us directly at{" "}
                                <strong>
                                    (505) 508-5225, (719) 632-7626, (970) 245-8101 or (719) 542-3181
                                </strong>
                            </p>
                        </>
                    )}

                    <Button
                        text="SIGN UP"
                        onClick={() => {
                            if (!this.isVisibleOtp) {
                                this.sendOneTimePasswordEmailToUser()
                            } else {
                                this.signUp()
                            }
                        }}
                        className={styles.button}
                    />
                </div>
            </LoginWrapper>
        )
    }

    private async sendOneTimePasswordEmailToUser() {
        if (this.isValidEmail()) {
            const {email} = this.user
            const response = await this.props.model.sendCreateAccountOtpEmail(email)
            // alert(`${response.message}`)
            Swal.fire({
                icon: response.success ? "success" : "warning",
                text: `${response.message}`
            })
            if (response.success) {
                this.isVisibleOtp = true
            }
        }
    }

    private async signUp() {
        this.backendErrors = ""
        const CAPTCHA_WORD = "Captcha"
        if (this.recaptchaRef.current) {
            const captchaToken = await this.recaptchaRef.current.executeAsync()
            console.log("@@@ signUp captch_value", captchaToken)
            this.user.captcha_value = captchaToken
            this.recaptchaRef.current.reset()
        }
        if (this.isValid()) {
            this.user.json_data.lead_source = localStorage.getItem("lead_source")
            const response = await this.props.auth.signUp("intellitec", {...this.user})
            if (this.recaptchaRef.current) {
                this.recaptchaRef.current.reset()
                this.user.captcha_value = ""
            }
            if (!response.success) {
                const {
                    errors: [{message}]
                } = response
                if (message.includes(CAPTCHA_WORD)) {
                    this.backendErrors = message
                }
            }
        }
    }
}
